// /app/frontend/src/data/coursVoitureEleve.js
// Contenu pédagogique natif codevoiture.fr — Cours en voiture mobile élève
// Aligné Référentiel pour l'Éducation à une Mobilité Citoyenne (REMC) — 4 compétences, 38 leçons.
// Aucune marque ni entreprise citée — contenu original chartré CodeVoiture.

export const COURS_VOITURE_ELEVE = [
  {
    code: 'C1',
    title: 'Maîtriser le maniement du véhicule',
    subtitle: 'dans un trafic faible ou nul',
    color: 'red',
    intro: "Avant la route, le contrôle. C1 c'est apprendre à dialoguer avec ta voiture : la connaître, la mettre en route, doser tes appuis, regarder loin. Sans cette base, rien ne tient en circulation.",
    duree: '15 à 25 h de pratique selon profil',
    pre_requis: 'Avoir validé l\'épreuve théorique générale (ETG) ou être en cours de préparation.',
    lecons: [
      {
        i: 0,
        letter: 'a',
        titre: 'Connaître les principaux organes et commandes du véhicule, effectuer des vérifications intérieures et extérieures',
        objectif: "Identifier les commandes, voyants et fonctions essentielles du véhicule, et garantir avant chaque départ qu'il est apte à rouler en sécurité.",
        // ── Trame REMC officielle (fidèle au livret p.12-15) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à savoir situer les principaux organes, commandes du véhicule et effectuer les vérifications qui s'imposent.",
            question_avantages: "Quels sont les avantages à bien connaître les commandes de son véhicule ?",
            avantages: [
              "Rapidité d'exécution des gestes.",
              "Anticipation (le regard reste sur la route).",
              "Pas d'écarts de trajectoire dus à la recherche d'une commande.",
              "Confort de conduite.",
            ],
            question_inconvenients: "Quels sont les inconvénients à ne jamais effectuer de vérifications extérieures sur son véhicule ?",
            inconvenients: [
              "Pas d'anticipation de pannes liées à l'usure ou au manque d'entretien.",
              "Peu de prise en compte de la sécurité des autres.",
              "Coût financier plus important que l'entretien régulier.",
            ],
          },
          comment: {
            a_traiter: "Présentation du véhicule, vérifications intérieures/extérieures.",
            question_freq_int: "À quelle fréquence estimez-vous devoir effectuer les vérifications intérieures de votre véhicule ?",
            choix_freq_int: ["1 fois par semaine", "1 fois par mois", "1 fois par an"],
            question_freq_ext: "À quelle fréquence estimez-vous devoir effectuer les vérifications extérieures de votre véhicule ?",
            choix_freq_ext: ["1 fois par semaine", "1 fois par mois", "1 fois par an"],
            info_plus: {
              titre: "Info+",
              regulieres: {
                titre: "Vérifications à faire régulièrement",
                items: [
                  "L'état des pneus.",
                  "L'état, la propreté et le fonctionnement des optiques (feux et répétiteurs latéraux).",
                  "L'état et la propreté des surfaces vitrées et rétroviseurs.",
                  "L'état et la propreté des plaques d'immatriculation.",
                ],
              },
              tous_2000km: {
                titre: "Vérifications à faire tous les 2 000 km",
                items: [
                  "Les niveaux (1 Jauge d'huile moteur · 2 Liquide du lave-glace · 3 Remplissage d'huile moteur · 4 Batterie · 5 Liquide de frein · 6 Liquide de refroidissement).",
                  "La pression des pneus.",
                ],
              },
              tous_20000km: {
                titre: "Vérifications à faire (ou faire faire) tous les 20 000 km ou 30 000 km",
                items: [
                  "Le filtre à air.",
                  "Le filtre à carburant.",
                ],
              },
              lecture_pneu: "Inscription d'un pneu (ex : 175/65 R14 82 H TUBELESS RADIAL) : Largeur (mm) / Série du pneu / Structure R (Radial) / Diamètre intérieur (pouce) / Indice de charge / Indice de vitesse.",
            },
            savoir: [
              "Quels sont les voyants qui alertent de la nécessité de s'arrêter ?",
              "Où se trouvent les feux de détresse ?",
            ],
            savoir_faire: [
              "De vérifier la propreté et le fonctionnement des feux.",
              "De vérifier l'état, l'usure et la pression des pneumatiques.",
              "D'activer et désactiver l'airbag.",
            ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue, pour faire ressortir un problème lié à la méconnaissance du véhicule et/ou à l'absence de vérifications. Démontrez qu'un accrochage ou un accident est une suite d'évènements non anodins, liés à de mauvais choix de comportements.",
            questions: [
              "Les risques sont-ils identiques : 1) lorsqu'un conducteur tient compte du fait qu'il ne connaît pas l'état du véhicule ? 2) lorsque le conducteur considère que l'état est bon, mais sans l'avoir vérifié ? Expliquez pourquoi.",
            ],
            situations: [
              "Situation 1 : une partie des conducteurs va adapter son allure et son comportement en fonction des problèmes que peut ou pourrait avoir le véhicule. Cela va donc réduire un peu les risques.",
              "Situation 2 : la politique de l'autruche risque quant à elle d'accentuer les risques, du fait d'une absence totale de précautions. Cela peut être aggravé par des conditions de conduite particulières.",
              "Exemple : Ampoule d'un clignotant grillée, choix du conducteur de négliger la réparation, donc crée un problème de communication lors d'un changement de direction. Le conducteur va « essayer » d'en tenir compte dans sa conduite. Puis, avec le temps il va oublier que son clignotant est défectueux. Il va reprendre une conduite traditionnelle. Ce qui risque à plus ou moins long terme de provoquer un accrochage ou un accident.",
            ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage entretient et vérifie leur véhicule. La mise en évidence de leur intérêt et de l'investissement personnel va apporter quelques explications quant à la vision et au comportement de votre élève sur le sujet. Le mode de vie peut représenter un frein à un entretien méthodique et régulier du véhicule. Néanmoins, quel que soit le lieu d'habitation, avec une bonne organisation, rien n'est impossible !",
            questions: [
              "Quelle est la fréquence d'entretien du véhicule familial ?",
              "Qui s'occupe de l'entretien du véhicule dans votre famille ?",
              "Possédez-vous des produits et accessoires spécifiques pour l'entretien du véhicule ?",
              "Possédez-vous un garage ? Il est plus aisé d'entretenir un véhicule lorsque l'on possède un garage que lorsque ce dernier est stationné dans la rue.",
            ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter la prise en main, ou la vérification d'un véhicule nouveau. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            nb: "N.B. : Le fait de conduire un seul et même véhicule, crée une habitude à entrer, s'installer, démarrer sans forcément prendre le temps de faire le tour du véhicule et/ou de vérifier les réglages. Le conducteur attend parfois un signe traduisant un problème (bruit, fumée, etc.) pour prendre en compte l'état de son véhicule.",
            question_situations: "Citez des situations dans lesquelles on n'a pas toujours le temps de visualiser la position des commandes d'un véhicule avant de partir :",
            situations: [
              "Lorsque l'on est en retard, ou pressé.",
              "Lors de la gestion d'un déplacement professionnel avec une pression hiérarchique (besoin de rapidité et d'efficacité).",
              "Avec un véhicule prêté ou d'entreprise, la notice est-elle présente à son bord ? Dispose-t-on d'assez de temps ?",
              "En situation d'urgence.",
            ],
          },
        },
        points: [
          'Trois pédales (gauche/centre/droite) = embrayage, frein, accélérateur sur boîte manuelle.',
          'Voyants rouges = arrêt immédiat ; voyants orange = vigilance, garage rapidement.',
          'Frein de parking, sélecteur de vitesses, clignotants, essuie-glaces : repérer sans regarder.',
          "Tour extérieur : pneus (usure, pression visuelle), feux, plaques, fuites sous le véhicule.",
          "Tour intérieur : témoins, niveau carburant, essuie-glaces, dégivrage si besoin.",
          "Aucun objet libre sur la plage arrière ou le tableau de bord.",
        ],
        erreurs: [
          'Démarrer sans avoir repéré les commandes — perte de réflexe en situation.',
          'Ignorer un pneu visiblement sous-gonflé — risque éclatement à vitesse.',
        ],
        geste: "Avant le contact, fais un tour visuel du tableau de bord (3 s) puis un tour du véhicule (60 s).",
        mnemo: '"REVEC + NILE" : REVEC (Rétros, Éclairage, Voyants, Essuie-glaces, Commandes) pour le poste. NILE (Niveaux, Illumination, Lignes = pneus, Écran = tableau de bord) pour le tour véhicule.',
        checklist: [
          "Je sais nommer chaque voyant rouge et orange du tableau de bord.",
          "Je repère les 3 pédales sans regarder mes pieds.",
          "Je sais où sont clignotants, essuie-glaces, feux, klaxon, warnings.",
          "J'ai fait le tour du véhicule et vérifié les 4 pneus.",
          "J'ai testé les 4 clignotants + les 2 feux stop + les 2 feux de croisement + les warnings.",
          "Aucun objet libre dans l'habitacle.",
        ],
        attention: [
          "Sur une voiture inconnue, prends 2 min AVANT de démarrer pour tout repérer.",
          "Vérifie toujours la boîte : automatique (P/R/N/D) ou manuelle — les gestes ne sont pas les mêmes.",
          "Vérifie les liquides à FROID uniquement, sinon risque de brûlure et lecture faussée.",
          "En hiver, gratte TOUS les vitrages, pas juste un rond — verbalisable + dangereux.",
        ],
      },
      {
        i: 1,
        letter: 'b',
        titre: "Entrer, s'installer au poste de conduite et en sortir",
        objectif: 'Adopter une posture sûre et reproductible, à chaque montée et descente du véhicule.',
        // ── Trame REMC officielle (fidèle au livret p.16-19) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir s'installer au poste de conduite et en sortir.",
            qr: [
              {
                q: "Quels sont les avantages d'une bonne installation au poste de conduite ?",
                r: "Confort, moins de fatigue, rapidité et aisance sur la manipulation des différentes commandes, bonne visibilité, action efficace des accessoires de sécurité passive en cas d'accident, etc.",
              },
              {
                q: "Quels sont les inconvénients pouvant être provoqués par un chargement désordonné du véhicule ?",
                r: [
                  "Risque d'être gêné ou blessé par un objet non arrimé lors d'un virage, d'un freinage ou d'un choc.",
                  "Risque d'endommager le chargement ou le véhicule.",
                ],
              },
              {
                q: "Quels sont les avantages liés au fait de faire le tour du véhicule avant d'y entrer ?",
                r: "Prendre connaissance de l'environnement proche autour du véhicule, évaluer la proximité d'obstacles, détecter des anomalies.",
              },
            ],
          },
          comment: {
            a_traiter: "Précautions pour entrer et sortir du véhicule, comment s'y installer, comment installer des passagers et/ou des bagages.",
            questions_ouvertes: [
              "Que doit-on régler pour être bien installé au poste de conduite ?",
              "Pourquoi doit-on faire les différents réglages dans un ordre précis ?",
              "Peut-on les faire en roulant ? Pourquoi ?",
              "Comment rendre la ceinture de sécurité efficace ?",
              "À quel âge peut-on monter à l'avant ?",
            ],
            info_plus: {
              titre: "Info +",
              deformation: {
                titre: "Déformation du véhicule lors d'un choc",
                items: [
                  "Supérieur à 56 km/h : déformation majeure du véhicule.",
                  "À 15 km/h : déformation modérée.",
                  "Inférieur à 4 km/h : déformation minime.",
                ],
              },
              conclusion: "Une bonne installation limite le risque de blessures. La ceinture retient, l'airbag amortit, l'appui-tête évite le coup du lapin.",
              securite_passive: {
                titre: "Sécurité passive : agit pendant le choc",
                elements: "Ceinture de sécurité à prétensionneur, carrosserie à structure déformable (pare-chocs, capot, châssis, etc.), airbags, pare-brise non coupant, appuie-tête (anti coup du lapin), barres de protection latérales, etc.",
              },
            },
            savoir: [
              "Quel est le rôle de la ceinture ?",
              "Quelles précautions prendre avant de monter ou descendre du véhicule ?",
            ],
            savoir_faire: [
              "Monter et descendre du véhicule en sécurité.",
              "S'installer correctement en effectuant tous les réglages dans l'ordre.",
            ],
          },
          risques: {
            intro: "Les conducteurs ont souvent une vision erronée ou ne comprennent pas l'intérêt d'une bonne installation au poste de conduite.",
            directives: [
              "Argumentez sur la divergence entre l'image que les jeunes veulent donner et celle qu'ils donnent réellement.",
              "Utilisez, comme élément de comparaison, par exemple, la position de conduite d'un pilote automobile qui s'installe toujours près du volant.",
              "Une bonne installation doit également permettre aux accessoires de sécurité passive de remplir leur rôle correctement en cas d'accident.",
              "Demandez à votre élève d'analyser la position de conduite d'autres conducteurs en fonction de ce qu'il vient d'apprendre et comprendre.",
            ],
            cas_observe: "Le conducteur n'est pas attaché. Il n'utilise qu'une main pour conduire. Son dos n'est pas collé au dossier et l'appui-tête est trop éloigné pour lui éviter le coup du lapin en cas de choc.",
            risques_listes: "Mauvaise maîtrise des commandes et du volant, fatigue plus importante, moins bonne perception de l'environnement, efficacité moindre lors de situations imprévues, éventuellement des problèmes médicaux (liés à la position), blessures graves, etc.",
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les bons et mauvais comportements de son entourage. Cela va l'obliger à visualiser et à analyser une situation avec comme référence ce qu'il vient d'apprendre et comprendre.",
            definition: "Ergonomie : facilité d'utilisation de l'ensemble des équipements dans l'habitacle.",
            questions: [
              "Connaissez-vous des personnes dont la position de conduite est en totale adéquation avec la sécurité et le respect de l'ergonomie du poste de conduite ? Décrivez leur installation.",
              "Dans votre entourage, y a-t-il des personnes dont l'installation au poste de conduite laisse à désirer ? Pourquoi selon vous ?",
              "Quelles suggestions ou conseils aimeriez-vous leur apporter ?",
            ],
          },
          pressions: {
            intro: "Certains aménagements sont possibles mais ils correspondent à des situations particulières uniquement.",
            nb: "Cela peut générer de l'incompréhension ainsi qu'une forme de frustration chez certains conducteurs (ne possédant pas d'aménagements particuliers), les amenant à adopter un comportement inadéquat.",
            question_situations: "Connaissez-vous des professions et situations qui permettent ou obligent leur conducteur à s'installer différemment ?",
            situations_groupees: [
              {
                titre: "Professions",
                items: "Police, gendarmerie, taxis, pompiers, facteurs, livreurs porte-à-porte, etc.",
              },
              {
                titre: "Situations",
                items: "Personnes à mobilité réduite, certaines maladies, la morphologie de la personne, etc.",
              },
            ],
            info_legal: {
              titre: "Article R 412-1 du Code de la route — Sont dispensés du port de la ceinture de sécurité :",
              items: [
                "Les chauffeurs de taxi en service.",
                "Tout conducteur ou passagers de véhicule d'intérêt général prioritaire ou d'une ambulance en intervention.",
                "Les personnes dont la morphologie est inadaptée.",
                "Les personnes munies d'un certificat médical (délivré par une commission médicale).",
                "En agglomération, tout conducteur ou passager d'un véhicule de services publics contraint par nécessité de service de s'arrêter fréquemment, et tout conducteur ou passager d'un véhicule effectuant des livraisons en porte-à-porte.",
              ],
            },
          },
        },
        points: [
          "Côté chaussée : regard sur le trafic AVANT d'ouvrir.",
          "Siège réglé pour que la jambe gauche pousse l'embrayage sans tendre le genou.",
          "Volant à 25–30 cm du sternum, mains à 9 h 15.",
          "Ceinture passée plate, sans torsion, sous le bras.",
          "Rétros latéraux : je vois l'horizon + la ligne blanche côté route. Rétro central : je vois toute la lunette arrière.",
        ],
        erreurs: ["Sortir côté chaussée sans regarder — risque cycliste/voiture qui dépasse."],
        geste: 'Réflexe « PVRC » : Place-Volant-Rétro-Ceinture, avant chaque démarrage.',
        mnemo: '"PVRC" : Place – Volant – Rétros – Ceinture. Rituel de démarrage, jamais dans le désordre.',
        checklist: [
          "J'ouvre la porte côté trottoir chaque fois que c'est possible.",
          "Mon genou gauche s'appuie sur l'embrayage sans se tendre.",
          "Mes poignets touchent le haut du volant, bras légèrement pliés.",
          "Ma ceinture est plate, sous le bras, ne frotte pas le cou.",
          "Mes 3 rétros sont réglés correctement avant démarrage.",
        ],
        attention: [
          "Sortie côté chaussée : ouvre la poignée avec la MAIN OPPOSÉE (méthode « Dutch reach ») — ça force à tourner la tête.",
          "Sur un long trajet, ré-ajuste le siège toutes les 2 h : la fatigue tasse ta posture.",
          "Un passager qui descend côté route n'est PAS informé du danger — rappelle-le systématiquement.",
        ],
      },
      {
        i: 2,
        letter: 'c',
        titre: 'Tenir, tourner le volant et maintenir la trajectoire',
        objectif: 'Garder le contrôle directionnel du véhicule en toute circonstance et maintenir une trajectoire stable.',
        // ── Trame REMC officielle (fidèle au livret C1c) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir où placer son regard et ses mains sur le volant pour maintenir la trajectoire.",
            qr: [
              {
                q: "Quels sont les inconvénients au fait de mettre une main à l'intérieur du volant lorsqu'on tourne ?",
                r: [
                  "Incite à moins, ou à ne plus utiliser les commodos.",
                  "Actions moins précises.",
                  "Risques de blessures plus graves en cas d'accident lors du déploiement de l'airbag, etc.",
                ],
              },
              {
                q: "Quels sont les avantages au fait de tenir le volant à 2 mains ?",
                r: [
                  "Rotation du volant plus précise.",
                  "Permet de réaliser une manœuvre d'évitement.",
                  "Actions rapides sur les commodos.",
                  "Mouvements sur le volant rapides, précis et efficaces.",
                ],
              },
              {
                q: "Quels sont les inconvénients à figer le regard en conduite ?",
                r: [
                  "Selon l'allure, les informations ne sont pas perçues ou perçues tardivement.",
                  "Risque d'écarts de trajectoire ou de perte de contrôle.",
                ],
              },
            ],
          },
          comment: {
            a_traiter: "Regard (voir/regarder), position des mains sur le volant.",
            cas_observe: "Ici le volant n'est tenu que par 3 doigts. C'est insuffisant pour permettre l'accès aux différentes commandes, ou pour pouvoir maîtriser la trajectoire en cas d'imprévus (manœuvre d'évitement), ou en cas de revêtement dégradé (nid-de-poule, etc.).",
            info_plus: {
              titre: "Info + · Vision et champ visuel",
              champ_visuel: {
                titre: "Champ visuel",
                items: [
                  "Vision centrale : image nette, couleurs précises.",
                  "Œil gauche / œil droit : images floues, formes et couleurs de plus en plus imprécises en périphérie.",
                  "Vision binoculaire : 60° avec les 2 yeux — vue en relief, évaluation des distances.",
                  "Vision périphérique : 180° avec les 2 yeux.",
                ],
              },
              tache_mariotte: "Tache de Mariotte : tache dans le champ visuel dans laquelle les objets ne sont pas vus en vision monoculaire. L'œil voit une image, le cerveau reconstitue le reste.",
              exercice: "Exercice : à l'aide du visuel figurant au dos de la page d'inscription : cachez votre œil gauche, tenez le dessin face à vous, fixez avec votre œil droit le X. Avancez et reculez la feuille jusqu'à ce que le cercle ne soit plus visible. Faites la même chose avec l'œil gauche. Vous venez de mettre en évidence votre tache aveugle !",
            },
            savoir: [
              "Quelle est la position des mains la plus sécuritaire ? Pourquoi ?",
              "Quelles sont les façons de tenir le volant qui sont dangereuses ? Pourquoi ?",
            ],
            savoir_faire: [
              "Tenir le volant en ligne droite.",
              "Tourner le volant sans déplacer les mains sur la couronne (courbe), avec simple déplacement des mains (virage), avec chevauchement des mains (tournant).",
              "Placer le regard pour maintenir la trajectoire.",
            ],
          },
          risques: {
            intro: "Pour lui apprendre à évaluer le risque et rendre intéressant son apprentissage, vous pouvez proposer à votre élève de faire cette expérience. Le but étant qu'il prenne conscience des risques liés à une mauvaise position des mains sur le volant.",
            directives: [
              "Entamez une discussion autour des sentiments que lui procure chacun des conducteurs proposés et faites-le justifier son besoin de sécurité ou sa préférence pour les situations risquées.",
              "Aidez-le ensuite à mettre cela en relation avec le choix de sa future pratique.",
              "Info+ : déploiement de l'airbag conducteur : 50 à 150 millisecondes. Cligner de l'œil : 150 millisecondes.",
            ],
            cas_observe: "Exercice à réaliser : choisissez un lieu dépourvu de toute circulation. À l'aide de cônes ou piquets, installez un slalom ou un « 8 ». Faites rouler le véhicule en régime minimum (1re ou 2e vitesse) et demandez à votre élève de mettre les mains à l'intérieur du volant pour tourner, puis d'essayer de conduire avec les genoux, puis avec un objet dans une main (bouteille d'eau ouverte, téléphone, etc.). Tout en réalisant le parcours, demandez-lui de mettre en route les feux de détresse, d'utiliser le lave-vitres, ou d'ouvrir une vitre… Si vous êtes équipé, n'hésitez pas à filmer et/ou chronométrer son action.",
            risques_listes: "Avec quel(s) conducteur(s) votre élève n'aimerait-il pas ou refuserait-il de monter ? Pourquoi ? Décrivez ou mimez les situations vécues.",
          },
          influences: {
            intro: "Faites réfléchir votre élève sur la façon dont les personnes de son entourage tiennent le volant, pour qu'il puisse juger si sa pratique a été influencée ou non par la leur.",
            questions: [
              "Citez des personnes de votre entourage dont la position des mains sur le volant est en totale adéquation avec une conduite sécuritaire.",
              "Dans votre entourage, y a-t-il des personnes dont la tenue du volant laisse à désirer ? Pourquoi selon vous ?",
              "Par rapport aux situations à risque, quelles sont celles que vous avez déjà rencontrées en tant que passager ?",
              "Quelles suggestions ou conseils aimeriez-vous leur apporter ?",
            ],
          },
          pressions: {
            intro: "Il est nécessaire de comprendre que certaines professions et/ou situations peuvent contraindre le conducteur à adapter sa tenue du volant. Cette pratique est toujours associée à un véhicule rendu plus visible au milieu des autres (peinture, gyrophare, sirènes, etc.) et/ou par une adaptation de l'allure.",
            nb: "Les aménagements liés au handicap ou à certaines maladies permettent une conduite sécuritaire. Attention aux idées reçues (ex. commercial qui téléphone). Le kit main libre ou radio casque libère les deux mains mais ne libère pas pour autant le cerveau d'une double tâche.",
            question_situations: "Citez des professions et situations qui nécessitent parfois une conduite à une main.",
            situations_groupees: [
              {
                titre: "Professions",
                items: "Toutes celles qui peuvent avoir besoin d'utiliser une radio ou un micro… véhicule d'annonceur (cirque, publicité, etc.), moniteur moto-école, policiers, gendarmes, etc.",
              },
              {
                titre: "Situations",
                items: "Personnes à mobilité réduite, manchot, certaines maladies.",
              },
              {
                titre: "Solutions",
                items: "Aménagement du véhicule, boule sur le volant, volant au pied, etc.",
              },
            ],
          },
        },
        points: [
          "Mains à 9 h et 3 h (ou 10 h 10 selon préférence), pouces sur la jante, jamais à l'intérieur.",
          "Tirer / pousser : main qui pousse vers le haut, l'autre tire — pas de croisé en virage serré.",
          "Manœuvres lentes : croisé toléré ; circulation : interdit.",
          "Trajectoire stable = regard porté loin (3-5 s devant) + micro-corrections souples au volant.",
        ],
        erreurs: [
          'Conduire une main sur la cuisse — réaction tardive en surprise.',
          'Serpenter faute de regard porté loin — trajectoire instable.',
        ],
        geste: 'En tirer-pousser, ta main basse termine toujours en haut du volant — pas plus.',
        mnemo: '"9-3, jamais 12" : main à 9 h et 3 h, pouces DEHORS. En cas d\'airbag, une main à 12 h = poignet cassé.',
        checklist: [
          "Mes deux mains sont sur le volant, sauf pour manipuler une commande dédiée.",
          "Mes pouces reposent SUR la jante, pas dans les branches.",
          "En virage, je ne croise pas les bras (sauf manœuvre lente).",
          "Je peux ramener le volant droit sans regarder mes mains.",
          "Je maintiens une trajectoire stable dans MA voie, sans osciller.",
        ],
        attention: [
          "Le pouce à l'intérieur des branches = fracture assurée en cas d'accident (déclenchement airbag).",
          "Retour du volant : accompagne-le avec les mains, ne le laisse jamais glisser tout seul dans les doigts.",
          "Volant + smartphone dans la même main = infraction ET impossible en manœuvre d'urgence.",
        ],
      },
      {
        i: 3,
        letter: 'd',
        titre: "Démarrer, s'arrêter",
        objectif: 'Mettre en mouvement et immobiliser le véhicule sans à-coup ni cale.',
        // ── Trame REMC officielle (fidèle au livret C1d) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir maîtriser les démarrages/arrêts en toutes circonstances.",
            qr: [
              {
                q: "Quels sont les avantages liés à la maîtrise des démarrages ?",
                r: [
                  "Utilisation du véhicule qui n'occasionne pas de stress.",
                  "Risques diminués pour soi et autrui.",
                  "Respect de la mécanique.",
                  "Attention du conducteur qui se porte sur l'environnement, etc.",
                ],
              },
              {
                q: "Quels sont les inconvénients liés à la non-maîtrise de l'arrêt de précision ?",
                r: [
                  "Occasionne du stress.",
                  "Peut provoquer un accrochage.",
                  "Peut effrayer les autres usagers, etc.",
                ],
              },
              {
                q: "Quels sont les avantages à savoir démarrer sans à-coup ?",
                r: [
                  "Confort.",
                  "Respect de la mécanique.",
                  "Attention du conducteur qui se porte sur l'environnement.",
                ],
              },
            ],
          },
          comment: {
            a_traiter: "Aspects mécaniques, démarrages avec et sans frein à main, côte/plat/descente, ligne droite/courbe/angle, arrêts côte/plat/descente, ligne droite/courbe/angle, arrêt de précision.",
            info_plus: {
              titre: "Info + · Aspects mécaniques de l'embrayage",
              boite_manuelle: {
                titre: "Véhicule à boîte manuelle",
                items: [
                  "Position DÉBRAYÉE : un système mécanique ou hydraulique déplace la fourchette (1) et la butée (2). Le plateau presseur (3) s'écarte et le disque d'embrayage (4) est libéré. Plus de liaison entre le moteur et la transmission → permet le passage des vitesses et l'arrêt sans calage.",
                  "Position EMBRAYÉE : par le même mécanisme, le plateau appuie avec force sur le disque et la liaison moteur-transmission est rétablie.",
                  "Position dite de « PATINAGE » : le disque n'est pas complètement comprimé. Il permet une liaison progressive des deux ensembles, ce qui favorise les démarrages en douceur.",
                ],
              },
              boite_automatique: {
                titre: "Véhicule à boîte automatique",
                items: [
                  "La liaison moteur-transmission passe par un convertisseur hydraulique + boîte de vitesses automatique — pas de pédale d'embrayage.",
                ],
              },
            },
            savoir: [
              "Quelle(s) est/sont la(les) précaution(s) à prendre avant de mettre le moteur en route ?",
              "Quel est le rôle de l'embrayage ?",
              "Pourquoi faut-il savoir remettre rapidement le moteur en marche après calage ?",
            ],
            savoir_faire: [
              "Démarrer sur le plat, en descente et en montée, avec ou sans frein à main (trois exercices réussis).",
              "S'arrêter à hauteur d'un repère, véhicule roulant à faible vitesse (tolérance plus ou moins 50 cm).",
            ],
          },
          risques: {
            intro: "Il est important que votre élève puisse identifier les situations présentant des risques liés à la non-maîtrise de la compétence. Ces arguments doivent l'amener à comprendre l'intérêt à réaliser des démarrages efficaces et des arrêts précis.",
            directives: [
              "Avez-vous vécu une situation dans laquelle la non-maîtrise du démarrage ou arrêt de précision a ou aurait pu entraîner un risque d'accrochage ?",
              "Citez tous les inconvénients que la non-maîtrise du démarrage ou de l'arrêt peut provoquer en circulation.",
            ],
            risques_listes: "Peut gêner la circulation, ne permet pas toutes les manœuvres, abîme la mécanique, provoque du stress chez le conducteur et les passagers, peut effrayer les autres usagers, entraîne un risque de collision, etc.",
          },
          influences: {
            intro: "Faites réfléchir votre élève sur la façon dont les personnes de son entourage réalisent leurs démarrages et arrêts, pour qu'il puisse juger si sa pratique a été influencée ou non par la leur. Vous pouvez amener votre élève à comparer si ce qui est pratiqué est en accord avec « l'image » de la personne.",
            definition: "N.B. : Il est important dans cette compétence de travailler sur l'image associée au calage. Souvent associé à un manque de capacités du conducteur, il peut vite devenir traumatisant ou perturbant pour l'élève débutant.",
            questions: [
              "Qu'est-ce qui est le plus pratiqué comme démarrage par votre entourage ? (démarrages normaux, rapides, faire patiner les pneus au démarrage, etc.)",
              "Pourquoi ?",
              "Pensez-vous que la façon de démarrer définit la personnalité ou les qualités du conducteur ?",
              "Que pensez-vous d'un usager qui cale au démarrage ?",
            ],
          },
          pressions: {
            intro: "Pour certaines professions, la maîtrise de cette compétence (entre autres) est primordiale. Mais effectuer des démarrages/arrêts répétés dans un laps de temps court génère des inconvénients débouchant sur l'adoption de mauvaises habitudes (ne plus s'attacher lors de courts trajets, se rapprocher au maximum d'un lieu pour éviter de couper le contact et redémarrer, laisser tourner le moteur ou la porte ouverte lors de la descente, etc.). Tous ces « aménagements » de conduite entraînent des conséquences sur l'environnement, le conducteur et le véhicule.",
            question_situations: "Quelles professions imposent de nombreux démarrages au cours d'une journée ?",
            situations_groupees: [
              {
                titre: "Professions",
                items: "Les postiers, les livreurs, les soins à domicile, les vendeurs porte-à-porte…",
              },
              {
                titre: "Inconvénients sur le véhicule",
                items: "Sollicitation du démarreur, de l'embrayage, usure de la batterie.",
              },
              {
                titre: "Inconvénients pour le conducteur",
                items: "Troubles musculo-squelettiques (douleurs et maladies occasionnées par des mouvements répétitifs), mauvaises habitudes (contrôles avant démarrage / arrêt oubliés pour gagner du temps), stress, tâche pénible au bout de quelques années, etc.",
              },
              {
                titre: "Inconvénients pour l'environnement",
                items: "Bruit, pollution, consommation, etc.",
              },
            ],
          },
        },
        points: [
          "Démarrage : embrayage à fond, point mort, contact, embrayage lentement jusqu'au point de patinage, gaz légers.",
          "Arrêt : rétrograder progressivement, frein gradué, embrayer juste avant l'arrêt complet.",
          "Toujours regarder LOIN (40-50 m) pour anticiper et lisser les ralentissements.",
        ],
        erreurs: ['Caler en intersection — souvent dû à un relâchement trop sec de l\'embrayage.'],
        geste: "Pied gauche au plancher quand tu n'embraies pas — évite l'usure et la fatigue.",
        mnemo: '"Écoute d\'abord, gaz ensuite" : trouve le point de patinage à l\'oreille avant d\'accélérer.',
        checklist: [
          "Je démarre sans caler 5 fois d'affilée en côte modérée.",
          "Je m'arrête en douceur, sans projeter le passager vers l'avant.",
          "Je regarde à 40-50 m devant, pas 10 m.",
          "Je peux redémarrer en côte au frein à main sans reculer.",
          "Je sais faire un arrêt d'urgence contrôlé.",
        ],
        attention: [
          "En pente + intersection = trouve TOUJOURS le frein à main. Le patinage à contre-pente use l'embrayage.",
          "Un freinage brusque suivi d'un relâchement = pire pour la sécurité passagers qu'un freinage ferme et continu.",
          "Sur voiture automatique : pied gauche AU PLANCHER, jamais posé sur le frein en roulant.",
        ],
      },
      {
        i: 4,
        letter: 'e',
        titre: "Doser l'accélération et le freinage à diverses allures",
        objectif: 'Coordonner accélération et freinage pour une conduite fluide à toutes les vitesses.',
        // ── Trame REMC officielle (fidèle au livret C1e) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir maîtriser et gérer l'allure de son véhicule.",
            qr: [
              {
                q: "Quels sont les avantages à bien connaître les capacités d'accélération de son véhicule ?",
                r: "Indispensable pour dépasser, respect de la mécanique, favorise la conduite éco, évite de sous ou surestimer les capacités de son véhicule."
              },
              {
                q: "Quels sont les inconvénients au fait de ne pas bien connaître les capacités de freinage de son véhicule ?",
                r: "Prise de risque plus importante : risque d'allure excessive, freinages tardifs, non-maîtrise des distances de sécurité, mauvaise sollicitation du frein et frein moteur, etc."
              }
            ]
          },
          comment: {
            a_traiter: "Regard, analyse, capacités d'accélération/freinage du véhicule, accélérer, ralentir, freiner.",
            questions_ouvertes: [
              "Qu'est-ce qui permet de déterminer la vitesse à laquelle on doit rouler ? (Réglementaire : signalisation, météo. Autres : usagers vulnérables, environnement, etc.)",
              "Quels sont les dispositifs permettant de ralentir le véhicule ? (Frein à pied, frein moteur, frein à main en cas de défaillance et sur certains véhicules uniquement.)",
              "Qu'est-ce qu'un freinage dégressif ? Quelle est son utilité ? (Appui fort sur le frein puis relâché ou avec moins de pression. Ralentit fortement le véhicule.)"
            ],
            info_plus: {
              titre: "Info + · Frein à disque et transfert de masse",
              conclusion: "Frein à disque : lorsque le conducteur appuie sur la pédale, la pression met en mouvement, via un fluide hydraulique, les pistons qui appuient les plaquettes contre le disque et freinent sa rotation. Transfert de masse : déplacement du centre de gravité lors d'un freinage ou d'une accélération."
            },
            savoir: [
              "Pourquoi doit-on doser l'accélération et le freinage ?",
              "Quelle est l'utilité du frein moteur ?"
            ],
            savoir_faire: [
              "Faire varier la vitesse de déplacement du véhicule entre 10 et 30 km/h en dosant l'accélération et le freinage."
            ]
          },
          risques: {
            intro: "Proposez une discussion sur le fait que tous les véhicules peuvent rouler vite, mais ne sont pas tous égaux en termes de tenue de route et de réactions au freinage (ex : à moto, un freinage mal réalisé peut entraîner la chute immédiate du motard).",
            directives: [
              "Faites ressortir que les conducteurs (selon leur âge, leur expérience et leur vision du risque, etc.) ne sont pas non plus égaux entre eux en termes de capacités de conduite.",
              "Considérez également les capacités du conducteur d'un jour sur l'autre (soucis, fatigue, maladie, etc.)."
            ],
            risques_listes: "Les véhicules (de différentes catégories) sont-ils tous équivalents en termes de capacité d'accélération ? OUI - NON (différences entre poids lourd, moto, voiture citadine, voiture de sport). En termes de capacité de freinage ? OUI - NON (tous ont de bonnes capacités adaptées, mais l'adhérence modifie la distance de freinage). Et les conducteurs, sont-ils tous égaux dans la gestion d'une allure rapide ? OUI - NON."
          },
          influences: {
            intro: "Faites réfléchir votre élève sur la façon dont les personnes de son entourage conduisent pour qu'il puisse juger si sa pratique a été influencée ou non par la leur. Amenez-le à comparer si ce qui est pratiqué est en accord avec « l'image » de la personne.",
            questions: [
              "Que traduit une conduite ponctuée d'accélérations et de freinages ?",
              "Y a-t-il dans votre entourage des gens qui pratiquent ce genre de conduite ?",
              "Pour quelles raisons d'après vous ?"
            ]
          },
          pressions: {
            intro: "Même si l'image de la vitesse évolue, elle reste valorisée par notre société. Nous fonctionnons dans un monde où tout doit aller vite (TGV, Internet, livraison express, etc.) mais d'un autre côté la vitesse est dangereuse lorsqu'elle est pratiquée avec excès sur la route.",
            nb: "Apprendre à maîtriser l'accélérateur et le frein, c'est prendre conscience qu'il faudra être capable de gérer l'allure de son véhicule et cela malgré la pression de la société.",
            question_situations: "Questions à débattre :",
            situations: [
              "À votre avis, démarrer en trombe est-il le signe d'une bonne maîtrise du véhicule et de bonnes capacités du conducteur ?",
              "Quelle image associez-vous à ceux qui pratiquent les « Runs sauvages » (courses au milieu de la circulation) ?",
              "Que pensez-vous des courses automobiles (sur piste) ?"
            ]
          }
        },
        points: [
          "Accélération : pression progressive du gros orteil, jamais d'à-coup.",
          "Frein : appui ferme au début, dégressif vers l'arrêt — passager ne doit pas être projeté.",
          "À faible allure : dosage très fin ; à haute allure : anticipation et progressivité renforcées.",
        ],
        erreurs: ['Freiner « en deux temps » qui surprend le véhicule suivant.'],
        geste: "Si tu freines, regarde 1 seconde dans le rétro intérieur APRÈS le freinage — vérifie la distance.",
        mnemo: '"Un café dans la main du passager" : conduis comme s\'il tenait une tasse chaude — aucun mouvement brusque toléré.',
        checklist: [
          "Mon passager peut lire son téléphone sans être secoué.",
          "Je sais faire un freinage d'urgence sans caler et sans dévier de trajectoire.",
          "Je peux maintenir 30 km/h stable en 2e rapport sur 200 m.",
          "Mes accélérations sont progressives, sans à-coup.",
          "Mes freinages sont dégressifs à l'approche de l'arrêt complet.",
        ],
        attention: [
          "Freiner à 2 pieds (frein + accélérateur simultanés) = interdit et destructeur. UN pied par pédale.",
          "En descente longue, le frein moteur (rétrograder) évite la surchauffe des plaquettes.",
          "Sur mouillé, ta distance de freinage double. Adapte ton dosage.",
        ],
      },
      {
        i: 5,
        letter: 'f',
        titre: 'Utiliser la boîte de vitesses',
        objectif: 'Choisir et changer de rapport au bon moment pour une conduite fluide, sûre et économe.',
        // ── Trame REMC officielle (fidèle au livret C1f) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir manipuler et utiliser correctement une boîte de vitesses.",
            qr: [
              {
                q: "Quels sont les avantages à rouler sur le bon rapport de vitesse ?",
                r: "La consommation est maîtrisée, la mécanique est préservée, le véhicule est moins bruyant, plus confortable. On exploite correctement le couple-moteur du véhicule."
              },
              {
                q: "Quels sont les avantages liés au passage de vitesses sans regarder le levier ?",
                r: "Plus de sécurité (yeux sur la route), moins de stress, l'attention du conducteur se porte sur l'environnement, moins de risque d'écarts de trajectoire, etc."
              }
            ]
          },
          comment: {
            a_traiter: "Aspects mécaniques, sur et sous régime, position de la main sur le levier, montée des vitesses, frein moteur, freinage, rétrogradage, prise en compte du relief, de la visibilité.",
            questions_ouvertes: [
              "Comment redonner de la puissance à son véhicule dans une forte côte ? (En accélérant franchement ? En passant la vitesse supérieure ? En freinant ? En passant la vitesse inférieure ?)",
              "Qu'est-ce que le sur-régime ? Le sous-régime ?"
            ],
            info_plus: {
              titre: "Info + · Boîtes manuelle et automatique",
              boite_manuelle: {
                titre: "Boîte manuelle — Fonctionnement",
                items: [
                  "Dans la boîte de vitesses, les pignons (roues dentées) sont constamment en contact.",
                  "Les rapports de transmission sont commandés par le levier de vitesses.",
                  "Le pignon denté correspondant à la vitesse choisie est libre sur son arbre. À l'instant où il est sélectionné, il est engrené à cet arbre grâce à un synchroniseur et à un crabot qui établissent la connexion."
                ]
              },
              boite_automatique: {
                titre: "Boîte automatique — Positions",
                items: [
                  "P (Park) : Parking.",
                  "R (Reverse) : Marche arrière.",
                  "N (Neutral) : Point mort.",
                  "D (Drive) : Marche avant.",
                  "2 ou S : seules les 2 premières vitesses sont utilisées (forte descente, neige, verglas, etc.).",
                  "1 ou L : seule la 1re vitesse est utilisée (verglas, forte côte, etc.).",
                  "Sur certains modèles S : Sport et W : démarrage en 2nd pour limiter le risque de patinage.",
                  "Seules les positions P et N permettent de mettre en marche le moteur.",
                  "La position N permet également de déplacer le véhicule en le poussant."
                ]
              },
              conclusion: "Rôle de la boîte de vitesses : sélectionner différents rapports de démultiplication (selon l'effort résistant), obtenir la marche arrière (inversion du sens de mouvement de la transmission), choisir le point mort (séparation permanente de la liaison moteur/transmission)."
            },
            savoir: [
              "À quoi sert la boîte de vitesses ?",
              "Pourquoi faut-il débrayer avant de changer de vitesse ?",
              "Sur quelle position dois-je mettre le sélecteur de vitesse pour avancer ?"
            ],
            savoir_faire: [
              "Véhicule à l'arrêt : passer différentes vitesses (vérifier la coordination pied gauche et mouvement du levier).",
              "Véhicule roulant : monter et rétrograder les vitesses (trois fois au moins sans erreur)."
            ]
          },
          risques: {
            intro: "En plus du risque d'endommager la mécanique de la voiture, une mauvaise utilisation de la boîte de vitesses peut être à l'origine d'une collision. Elle peut être à l'origine d'un calage, ou d'un fort ralentissement sans que les feux de stop ne s'allument pour autant. Pour les passagers du véhicule, cela peut provoquer beaucoup d'inconfort et de stress.",
            directives: [
              "Que peut engendrer une mauvaise utilisation de la boîte de vitesses sur la mécanique ?",
              "Une mauvaise utilisation des vitesses peut-elle être à l'origine d'autres problèmes ?"
            ],
            risques_listes: "Main en permanence sur le levier : exerce une pression inutile sur les fourchettes de transmission (usure prématurée). Pied en permanence sur la pédale d'embrayage : la butée est en permanence en contact avec le plateau → détérioration rapide. Changements de vitesse trop rapides : « battre les synchros » → dommages sur les engrenages. Utiliser le frein moteur de façon excessive (sans ou peu de freinage) : consommation excessive d'huile, bris de soupapes, stress énorme sur le moteur/transmission/différentiel/rouage d'entraînement.",
            cas_observe: "Info + · En 2007, les véhicules à boîte automatique représentaient à peine 8 % des ventes. En 2019 → 35 %, en 2020 → 37 %, en 2021 → 54 % du marché du neuf (source Internet)."
          },
          influences: {
            intro: "Demandez à votre élève d'associer chaque conducteur à un type de conduite possible. Cet exercice va lui permettre de comprendre plus facilement que certains comportements routiers sont influencés par les traits de caractère d'un individu. Il pourra ainsi rapporter cela aux comportements des conducteurs de son entourage et vérifier qu'il n'a pas subi leur influence dans sa pratique.",
            definition: "Le débutant regarde le levier de vitesse, n'est pas toujours dans le bon rapport, regarde le compte-tours. Le nerveux pousse les rapports à fond, utilise beaucoup le frein moteur. Le stressé n'est pas toujours dans le bon rapport, vérifie plusieurs fois en quelle vitesse il est. Le fatigué reste sur le même rapport quelle que soit la vitesse, conduit en sur ou sous régime. Le respectueux de la mécanique / l'éco-conducteur : passe les vitesses sans à-coup et de façon souple.",
            questions: [
              "Nos expériences, caractères ou état influencent-ils notre manière de passer les vitesses ? OUI - NON",
              "Pouvez-vous associer quelques-uns de ces clichés à des conducteurs de votre entourage ?",
              "Pousser les rapports à fond permet une conduite écologique ? Sportive ? Économique ? Dynamique ? Use la mécanique ? Pollue plus ? Fait consommer plus ?"
            ]
          },
          pressions: {
            intro: "Ces questions doivent aider votre élève à associer comportements et image. S'agit-il de valeurs subies ou réfléchies ? Amenez votre élève à prendre conscience de ses valeurs et représentations afin de les faire évoluer.",
            nb: "Idée reçue : en France, les véhicules à boîte auto sont volontiers associés aux personnes qui manquent de capacités en conduite, ou aux personnes âgées. D'ailleurs le « permis boîte automatique » ne permet pas de conduire un véhicule à boîte manuelle. Réalité : aujourd'hui pratiquement tous les constructeurs proposent leurs modèles en boîte automatique, qu'il s'agisse de citadines ou de voitures de luxe. Elle améliore le confort du conducteur, le plaisir de conduire et augmente la sécurité en permettant notamment une conduite à deux mains.",
            question_situations: "Questions à débattre :",
            situations: [
              "Combien de types de boîtes de vitesses connaissez-vous ? (Manuelle, automatique, séquentielle, robotisée, etc.)",
              "Quelle boîte de vitesses aimeriez-vous sur votre véhicule et pourquoi ce choix ?",
              "Quelle image associez-vous au conducteur d'un véhicule à boîte automatique ?"
            ]
          }
        },
        points: [
          "Boîte manuelle : rapport 1 pour démarrer, monter 2/3/4/5/6 en fonction de la vitesse et du régime moteur.",
          "Point de patinage de l'embrayage : position clé, à trouver « à l'oreille ».",
          "Changement de rapport : embrayage à fond, sélecteur au rapport souhaité, embrayage progressif avec un léger coup d'accélérateur.",
          "Boîte automatique : sélecteur P/R/N/D, frein enfoncé pour changer P↔R/D, mode manuel pour le frein moteur.",
        ],
        erreurs: [
          'Rester en rapport bas trop longtemps — moteur qui hurle, surconsommation.',
          "Rétrograder brutalement — perte d'adhérence roues motrices.",
        ],
        geste: 'Monte un rapport dès 2 000 – 2 500 tr/min en conduite normale.',
        mnemo: '"Écoute – Regarde – Change" : Écoute le moteur (régime), Regarde la vitesse, Change au bon moment.',
        checklist: [
          "J'ai identifié mon point de patinage sur MA voiture.",
          "Je passe le rapport supérieur dès 2 000 – 2 500 tr/min en conduite normale.",
          "Je rétrograde progressivement en approche de ralentissement.",
          "Aucun à-coup lors de mes changements de rapport.",
          "Sur automatique, je connais l'usage de chaque position (P, R, N, D, mode manuel).",
        ],
        attention: [
          "Un embrayage relâché trop vite en 1re = cale ou saut. Trop lentement = usure prématurée.",
          "Rétrograder alors que le régime est trop haut = à-coup violent + perte d'adhérence.",
          "Sur automatique, ne passe JAMAIS en N en roulant (perte du frein moteur).",
        ],
      },
      {
        i: 6,
        letter: 'g',
        titre: 'Diriger la voiture en avant en ligne droite et en courbe en adaptant allure et trajectoire',
        objectif: 'Maintenir une trajectoire stable en ligne droite et en courbe, en adaptant sa vitesse au tracé.',
        // ── Trame REMC officielle (fidèle au livret C1g) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt de savoir placer son regard pour choisir l'allure et maintenir la trajectoire.",
            qr: [
              {
                q: "Quels sont les inconvénients à regarder trop près ?",
                r: "L'analyse sera tardive et ne permettra pas d'anticiper sur la configuration de la route ou la présence d'autres usagers, risque de mauvaises trajectoires et de sorties de route, ou de collision, etc."
              },
              {
                q: "Pourquoi doit-on éviter de fixer un obstacle ?",
                r: "Pour éviter de dévier sa trajectoire en se dirigeant vers lui."
              },
              {
                q: "Pourquoi ne peut-on pas conserver la même allure en permanence ?",
                r: "Densité du trafic, météo, relief, visibilité."
              }
            ]
          },
          comment: {
            a_traiter: "Regard, gestion de l'allure (freiner/ralentir, accélérer ou non, etc.), gestion des rapports de vitesse, négociation de courbe.",
            info_plus: {
              titre: "Info + · Expérience des bouteilles d'eau",
              exercice: "Prendre 2 bouteilles, une vide, l'autre pleine d'eau (possible avec du sable, etc.). Demandez à l'élève de commencer à vider l'une dans l'autre, les goulots étant proches. Q : Où placez-vous votre regard ? — Puis vider en éloignant les goulots de 20 cm environ, puis de plus en plus haut. Q : Où regardez-vous ? — Puis demander à l'élève de déplacer son regard sur le goulot qui verse uniquement, la bouteille qui se vide étant placée au moins à 50 cm au-dessus. Q : Que se passe-t-il ? Q finale : Où devez-vous regarder pour réussir à verser l'eau dans la bouteille vide ?",
              conclusion: "Le fait d'utiliser une expérience pour amener ce savoir (primordial en conduite) va rendre l'apprentissage ludique et permettre à l'élève de se l'approprier plus facilement. En fin d'expérience, faites le lien avec « où placer le regard en conduite » : la bouteille qui se vide correspond au regard près du véhicule, celle qui reçoit correspond au regard au loin, à la découverte de la route."
            },
            savoir: [
              "Que se passe-t-il si on tient trop fermement le volant ?",
              "Quel est le rôle du regard pour suivre une trajectoire ?"
            ],
            savoir_faire: [
              "Circuler en ligne droite et en courbe en marche avant, sans s'écarter ni se rapprocher exagérément de la bordure de la chaussée."
            ]
          },
          risques: {
            intro: "Proposez une discussion pour faire évoluer les représentations de votre élève en termes de risques à propos de la vitesse (ce thème sera plus développé en C2c).",
            directives: [
              "La vitesse est, et reste, une source déclenchante et aggravante d'accidents de la route. Les moins de 25 ans sont les plus touchés par les accidents liés à la non-maîtrise de l'allure.",
              "L'important n'est pas de chercher à convaincre, mais plutôt d'amener une autre vision du problème. En aidant l'élève à prendre conscience que ses choix auront des conséquences sur la prise de risque pour lui et les autres."
            ],
            risques_listes: "Quelles peuvent être les conséquences d'une mauvaise maîtrise de l'allure ? Consommer plus, polluer plus, risque d'accident, gêne pour les autres usagers, usures mécaniques, etc.",
            cas_observe: "Parmi les conséquences et risques cités, quels sont ceux que votre élève accepte de prendre ? De faire prendre à ses passagers ? Aux autres usagers ?"
          },
          influences: {
            intro: "Faites réfléchir votre élève sur la façon dont les personnes de son entourage gèrent l'allure de leur véhicule, pour qu'il puisse juger si sa pratique a été influencée ou non par la leur. Il est intéressant de voir ce que l'élève met derrière chaque définition et quels exemples de comportement il a eu au sein de son entourage.",
            definition: "« Prudent et consciencieux » : respecte le code, les limitations de vitesses, adapte son allure aux situations, aux autres, à l'environnement. « Pas sûr de lui, hésitant » : beaucoup de variations d'allure, vitesse maintenue voire soutenue en ligne droite, freinage tardif ou mal dosé en virage, stressé au volant, etc.",
            questions: [
              "Donnez des définitions à ces expressions : « prudent et consciencieux », « pas sûr de lui, hésitant ».",
              "Certaines de ces expressions peuvent-elles être attribuées à des personnes de votre entourage ?"
            ]
          },
          pressions: {
            intro: "Montrer que l'on peut facilement être amené à détacher le regard de la route (rappel : expérience réalisée), et qu'il faut être vigilant vis-à-vis de ce genre de distraction. Surtout lorsque l'on passe de la place de passager à celle de conducteur…",
            nb: "Mais installer des publicités aux bords des routes, c'est aussi un moyen de faire passer un message et de communiquer avec un nombre important de personnes. Il faut donc trouver un juste milieu entre satisfaire sa curiosité et assurer la sécurité.",
            question_situations: "Questions à débattre :",
            situations: [
              "Comment percevez-vous ces publicités au bord des routes ? (Agréables, perturbantes, jolies, sans avis, informatives, indispensables, à interdire, etc.)",
              "Les regardez-vous, lorsque vous êtes passager ? Conducteur ?",
              "Peuvent-elles perturber l'attention des conducteurs ?"
            ]
          }
        },
        points: [
          "Regard loin = trajectoire stable. Plus le regard est court, plus la voiture serpente.",
          "Courbe : entrer large, viser le point de corde, ressortir large.",
          "Vitesse adaptée AVANT le virage, jamais pendant.",
        ],
        erreurs: ['Freiner en plein virage — risque sous-virage / sortie de route.'],
        geste: '« Slow in, fast out » : ralentis à l\'approche, ré-accélère à la sortie.',
        mnemo: '"Où tu regardes, tu vas." Fixe le point de sortie du virage, pas la corde.',
        checklist: [
          "Mon regard porte à 3-5 secondes devant, pas sur le capot.",
          "Je freine AVANT la courbe, jamais dedans.",
          "En courbe à droite, j'entre à gauche de ma voie ; en courbe à gauche, j'entre à droite (dans les limites de ma voie).",
          "Je peux tenir 60 km/h stable en trajectoire dans une courbe sans à-coup.",
          "Je reste dans MA voie même quand la route est vide.",
        ],
        attention: [
          "En virage serré aveugle, imagine TOUJOURS qu'un cycliste ou tracteur est juste derrière.",
          "L'ESP (antipatinage) sauve, mais ne remplace jamais un ralentissement anticipé.",
          "Sur route mouillée, ta vitesse d'entrée en courbe doit être réduite de 20 %.",
        ],
      },
      {
        i: 7,
        letter: 'h',
        titre: 'Regarder autour de soi et avertir',
        objectif: 'Construire une vision panoramique en mouvement et signaler ses intentions clairement.',
        // ── Trame REMC officielle (fidèle au livret C1h) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir prendre les informations et communiquer avec son entourage. « Il vaut mieux oublier d'éteindre son clignotant que d'oublier de l'allumer… ». « Eh non ! Les fausses intentions sont aussi des sources d'accident ! »",
            qr: [
              {
                q: "Quels sont les avantages à contrôler avant de signaler ?",
                r: "Prise en compte et respect des autres usagers (ne pas surprendre), éviter d'être surpris."
              },
              {
                q: "Quels sont les avantages à vérifier l'absence d'usagers en angle mort avant un changement de trajectoire ?",
                r: "Permet d'assurer la sécurité en proximité immédiate du véhicule, permet de ne pas surprendre ou de ne pas être surpris."
              },
              {
                q: "Quels dangers peut provoquer un changement de direction non signalé ou signalé tardivement ?",
                r: "Induire les autres en erreur, les surprendre. Ils risquent de prendre une mauvaise décision et avoir un comportement inadéquat provoqué par le manque d'informations."
              }
            ]
          },
          comment: {
            a_traiter: "Comment et où regarder, comment et quand signaler ?",
            questions_ouvertes: [
              "Que connaissez-vous comme moyen de communication avec l'extérieur lorsque l'on circule en voiture ?",
              "Parmi ceux cités, quels sont les plus efficaces ? Les plus faciles à utiliser ?"
            ],
            info_plus: {
              titre: "Info + · Champ de vision, angles morts, rétroviseurs",
              conclusion: "Schéma illustrant le champ de vision, les angles morts et l'utilisation des rétroviseurs. Le contrôle en angle mort (par-dessus l'épaule) reste indispensable avant tout changement de file, même avec des rétros bien réglés."
            },
            savoir: [
              "Qu'est-ce qu'un angle mort ?",
              "Pourquoi et quand utiliser les rétroviseurs ?",
              "Pourquoi regarder en « balayant » l'environnement du véhicule ?",
              "Quels sont les moyens de communication à notre disposition ?"
            ],
            savoir_faire: [
              "Véhicule à l'arrêt, l'élève actionne sur indication du formateur toutes les commandes d'avertissement (3 exercices pour chacune, dans un ordre aléatoire). Aucune hésitation ne sera tolérée."
            ]
          },
          risques: {
            intro: "Partez d'une situation vécue pour faire ressortir un problème lié à l'absence de contrôles ou à l'absence des clignotants. Aidez l'élève à identifier les causes et les conséquences provoquées par ce mauvais choix de comportement. Le but : qu'il comprenne les risques liés à l'absence de contrôles et/ou de communication (ou à leur réalisation tardive) pour adopter un comportement sécuritaire.",
            directives: [
              "Les conducteurs ont souvent une vision erronée de leur conduite : « Je suis un bon conducteur parce que je n'ai jamais eu d'accident ». Mais combien d'accidents (sans impliquer ledit conducteur) ou de frayeurs a-t-il provoqués par l'absence de contrôle ou de clignotants ?"
            ],
            risques_listes: "Avez-vous vécu une situation d'accident ou de presque accident dont la principale cause a été l'oubli (ou la mise tardive) des clignotants, ou des contrôles ? Le fait d'avertir trop tôt ou trop tard génère-t-il un risque ? OUI - NON. Avez-vous une idée du nombre de conducteurs français qui oublient de mettre le clignotant ? 1/3 · 1/30 · 1/300 · 1/3000.",
            cas_observe: "Info + · 29 % des conducteurs ne mettent pas le clignotant lorsqu'ils dépassent et 45 % ne le mettent pas lorsqu'ils se rabattent (source SANEF 2019)."
          },
          influences: {
            intro: "Faites réfléchir votre élève sur la façon dont les personnes de son entourage gèrent leur changement de direction, pour qu'il puisse juger si sa pratique a été influencée ou non par la leur.",
            questions: [
              "Estimez l'efficacité des contrôles réalisés par des conducteurs de votre entourage : inefficaces (absents, faits après la mise du clignotant, sans contrôle d'angle mort) ou efficaces (réguliers, dans l'ordre, complets) ?",
              "À quelle fréquence les conducteurs de votre entourage utilisent-ils les clignotants ? (Jamais, de temps en temps, régulièrement, quand ils y pensent.)"
            ]
          },
          pressions: {
            intro: "Les gens qui ne communiquent pas leurs intentions n'ont pas d'excuses valables permettant d'expliquer ce comportement. Faire des contrôles et mettre les clignotants ne sont pas des tâches contraignantes à réaliser. Cela dépend juste du niveau de compréhension et de l'intérêt qu'a un conducteur pour les autres usagers.",
            nb: "Le fait que le conducteur se sente en sécurité dans sa « bulle » lui fait oublier que la route est un domaine partagé et que les profils des conducteurs sont nombreux et différents. Généralement, l'absence de clignotants provoque, selon le profil des autres usagers, du stress, de la colère (69 % des conducteurs injurient les autres conducteurs), de la confusion, de l'incompréhension… et assez fréquemment un accrochage ou un accident !",
            question_situations: "Connaissez-vous des situations ou professions qui rendraient impossible ou inutile l'utilisation des clignotants ?",
            situations_groupees: [
              {
                titre: "Professions",
                items: "Il n'existe aucune profession pouvant encourager ce choix…"
              },
              {
                titre: "Situations",
                items: "Une mauvaise installation ou une mauvaise position de conduite peut empêcher ou retarder la mise des clignotants."
              }
            ]
          }
        },
        points: [
          "Cycle visuel : loin > proche > rétros > tableau de bord, toutes les 8-10 s.",
          "Rétroviseur intérieur avant tout freinage, latéral avant tout déplacement latéral.",
          "Angles morts : contrôle de l'épaule avant changement de file.",
          "Clignotant : 3 s minimum AVANT action, jamais après. Vérifier qu'il s'éteint après.",
          "Klaxon : signal de danger, pas d'agacement. Phares : léger appel pour prévenir.",
        ],
        erreurs: [
          'Regarder fixement la voiture devant — tu rates les indices loin (feu, panneau).',
          "Oublier de remettre le clignotant à zéro — induit le suivant en erreur.",
        ],
        geste: 'Au feu : compte mentalement « 1-2-3 rétros » avant de redémarrer. Avant chaque changement de direction : clignotant, rétro, angle mort, action.',
        mnemo: '"CRAC" : Clignotant – Rétro – Angle mort – Contrôle final. Toujours dans cet ordre.',
        checklist: [
          "Toutes les 8-10 s je regarde loin puis rétros.",
          "Avant tout freinage, coup d'œil rétro intérieur.",
          "Avant tout changement de file : rétro latéral + contrôle angle mort par-dessus l'épaule.",
          "Je mets le clignotant 3 secondes AVANT toute manœuvre.",
          "Je vérifie qu'il s'est bien éteint après action.",
          "Je n'utilise le klaxon QUE pour signaler un danger, jamais pour râler.",
        ],
        attention: [
          "Regarder son smartphone 2 s à 90 km/h = 50 m parcourus à l'aveugle. Une salle de classe entière.",
          "Un rétroviseur bien réglé fait disparaître 80 % de l'angle mort — mais pas tout. L'épaule reste obligatoire.",
          "Un cycliste ou piéton qui te regarde N'A PAS forcément vu ta voiture — établis un contact visuel clair.",
          "Feux de détresse en roulant = danger immédiat devant (bouchon soudain sur autoroute).",
        ],
      },
      {
        i: 8,
        letter: 'i',
        titre: 'Effectuer une marche arrière et un demi-tour en sécurité',
        objectif: 'Manœuvrer en marche arrière et exécuter un demi-tour en toute sécurité.',
        // ── Trame REMC officielle (fidèle au livret C1i) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir prendre les informations et communiquer avec son entourage.",
            qr: [
              {
                q: "Quels sont les avantages à maîtriser le gabarit du véhicule ?",
                r: "Gérer le stationnement en créneau, épi, bataille, la circulation en rue étroite ou en angle, le stationnement dans un garage, parking souterrain (hauteur, largeur), les manœuvres comme le demi-tour, marche arrière, etc."
              },
              {
                q: "Quels sont les avantages à se retourner pour effectuer une marche arrière ?",
                r: "Meilleure visibilité, champ de vision plus large donc moins de surprise et moins de risque de blesser, meilleure perception de l'environnement."
              },
              {
                q: "Quels avantages et/ou inconvénients présentent la caméra de recul lors d'une marche arrière ?",
                r: [
                  "Avantages : complète et confirme les informations détectées en vision directe.",
                  "Inconvénients : peut faire perdre l'habitude de se retourner et de faire des contrôles en vision directe (changement de véhicule)."
                ]
              }
            ]
          },
          comment: {
            a_traiter: "Regard, position, allure, gabarit, sécurité.",
            savoir: [
              "Quelles précautions prendre pour effectuer une marche arrière sans caméra de recul ?",
              "Quelles précautions prendre pour effectuer une marche arrière avec caméra de recul ?",
              "Dans quels cas effectuer un demi-tour sur la chaussée est-il dangereux ? Interdit ?"
            ],
            savoir_faire: [
              "Effectuer une marche arrière, en ligne droite et en courbe, sans s'écarter ni se rapprocher exagérément de la bordure de la chaussée.",
              "Exécuter un demi-tour entre 2 trottoirs."
            ]
          },
          risques: {
            intro: "Le fait d'utiliser une expérience pour amener ce savoir va rendre l'apprentissage plus ludique et permettre à l'élève de se l'approprier plus facilement. Cela va l'aider à comprendre, au moyen de la mise en œuvre d'une pratique inadaptée, à choisir ce qui est le plus sécuritaire.",
            directives: [
              "Expérience : faites effectuer une marche arrière en ligne droite puis en slalom entre des piquets (style piquets moto ou poids lourd) avec la simple utilisation du rétroviseur intérieur (masquez la caméra de recul et déréglez les rétros extérieurs).",
              "Refaites le même exercice au moyen des rétroviseurs extérieurs uniquement puis en laissant l'élève se retourner."
            ],
            cas_observe: "Comment avez-vous vécu ces expériences ? Avez-vous rencontré des difficultés ? Selon vous, quel est le moyen le plus simple et le moins dangereux de réaliser une marche arrière ?",
            risques_listes: "Info + · Exécution d'une marche arrière ou d'un demi-tour sur autoroute : 135 € d'amende, retrait de 4 points, suspension de permis 3 ans maxi."
          },
          influences: {
            intro: "L'important est que l'élève puisse identifier ce qui se pratique dans son entourage afin de pouvoir poser une critique (positive et/ou négative) et en déduire le comportement qu'il souhaite adopter en retour.",
            questions: [
              "Y a-t-il des personnes dans votre entourage qui réalisent leur marche arrière uniquement au moyen du rétroviseur ?",
              "Connaissez-vous la raison de leur choix ? (Raisons médicales, non-conscience du danger, non-conscience de l'environnement, etc.)",
              "Quels sont les moyens retenus par votre entourage pour réaliser un demi-tour lorsque celui-ci s'impose ? (Dès que possible, attente d'une intersection, d'un rond-point, n'importe où si besoin…)"
            ]
          },
          pressions: {
            intro: "C'est en discutant de toutes ces différences de pratique, liées à des catégories de véhicules, que votre élève va comprendre les risques et inconvénients inhérents. Il devra alors adopter le bon comportement selon le type de véhicule conduit.",
            question_situations: "Questions à débattre :",
            situations: [
              "Existe-t-il des véhicules qui ne permettent pas de se retourner pour réaliser une marche arrière ? OUI - NON. (Camionnettes, véhicules utilitaires, bus, camions, camping-cars, certains véhicules de tourisme, etc.)",
              "Comment est alors assurée la sécurité ? En faisant le tour du véhicule avant de démarrer et en descendant du véhicule si besoin pendant la manœuvre. En s'aidant de caméra de recul, alarme de recul, radar de recul, rétro grand angle, et en roulant à très faible allure, etc."
            ]
          }
        },
        points: [
          "Avant : tour du véhicule pour vérifier l'absence d'obstacle / enfant.",
          "Pendant : regard principal vers l'arrière, complété par rétros et caméra.",
          "Vitesse très lente, embrayage au point de patinage seulement.",
          "Demi-tour : privilégier un rond-point, sinon un endroit dégagé avec visibilité 100 m des 2 côtés.",
          "Demi-tour en 3 temps : avancer + braquer, reculer + contre-braquer, avancer et rectifier.",
        ],
        erreurs: [
          'Reculer en ne regardant que la caméra — angle mort latéral.',
          "Demi-tour sur route bidirectionnelle sans visibilité claire des 2 côtés.",
        ],
        geste: 'Si tu doutes, descends, vérifie. Mieux vaut perdre 10 s que rayer ou blesser.',
        mnemo: '"Tour, tourne, TOUCHE" : Tour du véhicule, Tourne la tête, TOUCHE le point où tu vas te garer avec ton regard.',
        checklist: [
          "Je fais toujours le tour de la voiture AVANT une marche arrière (si je n'ai pas vu ce qui est derrière depuis 30 s).",
          "En reculant, ma main droite est sur l'appui-tête passager, je tourne la tête à droite.",
          "Ma vitesse est celle de la marche à pied, jamais plus.",
          "J'utilise le rétro central + les 2 latéraux + les capteurs éventuels.",
          "Un demi-tour se fait sur emplacement dégagé, avec 100 m de visibilité des 2 côtés.",
          "Je m'arrête immédiatement si je doute d'un obstacle.",
        ],
        attention: [
          "La caméra de recul déforme les distances : divise par 2 ce que tu vois.",
          "Enfants + marche arrière = angle mort mortel. Sortir et regarder, TOUJOURS, si des enfants sont proches.",
          "Demi-tour interdit : autoroute, voie rapide, sommet de côte, courbe sans visibilité.",
          "En marche arrière, le sens du volant est le MÊME qu'en marche avant (tu tournes à droite = tu vas à droite).",
        ],
      },
    ],
  },
  {
    code: 'C2',
    title: 'Appréhender la route',
    subtitle: 'et circuler dans des conditions normales',
    color: 'red',
    intro: "Tu maîtrises ta voiture. Maintenant tu apprends à coexister avec les autres : feux, panneaux, intersections, ronds-points. C2 c'est la grammaire de la route.",
    duree: '15 à 25 h de pratique',
    pre_requis: 'C1 acquise (maniement du véhicule maîtrisé en trafic faible).',
    lecons: [
      {
        i: 0,
        letter: 'a',
        titre: 'Rechercher la signalisation, les indices utiles et en tenir compte',
        objectif: 'Identifier, hiérarchiser panneaux, marquages et feux, et distinguer le signal du bruit visuel.',
        // ── Trame REMC officielle (fidèle au livret C2a) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à être attentif à la signalisation et aux différents indices routiers.",
            qr: [
              {
                q: "Citez quelques avantages à détecter et identifier à l'avance les panneaux.",
                r: "Anticipation, éviter de se faire surprendre."
              },
              {
                q: "Citez quelques inconvénients au fait de ne pas prêter une attention particulière à la réglementation routière.",
                r: [
                  "Rater une direction ou une information.",
                  "Risque de surprendre ou d'être surpris.",
                  "Risque de provoquer un accident."
                ]
              }
            ]
          },
          comment: {
            a_traiter: "Forme/panneaux, regard, observation, comportement.",
            questions_ouvertes: [
              "D'où peuvent venir les indices importants en circulation ? (Extérieur : avant, arrière, côtés du véhicule ; intérieur : bruit, voyants.)",
              "Quels sont les sens utiles à la détection d'indices en conduite ? (Vision principalement, ouïe, odorat, sens kinesthésique — vibrations.)",
              "Dessinez (forme et couleur) un panneau d'obligation, un panneau de danger, un panneau d'interdiction."
            ],
            info_plus: {
              titre: "Info +",
              conclusion: "Prévoir le danger au-delà du visible."
            },
            savoir: [
              "Quelles sont les significations de la forme, de la couleur et des symboles des panneaux ?",
              "Quelles sont les significations des feux et celles des gestes des forces de l'ordre ?",
              "Quelle est la signification des différents marquages au sol ?",
              "Citer deux indices relatifs à la route, à la voiture et aux autres usagers."
            ],
            savoir_faire: [
              "Détecter, reconnaître et interpréter la signalisation verticale et horizontale relative aux intersections, à la vitesse et à la position sur la chaussée (tolérance : dans 1 cas sur 5 au plus, le formateur donne une indication)."
            ]
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir l'importance de l'observation et démontrer la complémentarité de la détection et de l'identification de la signalisation. Le risque est généré par les conducteurs qui surestiment leurs capacités et conduisent de façon passive et individualiste.",
            directives: [
              "Beaucoup de conducteurs se limitent à une détection basique (voir sans regarder, regarder sans analyser, etc.) se sentant en sécurité dans leur bulle.",
              "Les conducteurs se bornent trop souvent à ne considérer que ce que l'autre usager est autorisé à faire (selon la réglementation)."
            ],
            risques_listes: "Avez-vous déjà vécu une situation où la non-perception d'un indice vous a mis en danger ?"
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les bons et mauvais comportements de son entourage. Cela va l'obliger à visualiser et à analyser une situation en prenant comme référence ce qu'il vient d'apprendre et comprendre.",
            questions: [
              "Connaissez-vous des situations qui font que l'on ne prête plus forcément attention à la signalisation et/ou aux indices utiles ? (Habitude d'un itinéraire, conducteur passif, stressé, fatigué, passagers qui détournent l'attention, peu ou pas de circulation, publicité sur le bord des routes, recherche d'un itinéraire.)",
              "Y a-t-il des similitudes avec les pratiques de conduite de votre entourage ?"
            ]
          },
          pressions: {
            intro: "L'accumulation de tâches peut provoquer une surcharge mentale (ex : se concentrer sur la conduite en recherchant un itinéraire, dans un véhicule que l'on conduit pour la première fois, avec deux enfants à l'arrière assez pressés d'arriver…). Si observer et analyser la signalisation et les indices deviennent une habitude, le conducteur sera plus apte à observer la route. Son regard sera habitué à balayer l'environnement et son cerveau à trier et analyser les informations pertinentes.",
            question_situations: "Questions à débattre :",
            situations: [
              "Citez des situations qui peuvent parasiter la recherche de signalisation et d'indices en conduite lors de déplacements professionnels : rythme et/ou itinéraire imposé, recherche de lieu, véhicule avec vitres obstruées par chargement et/ou passagers, véhicule dont on n'a pas l'habitude.",
              "Professions dont le véhicule ou aménagement du véhicule ne permettent pas une bonne perception d'indices sur la route ? Balayeuse (volant à droite), véhicule chargé, véhicules publicitaires (vision diminuée), etc."
            ]
          }
        },
        points: [
          'Priorité signalisation : feu > police > signal vertical > marquage au sol > règle générale.',
          'Panneaux temporaires (jaune fluo) priment sur les permanents (blanc).',
          'Indices forts : freinage devant, clignotant, regard du piéton, ballon qui roule.',
          'Hiérarchiser : ce qui peut me toucher dans 3 secondes prime.',
        ],
        erreurs: [
          'Suivre le GPS plutôt que le panneau « sens interdit » ajouté ce matin.',
          "Fixer son téléphone en navigation — perte de tous les indices en 2 s.",
        ],
        geste: "Regard porté à 80-100 m avant l'intersection. Le rétro intérieur est ton 6e sens : 1 coup d'œil toutes les 5-10 s.",
        mnemo: '"FPVM + BALAI" : Feu > Police > Vertical > Marquage pour la signalisation ; Bandes, Autre usager, Loin, Arrière, Instruments pour les indices.',
        checklist: [
          "Je repère les panneaux à 80-100 m, pas 10 m.",
          "En cas de contradiction, je prends la règle la PLUS restrictive.",
          "Je regarde le marquage au sol AU MÊME titre que les panneaux verticaux.",
          "Je détecte les feux stop 3-4 voitures devant moi.",
          "Je capte les clignotants activés à distance.",
          "Je regarde le rétro intérieur toutes les 5-10 s.",
        ],
        attention: [
          "Les feux clignotants oranges ne libèrent PAS de la priorité à droite classique.",
          "Un policier en carrefour prime sur tout : ses gestes remplacent le feu, même vert.",
          "Le smartphone en navigation détourne le regard 2 s = 50 m à 90 km/h. Une classe traversée à l'aveugle.",
          "Un enfant à côté d'un adulte sur trottoir est TOUJOURS imprévisible — vitesse divisée par 2.",
        ],
      },
      {
        i: 1,
        letter: 'b',
        titre: 'Positionner le véhicule sur la chaussée et choisir la voie de circulation',
        objectif: 'Choisir la bonne voie au bon moment et maintenir une trajectoire adaptée.',
        // ── Trame REMC officielle (fidèle au livret C2b) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir positionner le véhicule sur la chaussée et choisir la bonne voie pour circuler.",
            qr: [
              {
                q: "Citez des avantages et des inconvénients à bien positionner son véhicule sur la chaussée.",
                r: [
                  "Avantages : permet de communiquer ses intentions aux autres usagers (évite de les surprendre), gain de temps, fluidité du trafic, plus de cohérence avec l'environnement.",
                  "Inconvénients : exige un effort du conducteur pour agir correctement en prenant en considération les autres usagers."
                ]
              },
              {
                q: "La position sur la chaussée dépend-elle des lieux où l'on circule ? OUI - NON. Pourquoi la position du véhicule varie-t-elle sur la chaussée ?",
                r: "Elle varie selon : l'état et la largeur de la route ; les caractéristiques et gabarit des véhicules ; les situations (travaux, dépassements, places de stationnement, voies réservées)."
              }
            ]
          },
          comment: {
            a_traiter: "Signalisation/marquage au sol, réglementation, placements, prise en compte des autres, communication.",
            questions_ouvertes: [
              "Pourquoi doit-on rouler au milieu de sa voie ?",
              "Pourquoi dans un sens unique à 2 voies de circulation doit-on rouler dans celle de droite ?",
              "Pourquoi existe-t-il des voies réservées à certaines catégories d'usagers ? Citez-les."
            ],
            info_plus: {
              titre: "Info + · Sanctions",
              items: [
                "La circulation sans motif dans la voie de gauche sur route à 2 voies à sens unique est sanctionnée par une contravention de 2e classe (35 €).",
                "La circulation dans une voie réservée à une autre catégorie d'usagers est sanctionnée par une contravention de 4e classe (135 €)."
              ],
              conclusion: "Rappel : les voies réservées existent pour protéger les usagers vulnérables (bandes cyclables) ou fluidifier le trafic (couloirs bus)."
            },
            savoir: [
              "Comment reconnaît-on une voie réservée aux cyclistes et cyclomotoristes, aux véhicules lents, aux véhicules de transport en commun ?",
              "Qu'est-ce qu'une voie de stockage ?"
            ],
            savoir_faire: [
              "Choisir la voie dans laquelle circuler (au moins trois situations différentes) avec prise d'information pour ne pas gêner."
            ]
          },
          risques: {
            intro: "Aidez votre élève à comprendre les risques liés au mauvais choix de voie, ou au mauvais placement sur la chaussée.",
            directives: [
              "Mis à part la sanction, le moins « gênant » est la perte de temps entraînée par les véhicules qui utilisent à mauvais escient les voies réservées à d'autres catégories d'usagers…",
              "Le plus gros risque réside dans l'individualisme des conducteurs qui omettent bien souvent de prendre des précautions avant de faire un écart sur la chaussée ou de changer de voie.",
              "Ces « oublis » génèrent de graves conséquences chez les catégories les plus exposées (deux-roues)."
            ],
            risques_listes: "Quels sont les risques encourus si on ne circule pas dans la bonne voie ? Quels sont les risques encourus à la suite d'un mauvais positionnement sur la chaussée ? Voyez-vous d'autres inconvénients à ces mauvaises pratiques ?"
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les comportements de son entourage. Cela va l'obliger à visualiser et analyser différentes pratiques observées en comparaison de ce qu'il vient d'apprendre et comprendre. S'il est cycliste ou cyclomotoriste, vous pouvez élargir la réflexion à sa propre conduite et expérience.",
            questions: [
              "Dans votre entourage, circule-t-on parfois dans les voies réservées ? Pour quels motifs ?",
              "Pensez-vous que l'habitude joue un rôle dans les positionnements sur la chaussée ? (Oui, une bonne habitude perdure, une mauvaise aussi !)",
              "Cyclomotoristes : préférez-vous circuler dans une voie réservée à votre moyen de locomotion plutôt que sur la route avec toutes les autres catégories d'usagers ? Pourquoi ?",
              "Cyclistes : que pensez-vous des véhicules qui utilisent les bandes cyclables pour stationner ?"
            ]
          },
          pressions: {
            intro: "Aidez votre élève à avoir une vision plus large de la pratique des autres. C'est en observant et en analysant ce que font les autres qu'il va construire une partie de son expérience et choisir les comportements à adopter en retour.",
            question_situations: "Questions à débattre :",
            situations: [
              "Que pensez-vous des conducteurs qui abusent des voies réservées ? Leurs comportements vous incitent-ils à faire de même ?",
              "Trouvez-vous normal que les taxis puissent utiliser les voies réservées aux bus ? Précisez votre réponse."
            ]
          }
        },
        points: [
          'Voie de droite par défaut hors dépassement.',
          'Bandes de rive (continue / discontinue) : reste à 50 cm minimum.',
          "Présélection avant intersection : choix de voie au moins 100 m avant.",
        ],
        erreurs: ['Cheminement collé à la ligne médiane sur route bidirectionnelle.'],
        geste: 'Vise un point au sol à 2/3 de la largeur droite de ta voie.',
        mnemo: '"1/3 – 2/3" : Trajectoire dans le tiers droit de ta voie, jamais collée à la ligne blanche centrale.',
        checklist: [
          "Je roule sur la voie de droite par défaut, sauf pour dépasser.",
          "Je garde 50 cm mini avec la bande de rive à droite.",
          "Je choisis ma voie AU MOINS 100 m avant l'intersection.",
          "En 2 voies, je reste dans MA voie sans mordre la ligne pointillée.",
          "En courbe, ma trajectoire est stable, sans coupure de virage.",
        ],
        attention: [
          "Collé à la ligne blanche centrale = risque de miroir latéral cassé en croisant un camion.",
          "Sur autoroute, la voie du milieu N'EST PAS une voie de croisière — c'est un dépassement en cours.",
          "Voie de bus autorisée aux vélos ? La question à 2 secondes : y a-t-il un cycliste ? Sinon interdit.",
        ],
      },
      {
        i: 2,
        letter: 'c',
        titre: "Adapter l'allure aux situations",
        objectif: 'Moduler la vitesse selon la complexité réelle, pas seulement le panneau.',
        // ── Trame REMC officielle (fidèle au livret C2c) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à adapter l'allure de son véhicule aux différentes situations rencontrées. N.B. : cette compétence requiert une attention particulière — les 18/24 ans sont très touchés par les accidents liés à la vitesse. Dans la mesure du possible, organisez une séance en salle avec un groupe d'élèves pour traiter risques, influences et pressions liés à cette compétence. Vous pouvez également utiliser les exercices, aides et arguments exposés en C1e et C3a.",
            qr: [
              {
                q: "Quels sont les avantages à rouler vite ?",
                r: "Se faire plaisir, impression de « renforcer l'image sociale » (vitesse = maîtrise)."
              },
              {
                q: "Quels sont les inconvénients à respecter les limitations de vitesse ?",
                r: "Aucun. Si ce n'est d'accepter de faire l'effort de partager la route..."
              }
            ]
          },
          comment: {
            a_traiter: "Observer, analyser, adapter son comportement.",
            questions_ouvertes: [
              "Qu'est-ce qu'adapter l'allure ? Changer le rythme, ralentir, freiner, accélérer (en gardant à l'esprit de pouvoir s'arrêter à temps).",
              "Qu'est-ce qui peut obliger à réduire l'allure ? La réglementation, certaines situations (météo, trafic, type de routes, capacité du véhicule et/ou du conducteur, configuration des lieux, visibilité, etc.).",
              "Quelle est la différence entre un excès de vitesse et une vitesse excessive ? L'excès est au-dessus des limitations réglementaires ; la vitesse excessive est inadaptée aux circonstances, même en respectant la réglementation.",
              "Calcul rapide des distances d'arrêt par temps sec : à 50 km/h → 15 + 10 = 25 m ; à 100 km/h → 30 + 70 = 100 m."
            ],
            info_plus: {
              titre: "Info + · Distances d'arrêt et énergie cinétique",
              items: [
                "Énergie cinétique — en poussant de tout son poids = 70 kg. En prenant de l'élan, la force potentielle atteint ~700 kg.",
                "Distances d'arrêt (temps de réaction 1 s) — 50 km/h : 26 m sec / 38 m mouillé · 70 km/h : 43 / 67 · 90 km/h : 64 / 104 · 110 km/h : 90 / 149 · 130 km/h : 119 / 202 m.",
                "Décélération sur sol sec : voiture 8 m/s² · autocar 6 m/s² · Formule 1 20 m/s².",
                "Équivalent choc en tonnes : à l'arrêt 1 t · à 50 km/h 10 t · à 90 km/h 32 t."
              ],
              conclusion: "La vitesse est estimée responsable d'environ 1 tué sur 3 — 1re cause de mortalité chez les 15/24 ans (accident sans tiers, responsabilité présumée)."
            },
            savoir: [
              "Quelles sont les prescriptions relatives aux limitations générales de la vitesse ?",
              "Peut-on toujours rouler à la vitesse maximale autorisée ?",
              "Quelles situations nécessitent de ralentir ?"
            ],
            savoir_faire: [
              "Ralentir suffisamment en présence d'autres usagers, notamment piétons et deux-roues.",
              "Adapter l'allure avant une intersection (priorité à droite, céder le passage, feux tricolores) avec ou sans visibilité."
            ]
          },
          risques: {
            intro: "Lancer une réflexion sur ce qu'est un accident, comment il survient, s'il est évitable. Définition possible : un accident est le résultat d'un enchaînement de situations mal ou non gérées par un ou plusieurs conducteurs — point de départ : un mauvais choix de comportement pouvant découler d'une mauvaise analyse et/ou d'une vision erronée du risque.",
            directives: [
              "Certains font des excès de vitesse, mais nombreux sont ceux qui roulent à des vitesses excessives.",
              "Prendre des risques en roulant vite peut être assimilé à un comportement ordalique.",
              "Les véhicules sont conçus pour résister à des chocs à une vitesse ≤ 55 km/h. Au-delà, malgré la sécurité active/passive, le corps humain et les organes internes ne peuvent plus être correctement protégés."
            ],
            risques_listes: "Sur une échelle de 0 (risque inexistant) à 3 (risque maximum), évaluez le risque lié à une allure excessive puis à un excès de vitesse. Justifiez. Vous estimez la vitesse responsable d'environ : 1 tué sur 3, 1 sur 30 ou 1 sur 300 ? Selon vous, quelle est la 1re cause de mortalité chez les 15/24 ans ? Dans quelle circonstance ? Quelles images associez-vous à la vitesse ?"
          },
          info_plus: {
            titre: "Info + · Ordalie",
            texte: "Qu'est-ce que l'ordalie ? La prise de risque est nécessaire au développement et fonctionnement d'un individu. L'ordalie est une forme de prise de risque, arbitrée par le destin. Exemple : « Run sauvage » — remonter une voie express à contresens de nuit, tous feux éteints, à plusieurs véhicules."
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les comportements de son entourage. Cela va l'obliger à visualiser et analyser différentes pratiques observées en comparaison de ce qu'il vient d'apprendre. L'influence de l'entourage ou d'un groupe peut amener à faire ou dire des choses allant à l'encontre de nos convictions — cet ascendant est à garder à l'esprit afin de réfléchir à « comment le gérer ! »",
            questions: [
              "Les personnes de votre entourage : adaptent leur vitesse aux circonstances ? Roulent toujours lentement ? Roulent vite parce qu'elles maîtrisent ? Roulent trop vite ?",
              "Vous est-il arrivé d'encourager un conducteur à rouler plus vite ? Pour quelles raisons ?"
            ]
          },
          pressions: {
            intro: "Laissez votre élève s'exprimer librement sur les pressions exercées par la société (publicité, travail…). Certains véhicules ont été étudiés pour gagner du temps dans la circulation (gyrophare, sirène, couleur voyante — véhicules d'urgence) ; d'autres non (livreurs, commerciaux). Que risquent réellement ces professionnels « pressés » s'ils respectent les limitations : perdre du temps, donc gagner moins ? Si l'on considère les risques (collision, sanctions), le stress, la fatigue (coût médical), la pollution et l'usure mécanique (frais) en regard d'un gain de quelques minutes… où se situe réellement la perte financière ?",
            question_situations: "Idées reçues à débattre :",
            situations: [
              "« Je conduis bien, donc je peux rouler vite. » — Bien conduire, c'est rechercher des indices et anticiper ; ce n'est pas rouler vite !",
              "Que pensez-vous de l'expression « Le temps c'est de l'argent ! » ?",
              "Connaissez-vous des professions qui requièrent d'être rapide sur la route ?"
            ]
          }
        },
        points: [
          'Approche carrefour, école, piétons, deux-roues : -20 km/h par rapport à la limite.',
          "Sortie de courbe sans visibilité : réduire AVANT la courbe.",
          "Pluie soudaine : -20 % minimum.",
        ],
        erreurs: ['Reprendre la vitesse limite dès la fin du virage sans vérifier ce qui sort.'],
        geste: "En zone scolaire, regarde les trottoirs en premier, pas ta vitesse.",
        mnemo: '"-20 en approche" : Zone piétonne, école, sortie de courbe = -20 km/h vs limite. Toujours.',
        checklist: [
          "Je ralentis de -20 km/h à l'approche d'école, marché, zone piétonne.",
          "En sortie de courbe sans visibilité, je ralentis AVANT la courbe.",
          "Sur pluie, je réduis de 20 % ma vitesse.",
          "Je ne reprends jamais la vitesse limite « par principe » — j'analyse la scène.",
          "La nuit, en ville, je roule à 40 max même en zone 50.",
        ],
        attention: [
          "Aux entrées d'agglomération, la première voiture ralentit rarement — sois précurseur.",
          "Une vitesse trop basse (< 20 km/h sous la limite) sans raison = danger pour le suivant.",
          "Radar « pédagogique » : ta vitesse s'affiche. Sert à corriger, pas juste à s'agacer.",
        ],
      },
      {
        i: 3,
        letter: 'd',
        titre: 'Détecter, identifier et franchir les intersections suivant le régime de priorité',
        objectif: 'Réussir feux, stops, cédez et intersections en respectant le régime de priorité en vigueur.',
        // ── Trame REMC officielle (fidèle au livret C2d) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à être attentif à la signalisation et aux différents indices routiers en rapport avec les intersections.",
            qr: [
              {
                q: "Citez des inconvénients au fait de détecter tardivement une intersection.",
                r: [
                  "Pas d'adaptation d'allure.",
                  "Risque de se faire surprendre par le régime de priorité et/ou la présence d'éventuels usagers.",
                  "Risque de surprendre des usagers par une allure inadaptée."
                ]
              },
              {
                q: "Citez un inconvénient au fait de ne pas connaître les règles de priorité.",
                r: "L'impossibilité de circuler sans provoquer gêne ou accident."
              },
              {
                q: "Citez les avantages au fait de pouvoir immédiatement interpréter la signification d'un panneau de priorité.",
                r: "L'anticipation et l'adaptation de l'allure et du comportement."
              }
            ]
          },
          comment: {
            a_traiter: "Détecter, identifier, communiquer, se placer.",
            questions_ouvertes: [
              "Qu'est-ce que « détecter », « identifier » une intersection ?",
              "Citez un ou plusieurs indices permettant la détection d'une intersection.",
              "Demandez à votre élève de dessiner les panneaux relatifs aux intersections (mémorisation par le dessin)."
            ],
            info_plus: {
              titre: "Info + · R412-31",
              items: [
                "Tout conducteur doit marquer l'arrêt devant un feu de signalisation jaune fixe, sauf dans le cas où, lors de l'allumage dudit feu, il ne peut plus arrêter son véhicule dans des conditions de sécurité suffisantes.",
                "Contravention de 2e classe."
              ],
              conclusion: "Rappel : les refus de priorité sont à l'origine d'environ 17 % des décès routiers (2021)."
            },
            savoir: [
              "Comment identifier une intersection ?",
              "Pourquoi ne doit-on pas s'engager dans une intersection encombrée ?"
            ],
            savoir_faire: [
              "Sur un parcours d'une dizaine de minutes : détecter en temps utile les intersections.",
              "Évaluer la visibilité, la distance et la vitesse des autres usagers.",
              "Ajuster l'allure aux circonstances.",
              "Reconnaître et appliquer les règles de passage.",
              "Utiliser les avertisseurs si nécessaire. Aucune erreur ou hésitation dangereuse ne sera tolérée."
            ]
          },
          risques: {
            intro: "Les refus de priorité sont à l'origine de nombreux décès routiers (17 % en 2021). Deux explications :",
            directives: [
              "Psychologique : risque « pratique » — refuser la priorité, passer à l'orange, glisser un stop ou accélérer permet en apparence de résoudre un problème de retard. Même si le conducteur sait que le temps perdu ne peut être regagné, la prise de risque est justifiée par l'apparence du gain de temps.",
              "Physiologique : tache aveugle (tache de Mariotte) — lors du franchissement d'une intersection, le conducteur peut ne pas voir un véhicule (non-perception due à la zone du champ visuel où les objets ne sont pas vus)."
            ],
            risques_listes: "Citez des causes qui peuvent être à l'origine d'un accident en intersection : non-respect de la priorité (pas d'arrêt au stop ou aux feux) — facteur principal ; mauvaise interprétation du régime de priorité ; peu de visibilité ; mauvaise communication (placement/clignotant) ; mauvaise évaluation de l'allure d'un véhicule en approche ; non prise en compte des autres usagers ; surestimation des capacités du véhicule ou du conducteur. Différence entre « marquer un stop » (immobiliser le véhicule pour permettre contrôles et analyse) et « glisser un stop » (ralentir au maximum sans immobilisation — donc griller le stop) ? À l'orange l'arrêt est-il facultatif ou obligatoire (R412-31) ? Connaissez-vous des catégories d'usagers non obligées de s'arrêter aux feux rouges ? (Cyclistes si panneau sous le feu ; véhicules d'intervention d'urgence en intervention.)"
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les comportements de son entourage. Le non-arrêt au stop fait partie des défauts observés chez certains élèves qui reproduisent simplement un comportement longuement observé sans comprendre qu'il s'agit d'une erreur.",
            questions: [
              "Dans votre entourage, qu'est-ce qui est le plus pratiqué : marquer le stop ou « glisser le stop » ?",
              "Que font les personnes de votre entourage lorsqu'elles arrivent à une intersection dont le feu est orange ? Ils passent en général, parfois, s'arrêtent toujours ?",
              "Pensez-vous que la taille de la ville a une importance sur le nombre d'accidents mortels en intersection ? OUI – NON."
            ]
          },
          pressions: {
            intro: "« Gagner du temps », voici le mot d'ordre de notre société ! Mais à quel prix et au détriment de quoi ? Ne pas s'arrêter au stop ou au feu représente-t-il un gain de temps si important que l'on est prêt à blesser ou tuer ? Amorcez une réflexion sans jugement et amenez l'élève à faire évoluer sa position en considérant la situation selon différents acteurs.",
            question_situations: "Situations à débattre :",
            situations: [
              "Les véhicules dits prioritaires doivent-ils respecter les règles de priorité aux intersections ? Non s'ils sont en intervention, mais ils doivent s'assurer qu'ils peuvent passer en sécurité.",
              "Le gabarit de votre véhicule peut-il influencer votre comportement aux intersections ? Plus il est important, plus le sentiment de sécurité est fort — ce qui peut influencer certains conducteurs.",
              "Pour certaines professions, l'arrêt au stop ou au feu orange peut-il représenter une perte de temps conséquente sur le respect d'horaires imposés ?"
            ]
          }
        },
        points: [
          "Priorité à droite : par défaut en l'absence de signalisation.",
          'STOP : arrêt absolu derrière la ligne, roue immobile comptée « 1-2 ».',
          "Cédez le passage : ralentir + regarder, arrêt SEULEMENT si un véhicule est prioritaire.",
          "Feu jaune : tu freines, sauf si freinage dangereux pour l'arrière.",
        ],
        erreurs: ['Confondre « cédez le passage » et « stop » — le stop impose l\'arrêt COMPLET.'],
        geste: 'Au STOP, roue arrêtée + gauche-droite-gauche, PUIS on repart.',
        mnemo: '"STOP = STOP" : Stop = roue immobile comptée "1-2". Cédez = ralentir + regarder + arrêt si prioritaire.',
        checklist: [
          "Je respecte la priorité à droite en l'absence de signalisation.",
          "Au STOP, ma roue s'arrête COMPLÈTEMENT avant de repartir.",
          "Au feu jaune, je freine sauf si dangereux pour le véhicule arrière.",
          "Je regarde gauche-droite-gauche avant de franchir un cédez.",
          "Je m'engage seulement si la voie est libre sur les 5 secondes à venir.",
        ],
        attention: [
          "Cédez le passage = ralentir + regarder, arrêt SEULEMENT si nécessaire.",
          "STOP avec ligne blanche large : arrêt AVANT la ligne, pas dessus.",
          "Aux feux, la voiture qui redémarre trop vite au vert = piège si un piéton court encore.",
        ],
      },
      {
        i: 4,
        letter: 'e',
        titre: 'Tourner à droite et à gauche en agglomération',
        objectif: 'Engager une intersection sans pénaliser le trafic ni se mettre en danger.',
        // ── Trame REMC officielle (fidèle au livret C2e) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir préparer et réaliser un changement de direction en sécurité. Citez les inconvénients des situations vécues — vous pouvez dessiner (ou faire dessiner) rapidement ces situations pour une meilleure visualisation.",
            qr: [
              {
                q: "Qu'est-ce qu'une intersection ?",
                r: "Lieu de jonction ou de croisement à niveau de deux ou plusieurs chaussées, quels que soient les angles des axes des chaussées. Routes qui se coupent."
              },
              {
                q: "À quoi sert une intersection ?",
                r: "À permettre à des flux de circulation issus de directions différentes de se croiser, se rejoindre ou se séparer."
              },
              {
                q: "Doit-on informer les autres usagers de notre intention de changer de direction ? Pourquoi ?",
                r: "Oui — sinon on met en danger particulièrement les deux-roues lents et rapides, moins voyants du fait de leur gabarit."
              }
            ]
          },
          comment: {
            a_traiter: "Préparer le changement de direction, communiquer, se placer, changer de direction en sécurité.",
            questions_ouvertes: [
              "Quelles précautions doit-on prendre avant de changer de direction ?",
              "Pourquoi est-il important de signaler au bon moment ?",
              "Pourquoi est-il important de positionner correctement le véhicule ?"
            ],
            info_plus: {
              titre: "Info + · Sanctions et statistiques",
              items: [
                "Un changement de direction sans avertir est sanctionné par 35 € et un retrait de 3 points sur le permis.",
                "Malgré une amélioration significative du comportement de conduite, 34 % des Français oublient de signaler leurs intentions avant de changer de direction.",
                "16 % des accidents mortels ont au moins une cause liée au non-respect des règles de circulation (source APAM — Bilan SR 2020, impact pandémie inclus)."
              ],
              conclusion: "Un placement communique une intention : c'est un langage silencieux, à combiner avec le clignotant."
            },
            savoir: [
              "Quelles précautions prendre avant un changement de direction ?",
              "Pourquoi signaler au bon moment ?",
              "Pourquoi positionner correctement son véhicule ?"
            ],
            savoir_faire: [
              "En intersections classiques (pas de giratoire), changer de direction à droite et à gauche dans trois situations différentes :",
              "— observer et respecter la signalisation ;",
              "— observer les autres usagers ;",
              "— signaler au moment opportun ;",
              "— adapter allure et trajectoire ;",
              "— respecter la règle de passage."
            ]
          },
          risques: {
            intro: "Beaucoup de conducteurs n'ont pas encore compris l'utilité et l'importance de la communication lors des changements de direction. Les placements sont eux aussi souvent faits « au petit bonheur la chance ». Amorcez une discussion sur les risques liés aux changements de direction non signalés. Laissez l'élève présenter ses opinions et arguments.",
            directives: [
              "Les catégories d'usagers les plus gravement accidentées à cause de la « non-mise des clignotants » sont tous les deux-roues (lents et rapides) — moins voyants du fait de leur gabarit.",
              "Un placement peut à lui seul communiquer une intention : mal positionné, il induit les autres en erreur."
            ],
            risques_listes: "Quelles sont les catégories d'usagers les plus gravement accidentées à cause de la non-mise des clignotants ? Pourquoi ? Peut-on considérer qu'un placement communique une intention ? Quels risques présentent des situations où le clignotant est mis trop tard, trop tôt, ou pas du tout ?"
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les comportements de son entourage. Proposez un travail sur les idées reçues — utilisez-les pour comprendre que nos mauvais comportements trouvent toujours des justifications qui évitent de prendre nos responsabilités. Il est intéressant que l'élève se positionne en trouvant une contre-argumentation.",
            questions: [
              "Pensez-vous que les conducteurs de votre entourage : communiquent correctement leurs intentions ? Parfois ? Pas assez ? Jamais ? Voyez-vous une raison à cela ?",
              "Sont-ils conscients des risques en ne communiquant pas leurs intentions ?",
              "Peut-on associer le fait de mettre les clignotants au fait d'être poli et courtois dans la vie de tous les jours ?",
              "Idées reçues à contre-argumenter : « Moi je n'ai pas besoin de mettre le clignotant, parce que je sais où je vais ! » et « Je ne mets pas le clignotant en ville, c'est trop contraignant ! »"
            ]
          },
          pressions: {
            intro: "On considère qu'un conducteur est expérimenté lorsqu'il a parcouru 100 000 km — il a été confronté à beaucoup de situations qui ont développé son anticipation. Mais l'acquisition d'expérience a des côtés pervers : plus les conducteurs accumulent d'expérience, plus ils tendent à penser qu'ils sont de bons conducteurs. Ils « aménagent leur conduite à leur sauce » — aménagements fonction de leur conscience du risque et de leur représentation de ce qu'est un bon conducteur : eux !",
            question_situations: "Questions à débattre :",
            situations: [
              "Connaissez-vous des professions qui obligent un emploi répété des clignotants ? (Facteur, livreur, coursier, professionnel de la route, etc.)",
              "Pensez-vous qu'un conducteur expérimenté puisse se passer des clignotants ?"
            ]
          }
        },
        points: [
          "À droite : serrer la droite, vérifier piétons et deux-roues, clignotant, contrôle angle mort.",
          "À gauche : se positionner près de l'axe, contrôle rétro + angle mort, céder aux véhicules en face.",
          "Toujours laisser passer les piétons engagés sur le passage.",
        ],
        erreurs: ['Tourner à gauche en coupant la trajectoire d\'une voiture en face.'],
        geste: 'Si en doute sur la priorité, immobilise au lieu de t\'engager à demi.',
        mnemo: '"CRAC" : Clignotant – Rétros – Angle mort – Contrôle final. Toujours dans cet ordre avant d\'engager.',
        checklist: [
          "Je mets le clignotant 3 s AVANT toute manœuvre.",
          "À droite, je serre à droite et je vérifie piétons + cyclistes.",
          "À gauche, je me positionne près de l'axe médian de ma voie.",
          "Je laisse toujours passer les piétons engagés.",
          "En doute sur la priorité, je m'immobilise plutôt que d'y aller à moitié.",
        ],
        attention: [
          "Tourner à gauche : le vrai danger vient d'EN FACE (voiture qui accélère) ET de derrière (moto qui remonte).",
          "À droite : angle mort MASSIF côté droit — un cycliste peut être invisible même avec rétro correct.",
          "Un piéton engagé sur le passage a priorité, MÊME si le feu passe au vert pour toi.",
        ],
      },
      {
        i: 5,
        letter: 'f',
        titre: 'Franchir les ronds-points et les carrefours à sens giratoire',
        objectif: 'Aborder, circuler et sortir d\'un rond-point en toute sécurité.',
        // ── Trame REMC officielle (fidèle au livret C2f) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir différencier et utiliser un rond-point ou un sens giratoire correctement.",
            qr: [
              {
                q: "Quels sont les avantages à utiliser le clignotant dans un rond-point ?",
                r: "Évite de surprendre les autres usagers, informe de ses intentions, permet d'anticiper, fluidifie le trafic."
              },
              {
                q: "Quels sont les inconvénients à respecter les placements ?",
                r: "Aucun."
              },
              {
                q: "Quels sont les avantages d'un sens giratoire par rapport à une intersection traditionnelle ?",
                r: "Il fluidifie le trafic, offre une meilleure visibilité, casse l'allure des conducteurs trop rapides, réduit les accidents, brasse un flot de véhicules plus important."
              }
            ]
          },
          comment: {
            a_traiter: "Préparer un changement de direction à l'aide d'un îlot circulaire, communiquer, se placer, changer de direction en sécurité, signaler sa sortie.",
            questions_ouvertes: [
              "Quelle est la différence entre un rond-point et un carrefour à sens giratoire ? Ils ont tous les deux le même aspect. Dans le sens giratoire, la priorité est donnée aux usagers circulant sur l'anneau. Dans un rond-point, la priorité est donnée aux usagers qui veulent entrer sur l'anneau.",
              "Quelle signalisation annonce un carrefour à sens giratoire ?",
              "Quels sont les placements à adopter en fonction de la direction choisie ?"
            ],
            info_plus: {
              titre: "Info + · R412-9",
              items: [
                "Un conducteur qui pénètre sur un carrefour à sens giratoire… peut serrer à gauche."
              ],
              conclusion: "Différencier rond-point (priorité à droite, aux entrants) et sens giratoire (priorité à l'anneau) est essentiel — le conducteur habitué aux giratoires peut être surpris par un rond-point."
            },
            savoir: [
              "Quelle est la différence entre un rond-point et un carrefour à sens giratoire ?",
              "Quelle signalisation annonce un carrefour à sens giratoire ?",
              "Quels sont les placements à adopter en fonction de la direction choisie ?"
            ],
            savoir_faire: [
              "Franchir et changer de direction dans un carrefour à sens giratoire (au moins trois situations différentes) et, si possible, dans un rond-point :",
              "— en respectant la règle de passage,",
              "— en signalant au moment opportun,",
              "— en adaptant allure et trajectoire."
            ]
          },
          risques: {
            intro: "Les giratoires ont envahi le réseau routier français — et pour cause : beaucoup plus sûrs qu'une intersection traditionnelle. Ils offrent une meilleure visibilité, fluidifient le trafic et gèrent plusieurs directions à la fois. Le conducteur habitué aux giratoires peut être surpris par les ronds-points (priorité aux usagers entrants donc à droite). Il est important de savoir différencier les deux.",
            directives: [
              "Le seul problème rattaché aux ronds-points réside dans la perte de temps occasionnée par des conducteurs qui ne signalent pas leurs intentions ou n'observent pas les placements d'usage.",
              "Les mauvais placements et l'absence de communication peuvent parasiter le rôle du sens giratoire."
            ],
            risques_listes: "Quels usagers sont les plus vulnérables lors du franchissement d'un giratoire ? Pourquoi ? Selon vous, la « non-mise des clignotants » concerne environ : 1/8 · 1/3 · 1/2 conducteur ? Pensez-vous qu'un carrefour à sens giratoire offre plus de sécurité qu'une intersection traditionnelle ? Expliquez."
          },
          influences: {
            intro: "Aidez votre élève à passer en revue les comportements de son entourage. Cela va l'obliger à visualiser et analyser les différentes pratiques observées en comparaison de ce qu'il vient d'apprendre.",
            questions: [
              "Dans votre entourage, fait-on une différence entre rond-point et sens giratoire ?",
              "Évaluez la pratique de votre entourage relative à la circulation dans un giratoire : bon placement et bonne communication ; placement au petit bonheur la chance avec peu de communication ; aucun effort de placement ou de communication ?",
              "Pourquoi selon vous ?"
            ]
          },
          pressions: {
            intro: "Chauffeur routier la semaine, motard ou automobiliste les week-ends… Livreur de plis express à scooter à l'année et camping-cariste avec remorque 3 semaines en août… Les exemples qui obligent le conducteur à s'adapter à un autre véhicule ne manquent pas.",
            question_situations: "Situations à débattre :",
            situations: [
              "Quelles catégories d'usagers peuvent présenter des particularités de placement dans certains giratoires ?",
              "Poids lourds, convois exceptionnels, grands camping-cars, véhicules articulés, ensembles de véhicules (gabarit).",
              "Scooters (peuvent rester placés sur l'anneau extérieur dans les grands sens giratoires).",
              "Cyclistes (la bande cyclable est placée sur l'anneau extérieur).",
              "Usagers qui ne connaissent pas à l'avance leur destination (restent sur l'anneau extérieur)."
            ]
          }
        },
        points: [
          "Rond-point moderne : céder à celui QUI EST DEDANS.",
          "Ancien « carrefour à sens giratoire » : priorité à droite (rare mais existant, panneau spécifique).",
          "Sortie : clignotant droit AVANT la sortie précédente pour prévenir.",
          "Voie extérieure = 1re sortie ; voie intérieure = plus de la moitié du tour.",
        ],
        erreurs: ['Confondre rond-point et carrefour à sens giratoire ancien (priorité à droite).'],
        geste: 'Sortie de rond-point : clignotant 1 seconde après l\'entrée de la sortie précédente.',
        mnemo: '"DEDANS PRIORITAIRE" : Rond-point moderne = celui qui est DEDANS est prioritaire. Sortie = clignotant droit.',
        checklist: [
          "En rond-point, je cède à celui QUI EST DEDANS.",
          "Je mets le clignotant droit avant la sortie du rond-point.",
          "Je choisis la voie extérieure pour la 1re sortie, intérieure pour les sorties lointaines.",
          "Je vérifie l'angle mort avant de changer de voie dans le giratoire.",
          "En sortant, je vérifie qu'aucun cycliste ne longe l'anneau extérieur.",
        ],
        attention: [
          "Rond-point ≠ « carrefour à sens giratoire » ancien. L'ancien = priorité à droite (rare).",
          "Un cycliste ou piéton peut être invisible dans le giratoire — angles morts vitaux.",
          "Bloquer un giratoire = amende + trafic bloqué. Anticipe ta sortie.",
        ],
      },
      {
        i: 6,
        letter: 'g',
        titre: "S'arrêter et stationner en épi, en bataille et en créneau",
        objectif: 'Réussir créneau, bataille et épi en évaluation et en usage quotidien.',
        // ── Trame REMC officielle (fidèle au livret C2g) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir réaliser différentes manœuvres pour stationner.",
            qr: [
              {
                q: "Quels sont les avantages à signaler un arrêt pour manœuvrer ?",
                r: "Informer les autres usagers en amont, réduire le risque de collision arrière, sécuriser les piétons et deux-roues à proximité."
              },
              {
                q: "Quels sont les inconvénients liés à la non-maîtrise de toutes les manœuvres ?",
                r: "Renoncer à des places disponibles, s'exposer à des situations bloquantes, perdre en autonomie, risquer des dégâts matériels."
              },
              {
                q: "Quels avantages présente l'aide active au stationnement ?",
                r: "Alerter en cas d'obstacle, faciliter la manœuvre, réduire le risque d'accrochage — mais ne dispense JAMAIS des contrôles visuels du conducteur."
              }
            ]
          },
          comment: {
            a_traiter: "Rechercher une place de stationnement, signaler son intention au bon moment, manœuvrer, sortir du véhicule en sécurité, entrer dans le véhicule en sécurité, sortir d'un stationnement en sécurité.",
            questions_ouvertes: [
              "Suis-je en arrêt ou en stationnement ? — Devant la boulangerie pour une baguette : STATIONNEMENT. Dépôt d'un colis moteur tournant : STATIONNEMENT. Déposer mon fils à l'école : ARRÊT.",
              "Remettre ce texte dans l'ordre : 1 – manœuvre · 2 – je cherche une place · 3 – je signale mon intention · 4 – j'ouvre la porte pour descendre · 5 – je vérifie que l'espace est libre avant de sortir · 6 – je m'arrête pour entamer la manœuvre. Ordre correct : 2 – 3 – 6 – 1 – 5 – 4."
            ],
            info_plus: {
              titre: "Info + · Sanctions",
              items: [
                "Arrêt ou stationnement au-delà du temps réglementaire : 35 € d'amende.",
                "Arrêt ou stationnement très gênant : 135 € d'amende avec mise en fourrière possible.",
                "Arrêt ou stationnement dangereux : 135 € d'amende, -3 points, suspension du permis possible (R417-9).",
                "Marche arrière : chaque année, des piétons (enfants et personnes âgées en majorité) sont tués lors de manœuvres en marche arrière — sortie d'emplacement de parking (parkings de centres commerciaux), sortie de garage au domicile."
              ],
              conclusion: "Une manœuvre en marche arrière exige un balayage visuel complet ET, si possible, de sortir marcher pour vérifier l'arrière."
            },
            savoir: [
              "Quelle est la différence entre l'arrêt et le stationnement ?",
              "Quelles sont les règles concernant le stationnement en agglomération ?",
              "Citez deux exemples de stationnement dangereux ? De stationnements gênants ?"
            ],
            savoir_faire: [
              "Ranger en sécurité la voiture en épi (avant et arrière), en bataille (avant et arrière), dans un créneau à droite et à gauche de la chaussée."
            ]
          },
          risques: {
            intro: "Lorsque l'on envisage le risque routier, on pense généralement aux accrochages/accidents — et peu aux conséquences des situations d'attente. Pourtant, la frustration (liée à l'impossibilité de changer les choses) peut amener énervement, colère et déboucher sur une forme de violence verbale et parfois physique. La colère et la frustration prennent alors le pas sur la réflexion : le conducteur n'est plus apte à assurer la sécurité autour de son véhicule.",
            directives: [
              "N.B. : les risques sont plus importants en SORTANT d'un stationnement — il faut s'intégrer au trafic (créneau) ou avoir constamment des yeux derrière la tête (bataille en marche avant).",
              "Étude de cas : vous cherchez une place depuis 20 minutes, le parking est plein, vous arrivez devant cette situation… que ressentez-vous ?"
            ],
            risques_listes: "Énumérez les risques liés aux manœuvres : lors de la recherche d'une place ; lors de la manœuvre ; pour quitter le véhicule ; pour quitter le stationnement. Sont-ils identiques quelle que soit la manœuvre ? Est-il préférable de stationner en marche avant ou en marche arrière ?"
          },
          influences: {
            intro: "Le choix du lieu d'habitation ou du mode de vie va avoir une incidence directe sur le besoin, la motivation et la dextérité liée à la réalisation des manœuvres.",
            questions: [
              "Habitez-vous une grande ville, une petite agglomération, à la campagne ?",
              "En arrivant chez vous : facile de stationner (garage, place réservée, place proche) ? Parfois pas simple (événements avec fermeture de rue, pas de place dans le quartier) ? Systématique de tourner jusqu'à trouver une place ?",
              "Lorsque vous allez en ville, votre entourage : stationne dès qu'il trouve une place ? A une préférence pour un type de manœuvre et cherche en rapport ? Préfère les transports en commun pour éviter les manœuvres ? Utilise l'intermodalité (différents moyens de locomotion) ?"
            ]
          },
          pressions: {
            intro: "Proposez un débat sur l'utilité de respecter les places réservées. Aidez votre élève à faire évoluer si besoin son ressenti, ses idées, son opinion — faites-lui considérer la situation selon différents points de vue.",
            question_situations: "Situations à débattre :",
            situations: [
              "Catégories d'usagers pouvant bénéficier d'emplacements réservés — Villes : personnes à mobilité réduite, livraisons, etc.",
              "Parkings magasins : femmes enceintes, familles, véhicules électriques, PMR…",
              "Hôpitaux, entreprises : selon statut social, réservé à la clientèle, aux PMR…",
              "N.B. : les parkings souterrains sont souvent interdits aux véhicules > 2 m, ou GPL, etc.",
              "Est-il normal de réserver des places à des usagers ? Précisez votre ressenti — geste citoyen normal / parfois exagéré vu le peu de places existantes / complètement injuste et injustifié. Justifiez."
            ]
          }
        },
        points: [
          "Créneau : repère 1 m de ton voisin droit, recule en braquant à droite jusqu'au 45°, contre-braquage à gauche, redresse.",
          "Bataille : entrée en marche avant ou arrière (arrière recommandée pour sortie sûre).",
          "Épi : aligner phare avant avec ligne du fond de la place, braquer fortement.",
        ],
        erreurs: ['Stationner sur passage piéton, devant entrée garage, bande cyclable — verbalisation systématique.'],
        geste: 'Toujours sortir côté trottoir si possible. Sinon, regarde le rétro arrière + angle mort.',
        mnemo: '"1m – 45 – Contre – Droit" : Créneau = 1 m du voisin, braquer 45°, contre-braquer à gauche, redresser.',
        checklist: [
          "Créneau : je repère 1 m du voisin droit avant de commencer.",
          "Bataille : je préfère l'entrée en marche arrière (sortie plus sûre).",
          "Épi : j'aligne mon phare avec la ligne du fond de la place.",
          "Je ne stationne jamais sur passage piéton, entrée garage, bande cyclable, arrêt bus.",
          "En sortant du véhicule, je regarde derrière avant d'ouvrir la portière.",
        ],
        attention: [
          "Stationnement gênant = amende 35 € + contravention. Sur passage piéton = 135 €.",
          "En zone bleue, disque obligatoire visible du pare-brise. Oubli = amende.",
          "Un stationnement en épi mal fait bloque une place voisine — courtoisie et technique.",
        ],
      },
    ],
  },
  {
    code: 'C3',
    title: 'Circuler',
    subtitle: 'dans des conditions difficiles et partager la route avec les autres usagers',
    color: 'red',
    intro: "Pluie, nuit, autoroute, virages, tunnels, motards, poids-lourds : les conditions changent, ta conduite aussi. C3 te prépare aux situations où la marge d'erreur diminue.",
    duree: '10 à 20 h',
    pre_requis: 'C1 + C2 acquises. Sortie nuit et autoroute recommandées.',
    lecons: [
      {
        i: 0,
        letter: 'a',
        titre: 'Évaluer et maintenir les distances de sécurité',
        objectif: 'Garder toujours devant soi un espace suffisant pour freiner ou manœuvrer, quelle que soit la vitesse.',
        // ── Trame REMC officielle (fidèle au livret C3a) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt de savoir évaluer et maintenir les distances de sécurité. Maintenir une distance de sécurité permet d'avoir le temps de réagir, de limiter le risque de collision, d'adapter son allure à la circulation et de préserver une marge de sécurité avec les autres usagers.",
            qr: [
              {
                q: "Quels sont les avantages à maintenir des distances de sécurité entre les véhicules à toutes les allures ?",
                r: "Le temps de réagir en cas d'imprévu, la marge pour freiner, un meilleur champ de vision, moins de stress et une conduite plus fluide."
              },
              {
                q: "Quels sont les inconvénients à ne pas connaître et/ou savoir calculer les distances de sécurité selon son allure ?",
                r: "Choc arrière, collision en chaîne, impossibilité de freiner à temps, prise de risque inconsciente."
              },
              {
                q: "Quels sont les avantages liés à l'utilisation du régulateur de distance de sécurité (ACC) ?",
                r: "Automatise le maintien d'une distance suffisante, réduit la fatigue sur trajets longs. Attention : ne dispense pas de la vigilance — la technologie assiste, elle ne remplace pas."
              }
            ]
          },
          comment: {
            a_traiter: "Calcul et évaluation des distances de sécurité, énergie cinétique, système de freinage.",
            questions_ouvertes: [
              "Calcul rapide de distance de sécurité — à 50 km/h : 5 × 6 = 30 m (ou 5 × 3 = 15, × 2 = 30 m). À 100 km/h : 10 × 6 = 60 m (ou 10 × 3 = 30, × 2 = 60 m).",
              "Repère simple : laisser au minimum 2 secondes entre son véhicule et celui qui précède.",
              "Représentation d'un choc selon la vitesse — équivalent chute d'immeuble : 30 km/h ≈ 2,7 m (1er étage) · 50 km/h ≈ 8 m (3e) · 70 km/h ≈ 16 m (6e) · 100 km/h ≈ 32 m (12e) · 130 km/h ≈ 69 m (22e)."
            ],
            info_plus: {
              titre: "Info + · Technologie et conducteur",
              items: [
                "Beaucoup de conducteurs pensent encore que la technologie et les aides à la conduite peuvent compenser leurs erreurs.",
                "En réalité, ces systèmes assistent le conducteur, mais ne le remplacent pas."
              ],
              conclusion: "À retenir : la technologie ne remplace pas le conducteur, elle apporte seulement une aide et un confort."
            },
            savoir: [
              "Quelle distance latérale minimale doit-on laisser pour dépasser un deux-roues ou un piéton ?",
              "Comment peut-on évaluer la distance à maintenir entre soi et un véhicule que l'on suit ?",
              "Que faut-il faire si l'on est suivi de trop près par un autre conducteur ?"
            ],
            savoir_faire: [
              "Sur deux kilomètres au moins, en circulation assez dense : vérifier que l'élève maintient une distance de sécurité suffisante entre lui et les véhicules suivis, au moyen d'un repère."
            ]
          },
          risques: {
            intro: "Le non-respect des distances de sécurité augmente le risque de choc arrière, de collision en chaîne et de collision frontale.",
            directives: [
              "Exercice « réglette » : mesurer le temps de réaction de l'élève. 1er essai — lâcher la réglette après un compte à rebours. 2e essai — lâcher la réglette avant la fin du compte, ou en attirant son attention sur autre chose. Comparer : le temps de réaction augmente lorsque l'attention est perturbée.",
              "Les distances de sécurité dépendent de la capacité du conducteur à détecter, analyser, décider et agir. Elles dépendent aussi de la vitesse pratiquée et de l'adhérence."
            ],
            risques_listes: "À combien estimez-vous le nombre de conducteurs qui ne respectent pas une distance de 2 secondes minimum sur autoroute ? Quels genres d'accidents le non-respect des distances de sécurité peut-il entraîner ? Avez-vous déjà roulé avec un conducteur qui « colle » les autres usagers ? Que risquez-vous ?"
          },
          influences: {
            intro: "Faire réfléchir l'élève au comportement des personnes de son entourage concernant le respect des distances de sécurité.",
            questions: [
              "Les conducteurs de votre entourage sont-ils plutôt respectueux des distances de sécurité ?",
              "Ne savent-ils pas les évaluer ?",
              "Ne les respectent-ils pas souvent ?",
              "S'en moquent-ils ?",
              "Sont-ils trop pressés pour s'en soucier ?"
            ]
          },
          pressions: {
            intro: "Les distances de sécurité dépendent de la capacité du conducteur à détecter, analyser, décider et agir. Elles dépendent aussi de la vitesse pratiquée et de l'adhérence. Beaucoup de conducteurs pensent que la technologie compense les erreurs — en réalité, elle assiste mais ne remplace pas.",
            question_situations: "À débattre :",
            situations: [
              "Un choc à 100 km/h équivaut à une chute d'environ 32 m — soit approximativement une chute du 12e étage.",
              "La règle des 2 secondes est un minimum absolu sur sec. Sous pluie : × 1,5. Nuit / brouillard : × 2.",
              "Le régulateur adaptatif n'a pas d'anticipation humaine : il freine SUR le véhicule détecté, pas AVANT."
            ]
          }
        },
        points: [
          "Règle des 2 secondes : au passage d'un repère par le véhicule précédent, tu dois pouvoir compter « un-mille-deux-mille » avant de l'atteindre.",
          "Distances de sécurité : 2 s sec, 3 s pluie, 4 s nuit / brouillard.",
          "Distance de freinage à 90 km/h sec ≈ 70 m ; sur mouillé ≈ 140 m ; sur verglas 500 m+.",
        ],
        erreurs: ["Rouler « collé » au véhicule précédent en pensant que ça fait avancer plus vite."],
        geste: "Compte mentalement « 21, 22 » entre le passage du véhicule précédent et le tien devant un repère : minimum 2 secondes.",
        mnemo: '"2-3-4" : 2 s sec, 3 s pluie, 4 s nuit/brouillard. La distance de sécurité en une règle.',
        checklist: [
          "Je maintiens 2 s de distance minimum sur sec.",
          "Sous pluie, je passe à 3 s.",
          "La nuit ou sous brouillard, je passe à 4 s.",
          "Je vérifie ma distance sur un repère (pont, arbre, panneau).",
          "Je n'utilise pas le régulateur pour rester collé à un véhicule lent.",
        ],
        attention: [
          "Distance de freinage à 130 km/h sec ≈ 130 m. Ta voiture ne s'arrête pas comme dans les films.",
          "Le tailgating (coller le précédent) = accident quasi-certain en cas de freinage d'urgence.",
          "Un radar embarqué peut sanctionner l'insuffisance de distance = amende + retrait de point.",
        ],
      },
      {
        i: 1,
        letter: 'b',
        titre: 'Croiser, dépasser, être dépassé',
        objectif: 'Gérer la coexistence sur la chaussée en sécurité.',
        // ── Trame REMC officielle (fidèle au livret C3b) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt de savoir croiser, dépasser et être dépassé dans le respect des règles de sécurité. Ces manœuvres nécessitent de prendre en compte la visibilité, la vitesse, les distances, le gabarit des véhicules, les autres usagers et les règles du Code de la route.",
            qr: [
              {
                q: "Citez les avantages à connaître les règles pour dépasser, croiser et être dépassé.",
                r: "Anticiper, éviter la surprise mutuelle, gagner en fluidité, protéger les usagers vulnérables (deux-roues, cyclistes), réduire drastiquement le risque de collision."
              },
              {
                q: "Citez les inconvénients à ne pas tenir compte du gabarit de son véhicule.",
                r: "Mal évaluer la distance nécessaire pour dépasser, sous-estimer les angles morts, provoquer un croisement dangereux, endommager son véhicule ou un tiers."
              },
              {
                q: "Quels sont les avantages et inconvénients liés à l'utilisation de l'AFIL (alerte de franchissement involontaire de ligne) ?",
                r: "Avantage : rappel visuel/sonore d'un écart involontaire. Inconvénient : ne dispense pas de la vigilance et peut être bruyant/perturbant en usage prolongé."
              }
            ]
          },
          comment: {
            a_traiter: "Quand et comment croiser, dépasser, être dépassé.",
            questions_ouvertes: [
              "Où doit-on placer son regard lors du croisement d'un véhicule sur une route étroite ?",
              "Quels indices importants permettent de savoir que la distance pour se rabattre est suffisante lors d'un dépassement ?",
              "Quelles sont les précautions à prendre avant de dépasser ?"
            ],
            info_plus: {
              titre: "Info + · Chaussée à forte déclivité",
              items: [
                "Croisement difficile mais possible : le véhicule descendant, quelle que soit sa catégorie, doit s'arrêter à temps le premier pour faciliter le passage.",
                "Croisement impossible : l'un des deux véhicules doit reculer. C'est toujours au véhicule le plus maniable de faire la manœuvre.",
                "Règles pratiques : un véhicule unique recule par rapport à un ensemble ; un véhicule léger recule par rapport à un lourd ; le véhicule qui descend recule si les deux sont de même catégorie, sauf si le montant peut plus facilement se ranger dans une place d'évitement."
              ],
              conclusion: "Accepter d'être ralenti n'est pas toujours évident. Dépasser sous stress ou énervement = focalisation excessive sur l'action, oubli des paramètres de sécurité."
            },
            savoir: [
              "Quelles sont les règles concernant le croisement ?",
              "Quels sont les principaux cas d'interdiction de dépasser ?",
              "Que faut-il faire quand on est sur le point d'être dépassé ?"
            ],
            savoir_faire: [
              "Prendre toutes les précautions lors d'un croisement présentant des risques.",
              "Prendre toutes les précautions avant, pendant et après un dépassement.",
              "Utiliser correctement les différents rapports de boîte de vitesses."
            ]
          },
          risques: {
            intro: "Accepter d'être ralenti n'est pas toujours évident. L'action de dépasser est souvent réalisée sous l'effet du stress ou de l'énervement. Le conducteur peut alors focaliser toute son attention sur l'obligation d'agir et oublier certains paramètres de sécurité ou certaines possibilités comme se calmer, attendre et faire preuve de patience.",
            directives: [
              "En agglomération, pour dépasser plus vite, l'automobiliste a tendance à prendre moins de précautions.",
              "Les usagers les plus touchés en agglomération suite à un dépassement mal évalué : deux-roues, cyclistes, piétons — gabarit réduit, visibilité et vulnérabilité maximales."
            ],
            risques_listes: "Quelle sorte d'accident peut engendrer un dépassement ? Quels sont les usagers les plus touchés en agglomération à la suite d'un dépassement ? Pourquoi ?"
          },
          influences: {
            intro: "Aider l'élève à passer en revue les comportements de son entourage concernant les croisements, les dépassements et le fait d'être dépassé.",
            questions: [
              "Dans votre entourage, y a-t-il des adeptes du dépassement ?",
              "Vous attribuez leur comportement à : un besoin réel de gain de temps ? Une envie de rouler vite ? Le fait de posséder un véhicule sportif ? Des compétences réelles en pilotage ? Une inconscience du risque ?",
              "Connaissant toute la procédure utile au dépassement, pensez-vous que ces personnes prennent toutes les précautions nécessaires ?",
              "Dans votre entourage, met-on toujours le clignotant pour dépasser ?",
              "Concernant les croisements, les personnes de votre entourage font-elles preuve de courtoisie et de respect ?"
            ]
          },
          pressions: {
            intro: "Un piéton dans un lieu connu fait preuve de courtoisie car la rencontre avec les autres est identifiable. Dans un lieu inconnu, il prend parfois moins de précautions, surtout s'il est pressé. Dans un véhicule, on peut se sentir anonyme et en sécurité — la pression sociale est moindre, moins de courtoisie et de précautions, le comportement peut devenir plus individualiste.",
            question_situations: "À débattre :",
            situations: [
              "Lors des déplacements dans les couloirs de votre établissement scolaire, entreprise ou lieu de travail, votre comportement est-il identique ou différent de celui adopté en centre-ville ou dans un couloir de métro ?",
              "Pensez-vous que ce phénomène (anonymat protecteur) peut se reproduire sur la route ?"
            ]
          }
        },
        points: [
          "Croisement étroit : ralentir, serrer à droite, klaxon bref si visibilité réduite.",
          "Dépassement : visibilité 150 m + ligne discontinue + écart 1 m mini + accélération franche.",
          "Être dépassé : maintenir ta vitesse, serrer à droite, NE PAS accélérer.",
        ],
        erreurs: ["Dépasser un cycliste sans 1,5 m d'écart (hors agglo)."],
        geste: 'Avant dépassement : rétros, angle mort, clignotant, accélération, retour souple à droite.',
        mnemo: '"REVAR" : Rétros – Écart 1m – Vitesse (accélération franche) – Angle mort – Retour souple.',
        checklist: [
          "Avant tout dépassement : 150 m de visibilité + ligne discontinue.",
          "Écart mini au dépassement : 1 m (agglo) ou 1,5 m (hors agglo, cycliste).",
          "J'accélère FRANCHEMENT lors du dépassement, sans traîner.",
          "Retour à droite : je vois le véhicule dépassé COMPLET dans mon rétro intérieur.",
          "Être dépassé : je maintiens ma vitesse, je serre à droite.",
        ],
        attention: [
          "Dépasser un cycliste : 1,5 m d'écart hors agglo, 1 m en agglo — TOUJOURS.",
          "Dépassement de bus scolaire à l'arrêt : ne PAS dépasser sans visibilité totale — enfant qui traverse.",
          "Accélérer pendant qu'on te dépasse = comportement dangereux + amende potentielle.",
        ],
      },
      {
        i: 2,
        letter: 'c',
        titre: 'Passer des virages et conduire en déclivité',
        objectif: 'Maîtriser trajectoires en virages, pentes et lacets sans mettre en péril l\'adhérence.',
        // ── Trame REMC officielle (fidèle au livret C3c) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt de savoir négocier un virage et conduire en déclivité. Adopter une trajectoire spécifique en virage permet d'optimiser les capacités du véhicule en respectant les effets de la force centrifuge. Connaître les caractéristiques de la conduite en côte et en descente permet de respecter la mécanique tout en adoptant une conduite sûre.",
            qr: [
              {
                q: "Quel avantage y a-t-il à adopter une trajectoire spécifique en virage ?",
                r: "Optimiser les capacités du véhicule en respectant les effets de la force centrifuge — meilleure stabilité, moins de sollicitation des pneus."
              },
              {
                q: "Quel avantage à connaître les caractéristiques de la conduite en côte / descente ?",
                r: "Respecter la mécanique du véhicule (boîte, freins, moteur) tout en adoptant une conduite sûre."
              }
            ]
          },
          comment: {
            a_traiter: "Regard, trajectoire, force centrifuge, énergie cinétique, respect de la mécanique, boîte de vitesses, freins, moteur.",
            questions_ouvertes: [
              "Quelles précautions doit-on prendre pour stationner dans une forte descente ?",
              "Lors d'un croisement impossible en montagne, quelles règles applique-t-on ? Pourquoi ?",
              "Qu'est-ce que le fading ?"
            ],
            info_plus: {
              titre: "Info + · Le fading",
              items: [
                "Définition : chute du coefficient de frottement liée à l'échauffement de la garniture de frein.",
                "Se produit fréquemment en descente de montagne, lors d'une utilisation intensive des freins, mais aussi lorsque les freins ne sont pas entretenus.",
                "Prévention : utiliser le frein moteur (rétrograder) en descente, éviter le freinage continu."
              ],
              conclusion: "En descente, on n'utilise pas les freins comme sur le plat — on descend « avec la boîte », pas « avec la pédale »."
            },
            savoir: [
              "Quelle est la signalisation relative aux virages ?",
              "Quelle est la relation entre vitesse, rayon du virage et force centrifuge ?"
            ],
            savoir_faire: [
              "Franchissement de plusieurs virages plus ou moins serrés et où la visibilité est plus ou moins bonne :",
              "— adapter la vitesse aux caractéristiques du virage ;",
              "— adapter la position sur la chaussée ;",
              "— adapter la trajectoire ;",
              "— tenir correctement le volant."
            ]
          },
          risques: {
            intro: "Chaque moyen de locomotion, selon ses caractéristiques, requiert une technique de conduite particulière. On ne ralentit pas un poids lourd chargé en descente de la même manière qu'une voiture ou une moto. On ne négocie pas un virage serré dans une forte descente de la même manière à moto qu'en poids lourd.",
            directives: [
              "Un conducteur titulaire du permis B peut oublier de prendre en compte les caractéristiques techniques des autres véhicules.",
              "Exemples de risques : difficulté à freiner en virage pour les motos ; risque plus important de fading pour les poids lourds en forte descente."
            ],
            risques_listes: "Selon vous, quels facteurs augmentent le risque en virage / déclivité ? Comment adapter sa conduite à la présence d'un poids lourd descendant devant vous ? Que faire si vos freins commencent à « chauffer » en descente prolongée ?"
          },
          influences: {
            intro: "Beaucoup d'usagers adoptent une conduite « sportive » sur route car cela valorise leur image. Même avec un véhicule performant, il est rare qu'ils possèdent les techniques permettant de contrôler un véhicule à allure élevée. Et même s'ils les possédaient, la présence d'autres usagers ne permettrait pas forcément de les mettre en pratique. Les pilotes professionnels ne pratiquent pas sur route ouverte — ils connaissent les risques liés à une pratique sportive dans un environnement adapté et fermé.",
            questions: [
              "Dans votre entourage, y a-t-il des conducteurs qui se prennent pour des pilotes, notamment sur route sinueuse ?",
              "Possèdent-ils un véhicule sportif ou modifié ?",
              "Ont-ils suivi des cours de pilotage ?",
              "Conduire en montagne pose-t-il un problème ?",
              "Le fait d'avoir un véhicule dit sportif autorise-t-il à prendre les virages plus rapidement ?",
              "Les techniques de pilotage sont-elles adaptées à une circulation classique ?"
            ]
          },
          pressions: {
            intro: "Les statistiques montrent que les accidents mortels sont plus souvent dus à des conducteurs masculins. En 2020 : femmes 21,6 % · hommes 78,4 % des accidents mortels. Le « drift » (technique de pilotage en virage) est de plus en plus utilisé dans les films et les courses ouvertes — beaucoup de jeunes pensent qu'il suffit de tirer le frein à main en courbe pour faire glisser leur voiture. En réalité, cette technique demande des connaissances mécaniques, des compétences particulières et un environnement sécurisé.",
            question_situations: "À débattre :",
            situations: [
              "La publicité automobile utilise-t-elle des images valorisant la puissance, l'agressivité ou la vitesse pour renforcer le caractère exceptionnel d'un véhicule ?",
              "Ces images vous incitent-elles à adopter une conduite plus dynamique ?",
              "À retenir : on ne s'improvise pas pilote."
            ]
          }
        },
        points: [
          "Virage : ralentir AVANT, tenir la trajectoire, ré-accélérer en sortie.",
          "Montée : rapport adapté pour ne pas faire surchauffer le moteur ; pas de point mort.",
          "Descente : frein moteur (rétrograder) en complément du frein principal ; éviter le freinage continu.",
          "Lacets : trajectoire large à l'entrée, serrée à la sortie.",
        ],
        erreurs: ["Freiner en plein virage — risque sous-virage / sortie de route.", "Descente longue au frein constant — surchauffe et perte d'efficacité."],
        geste: '« Slow in, fast out » : ralentis à l\'approche, ré-accélère à la sortie. En descente, rétrograde AVANT de freiner.',
        mnemo: '"FREIN MOTEUR" : Descente = rétrograde, laisse le moteur retenir la voiture. Pas de freinage continu.',
        checklist: [
          "Je freine AVANT la courbe, jamais dedans.",
          "En descente, je rétrograde AVANT de freiner.",
          "Je n'utilise jamais le point mort en descente.",
          "En lacet, j'entre large et je sors serré.",
          "Si mes freins sentent le brûlé, je m'arrête pour laisser refroidir 20 min.",
        ],
        attention: [
          "Une descente longue au frein continu = surchauffe = perte d'efficacité (« fading »).",
          "Croisement en lacet étroit : véhicule montant a la PRIORITÉ (moins de recul possible).",
          "En virage serré aveugle, imagine TOUJOURS qu'un cycliste ou tracteur est juste derrière.",
        ],
      },
      {
        i: 3,
        letter: 'd',
        titre: 'Connaître les caractéristiques des autres usagers et savoir se comporter à leur égard avec respect et courtoisie',
        objectif: 'Comprendre les vulnérabilités et comportements des piétons, cyclistes, motards, poids-lourds, engins agricoles, transports en commun.',
        // ── Trame REMC officielle (fidèle au livret C3d) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt de connaître les caractéristiques des autres usagers pour pouvoir circuler en sécurité et faire preuve de respect et de courtoisie. Cette compétence est un pilier de l'anticipation en conduite. Connaître les autres usagers permet d'adapter son comportement, d'anticiper les situations, de faire preuve de tolérance, d'être patient, d'être courtois et de partager la route de manière plus sûre.",
            qr: [
              {
                q: "Que gagne-t-on à connaître les caractéristiques des différents usagers ?",
                r: "Anticiper leurs trajectoires, ne pas les surprendre, adapter son gabarit et sa vitesse, coexister sans risque."
              },
              {
                q: "Pourquoi la courtoisie est-elle un enjeu de sécurité et non juste une valeur morale ?",
                r: "Un conducteur qui laisse passer un piéton ou signale une intention désamorce un conflit ; un conducteur individualiste multiplie les micro-conflits et les micro-erreurs."
              }
            ]
          },
          comment: {
            a_traiter: "Caractéristiques des véhicules et des usagers (deux-roues, véhicules lents ou rapides, poids lourds, transports en commun, véhicules légers, véhicules tractés, usagers selon l'âge / le sexe / l'expérience, étrangers ou autochtones, situations : météo, semaine, week-end, jour, nuit, ville, campagne).",
            questions_ouvertes: [
              "En salle : le formateur est un animateur. Il aide les élèves à lister les moyens de locomotion existants avec leurs caractéristiques et les informations utiles rencontrées sur la route.",
              "Exemples d'usagers à passer en revue : quadricycle léger à moteur (2 places, ≤ 45 km/h, permis AM/ASSR + formation dès 14 ans) · véhicule léger (2 à 9 places, gabarits/puissances variables, silencieux en électrique) · moto/scooter (2 ou 3 roues, stabilité variable, dès 14 ans pour certains) · poids lourd (articulé ou non, conducteurs professionnels) · cycliste (VAE jusqu'à 25 km/h et plus selon relief) · piéton (tous âges) · bus/car (conducteurs pros, itinéraires fixes parfois) · tram (voie dédiée ou partagée) · EDP roller/trottinette/skate assimilés piéton · EDPM engins motorisés (bande cyclable/chaussée selon règles, vitesse réglementée).",
              "Facteurs qui influencent le comportement au-delà du Code : personnalité, capacités, émotions, activités familiales/sociales/pro, rapport à la règle, rapport au risque, représentations, croyances, valeurs, pairs, société, publicité."
            ],
            info_plus: {
              titre: "Info + · Bilan ONISR 2022",
              items: [
                "3 550 tués sur les routes de France, dont 3 267 en France métropolitaine.",
                "Environ 16 000 blessés graves et 221 000 blessés légers ou modérés.",
                "Selon l'âge : les 18-24 ans et les 75 ans et plus sont les plus touchés par le risque de mortalité.",
                "Selon le genre : les hommes sont surreprésentés (≈ 84 % des accidents mortels présumés responsables).",
                "Facteurs principaux évoqués : vitesse excessive ou inadaptée, alcool, stupéfiants, inattention, malaise, non-respect des priorités.",
                "Modes de déplacement concernés : véhicules de tourisme, poids lourds, piétons, cyclistes, utilisateurs d'EDPM, deux-roues motorisés."
              ],
              conclusion: "Adapter son comportement à l'autre = premier réflexe de sécurité, avant même la maîtrise technique."
            },
            savoir: [
              "Quelles précautions faut-il prendre en présence des piétons ?",
              "Quelles particularités présentent les poids lourds ? Comment se comporter à leur égard ?",
              "Comment se comporter avec les deux-roues : cyclistes, cyclomotoristes, motocyclistes ?",
              "Quels sont les véhicules d'intérêt général prioritaires ? Comment se comporter à leur égard ?"
            ],
            savoir_faire: [
              "Au cours des leçons pratiques : tenir compte des particularités des autres usagers en adaptant son comportement à leur égard. Selon le niveau, faire commenter la conduite."
            ]
          },
          risques: {
            intro: "Organiser une réflexion avec un groupe d'élèves sur les risques propres aux différents moyens de circuler et aux différents profils de conducteurs. L'interaction entre usagers est très importante. Le rôle du formateur est d'animer la discussion, d'apporter quelques chiffres et arguments pour alimenter le débat, mais d'éviter le cours magistral.",
            directives: [
              "Exemple d'engagement possible : s'engager à laisser passer les piétons qui souhaitent traverser sur un passage piéton.",
              "Compétences à travailler : détection, anticipation, analyse, courtoisie."
            ],
            risques_listes: "Quels sont les risques spécifiques associés aux piétons ? Aux cyclistes ? Aux deux-roues motorisés ? Aux poids lourds ? Aux véhicules d'intérêt général ? Quels comportements adopter en présence de chacun de ces usagers ?"
          },
          influences: {
            intro: "Le comportement au volant est fortement influencé par le contexte social et personnel. Aidez votre élève à identifier les facteurs qui pèsent sur sa propre conduite : personnalité, émotions, entourage, pression sociale, publicité.",
            questions: [
              "Dans votre entourage, comment se comporte-t-on face aux piétons, aux cyclistes, aux deux-roues motorisés ?",
              "Y a-t-il des remarques négatives récurrentes envers une catégorie d'usagers (« les motards se croient tout permis », « les cyclistes prennent toute la route ») ?",
              "Ces jugements influencent-ils votre propre attitude au volant ?",
              "Avez-vous déjà été vous-même piéton, cycliste ou deux-roues face à un automobiliste ? Qu'avez-vous ressenti ?"
            ]
          },
          pressions: {
            intro: "Les 18-24 ans et les 75+ sont les tranches les plus touchées par la mortalité routière (ONISR 2022). Les hommes sont présumés responsables d'environ 84 % des accidents mortels. Vitesse excessive, alcool, stupéfiants, inattention, malaise, non-respect des priorités sont les principaux facteurs.",
            question_situations: "À débattre :",
            situations: [
              "La sur-représentation masculine dans les accidents mortels tient-elle à la biologie, à l'éducation, à la culture, ou à un mélange ?",
              "Quel rôle joue la publicité automobile dans la construction du « bon conducteur » ?",
              "Comment votre âge, votre expérience et votre genre influencent-ils la façon dont les autres usagers vous perçoivent (et réciproquement) ?"
            ]
          }
        },
        points: [
          "Piétons : imprévisibles, surtout enfants et personnes âgées. Priorité absolue sur passage.",
          "Cyclistes / trottinettes : silencieux, angles morts, écart 1 m (agglo) ou 1,5 m (hors agglo) au dépassement.",
          "Motards : accélération et freinage forts, remontent les files, angles morts massifs.",
          "Poids-lourds / bus : angles morts géants, distance de freinage doublée, respecter leurs manœuvres.",
          "Engins agricoles : lents, larges, dépassement conditionnel.",
        ],
        erreurs: ["Klaxonner un piéton qui traverse — incivilité + panique."],
        geste: "Croise le regard des usagers vulnérables : sans contact visuel, aucune certitude qu'ils t'ont vu.",
        mnemo: '"COURTOISIE = SÉCURITÉ" : Anticiper, laisser passer, garder ses distances. Le partage de la route commence par le respect.',
        checklist: [
          "Je respecte l'écart de 1,5 m minimum au dépassement d'un cycliste hors agglo.",
          "Je regarde 2 fois avant de tourner en agglo (motards, cyclistes qui remontent).",
          "Je ne me place jamais dans l'angle mort d'un poids-lourd.",
          "Je patiente derrière un tracteur ; je ne double que si visibilité et sécurité totales.",
          "Je laisse toujours passer un piéton engagé sur un passage.",
        ],
        attention: [
          "Un enfant à côté d'un adulte peut se détacher SANS prévenir. Vitesse divisée par 2.",
          "Le motard qui remonte les files entre voitures = angle mort mortel. Toujours vérifier avant de changer de voie.",
          "Poids-lourd : angle mort à droite jusqu'à 5 m — un cycliste peut y disparaître complètement.",
        ],
      },
      {
        i: 4,
        letter: 'e',
        titre: "S'insérer, circuler et sortir d'une voie rapide",
        objectif: "S'insérer, circuler et sortir en sécurité d'une autoroute ou voie rapide.",
        // ── Trame REMC officielle (fidèle au livret C3e) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir circuler sur une voie rapide et en sortir en sécurité. Ne pas maîtriser l'insertion, la circulation ou la sortie sur voie rapide expose à des accidents graves.",
            qr: [
              {
                q: "Quels sont les avantages d'une voie rapide ?",
                r: "Gain de temps, séparation des flux, meilleure visibilité, moins de croisements."
              },
              {
                q: "Les inconvénients ?",
                r: "Monotonie et fatigue accrues, vitesses élevées → violence des chocs, sortie brutale du flux qui peut surprendre."
              },
              {
                q: "Inconvénients d'une insertion sans précautions ni prise en compte des autres usagers ?",
                r: "Risque de collision, de gêne, de freinage brutal du flux principal."
              },
              {
                q: "Avantages à contrôler dans l'angle mort avant de s'insérer ?",
                r: "Éviter de couper la route à un usager déjà présent sur la voie rapide."
              }
            ]
          },
          comment: {
            a_traiter: "Regarder, contrôler, analyser, décider, contrôler la vitesse et la trajectoire, anticiper les dépassements lents, maintenir les distances de sécurité, ralentir/freiner pour sortir.",
            questions_ouvertes: [
              "Citez les règles d'accès à une voie rapide.",
              "Quelles sont les étapes pour quitter une voie rapide ?",
              "Que faire si la voie de décélération est encombrée ?",
              "Devez-vous utiliser la totalité de la voie d'insertion à chaque insertion ?",
              "Les aires de repos sont espacées de combien de km sur autoroute ?"
            ],
            info_plus: {
              titre: "Info + · Réseau et comportements SANEF 2019",
              items: [
                "Aires de repos : environ tous les 10 km. Aires de service : tous les 40 km.",
                "Recrudescence des excès de vitesse et de l'usage du téléphone au volant.",
                "Dégradation du respect des distances de sécurité, cumul « trop vite + trop près ».",
                "Sur les statistiques 2022 : environ 12 % des tués sur autoroute concernent les poids lourds."
              ],
              conclusion: "L'insertion se prépare : contrôles, communication, accélération pour se caler à la vitesse du flux."
            },
            savoir: [
              "Quelles précautions prendre quand on sort d'un immeuble ou d'une aire de stationnement ?",
              "Quelles précautions prendre avant de démarrer en quittant le bord du trottoir ?"
            ],
            savoir_faire: [
              "Au moins 4 insertions et sorties en sécurité dans une circulation rapide, sans erreur grave :",
              "— en sortant d'un immeuble ou d'une station-service,",
              "— en partant de la bordure du trottoir,",
              "— en utilisant une voie d'insertion ou d'entrecroisement,",
              "— en cédant le passage,",
              "— alors que la circulation est plus ou moins dense."
            ]
          },
          risques: {
            intro: "Chaque phase de la voie rapide a ses risques propres : avant/pendant l'insertion, en circulation, en sortie.",
            directives: [
              "Avant/pendant l'insertion : risque d'effrayer ou de provoquer une collision si l'analyse est mauvaise, si les contrôles ou la communication sont absents, ou si les capacités d'accélération du véhicule sont surestimées.",
              "En circulation : la fatigue est la 1re cause d'accident sur autoroute. Ne pas respecter les distances = collisions en chaîne.",
              "En sortie : combattre l'habitude d'une vitesse élevée, ne pas entamer une décélération trop brutale dans la voie de décélération."
            ],
            risques_listes: "Quelles particularités de circulation sur voie rapide ? Quels sont les principaux facteurs d'accidents sur autoroute ? Quelle catégorie d'usagers est la plus touchée par les accidents mortels sur voie rapide ?"
          },
          influences: {
            intro: "Faire réfléchir votre élève sur la façon dont son entourage conduit — pour qu'il puisse juger si sa pratique a été influencée ou non. Amener aussi à comparer si ce qui est pratiqué est en accord avec l'image de la personne.",
            questions: [
              "Lors de longs trajets, votre famille préfère-t-elle utiliser les voies rapides ou le réseau secondaire ?",
              "Lors d'une insertion sur autoroute, comment procède votre entourage ? (regard, clignotant, accélération, communication)",
              "Dans votre entourage, le respect des voies (droite par défaut, gauche pour dépasser) est-il respecté ?"
            ]
          },
          pressions: {
            intro: "Les conducteurs français ont pris l'habitude qu'on leur facilite l'entrée sur voie rapide. Ce geste courtois vis-à-vis de certains usagers (poids lourds) est dorénavant considéré comme un dû par certains automobilistes qui pensent qu'il est du devoir des usagers du flux principal de s'écarter.",
            question_situations: "À débattre :",
            situations: [
              "Doit-on systématiquement changer de voie dès lors qu'un véhicule se présente sur la voie d'insertion ?",
              "Les usagers circulant sur la voie d'insertion doivent-ils toujours céder le passage ?",
              "Le geste de courtoisie est-il un droit ou un service ?"
            ]
          }
        },
        points: [
          "Insertion : voie d'accélération = tu accélères à la vitesse du flux, pas en dessous.",
          "Voie de droite par défaut. Voie de gauche = dépassement seulement.",
          "Sortie : clignotant 200 m avant la sortie, voie de droite, puis voie de décélération.",
        ],
        erreurs: ["Hésiter sur la voie d'insertion — coupe le flux."],
        geste: "Sortie : clignotant 200 m avant la sortie, voie de droite, puis voie de décélération.",
        mnemo: '"V-I-D" : Vitesse au flux avant insertion, Insertion à la fin de la bande, Décélération sur la sortie.',
        checklist: [
          "Sur bande d'accélération, j'atteins la vitesse du flux AVANT de m'insérer.",
          "Je m'insère à la fin de la bande d'accélération, pas au début.",
          "Je roule sur la voie de droite par défaut.",
          "Je respecte 2 s de distance minimum en flux normal.",
          "Sortie : clignotant 200 m avant, puis voie de décélération.",
        ],
        attention: [
          "L'autoroute a plus d'accidents PAR SUR-VIGILANCE que par vitesse pure (fatigue, monotonie).",
          "Voie de gauche = dépassement UNIQUEMENT. Y rester sans dépasser = amende + retrait de point.",
          "Bande d'arrêt d'urgence = jamais utilisée pour un appel téléphonique ou une pause. C'est mortel.",
        ],
      },
      {
        i: 5,
        letter: 'f',
        titre: 'Conduire dans une file de véhicules et dans une circulation dense',
        objectif: 'Garder son calme et lire un environnement chargé.',
        // ── Trame REMC officielle (fidèle au livret C3f) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir conduire en sécurité lorsque la circulation est dense.",
            qr: [
              {
                q: "Quels sont les avantages à respecter les distances de sécurité avant et arrière lors d'une circulation en file ?",
                r: "Permet d'anticiper et d'agir en cas de fort ralentissement, évite de subir la circulation, réduit les collisions arrière et en chaîne."
              }
            ]
          },
          comment: {
            a_traiter: "Contrôles, prise en compte des autres catégories d'usagers, changement de direction, respect des distances de sécurité, dangers inhérents à la circulation dense.",
            questions_ouvertes: [
              "Quelles sont les restrictions concernant les changements de voie ?",
              "Quelle est la chose essentielle à faire avant tout changement de voie ? (contrôle rétros + angle mort + clignotant)"
            ],
            info_plus: {
              titre: "Info + · Parc 2RM et pression du temps",
              items: [
                "Fort développement du parc deux-roues motorisés dans les grandes agglomérations.",
                "Certains ménages possèdent une voiture + un 2RM spécifiquement pour les trajets domicile-travail.",
                "L'illusion du gain de temps sur la route reste un moteur puissant du choix du 2RM."
              ],
              conclusion: "En circulation dense, la meilleure économie de temps = anticipation + calme. La frustration est un accélérateur d'erreurs."
            },
            savoir: [
              "Qu'est-ce que circuler en file ?",
              "Dans quels cas peut-on changer de file ?",
              "Quelles précautions prendre ?",
              "Quel comportement adopter face à un autobus qui signale son intention de repartir ?"
            ],
            savoir_faire: [
              "Choisir une file et la respecter.",
              "Commenter les indices utilisés pour ajuster vitesse, positionnement et distances de sécurité en circulation dense."
            ]
          },
          risques: {
            intro: "Un grand nombre d'automobilistes omettent de prendre en compte les caractéristiques techniques (gabarit, angles morts) des autres usagers, particulièrement en file dense. La frustration liée à l'attente est aussi source de comportements déviants.",
            directives: [
              "En circulation dense, la sensation d'être « prisonnier » du trafic peut nourrir agressivité, refus de priorité, changements de voie brusques.",
              "Les usagers les plus vulnérables lors d'un changement de voie en file : cyclistes et deux-roues motorisés (gabarit + angle mort)."
            ],
            risques_listes: "Quels sont les risques liés à la circulation en file dans une circulation dense ? Quels usagers sont les plus vulnérables lors d'un changement de voie ?"
          },
          influences: {
            intro: "Le lieu de résidence influe fortement sur le comportement en file. La perception du risque peut être faussée par l'expérience quotidienne de l'entourage — qui peut communiquer la peur ou au contraire la sérénité face à cette situation.",
            questions: [
              "Vos proches habitent-ils dans une agglomération à circulation dense ? Comment gèrent-ils les files ?",
              "Vous a-t-on transmis plutôt la peur ou la confiance face à la circulation dense ?"
            ]
          },
          pressions: {
            intro: "La société pousse sans cesse à gagner du temps — d'où le développement du parc 2RM en grandes agglomérations. À mettre en lien avec l'illusion du gain de temps sur la route.",
            question_situations: "À débattre :",
            situations: [
              "Certaines personnes de votre entourage ont-elles modifié leur moyen de locomotion pour gagner du temps ?",
              "Connaissez-vous des professions qui utilisent le 2RM pour gagner du temps en agglomération dans les bouchons ? (coursiers, livraison, professions médicales)",
              "Est-ce vraiment sur la route qu'il faut gagner du temps ?"
            ]
          }
        },
        points: [
          "Anticipation : ralentir AVANT les zones connues comme complexes.",
          "Toujours laisser une « porte de sortie » devant — pas collé au précédent.",
          "Patience : klaxonner ne fait pas avancer le bouchon.",
        ],
        erreurs: ["Forcer le passage dans un trafic à l'arrêt — bloque tout le carrefour."],
        geste: 'Si tu sens la frustration monter, respire 3 fois lentement. Ta conduite est tout de suite plus sûre.',
        mnemo: '"Porte de sortie" : Toujours une distance devant pour t\'immobiliser. Jamais collé au précédent.',
        checklist: [
          "Je garde une distance suffisante devant pour manœuvrer en cas d'imprévu.",
          "Je respire calmement, même dans les bouchons.",
          "Je n'engage jamais un carrefour si je risque de bloquer.",
          "Je ne klaxonne pas d'agacement (uniquement pour signaler un danger).",
          "Je respecte les couloirs de secours en cas d'embouteillage.",
        ],
        attention: [
          "Un scooter / cycliste peut te remonter par la droite ou la gauche — angles morts vitaux.",
          "Bloquer un carrefour = amende + zone dysfonctionnelle. Anticipe ta chaîne.",
          "Le stress au volant multiplie par 3 le risque d'accident (source Sécurité routière).",
        ],
      },
      {
        i: 6,
        letter: 'g',
        titre: 'Connaître les règles relatives à la Circulation Inter-Files (C.I.F.) des motocyclistes',
        objectif: 'Anticiper et respecter la remontée des motocyclistes entre les files de voitures dans les zones autorisées.',
        // ── Trame REMC officielle (fidèle au livret C3g) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir partager la route avec les deux-roues motorisés. Renforcer son esprit citoyen en acceptant que chacun (quel que soit le mode de déplacement choisi) puisse partager sans risque un même espace.",
            qr: [
              {
                q: "Quels sont les inconvénients à ne pas connaître les règles inhérentes à la circulation inter-files (CIF) ?",
                r: "Risque d'être surpris par la survenue d'un motard en CIF, risque de ne pas avoir le bon comportement alors que le trafic est dense, gêner ou provoquer un accident."
              }
            ]
          },
          comment: {
            a_traiter: "Identification des situations et lieux où la CIF se pratique — contrôles, positionnement, communication.",
            questions_ouvertes: [
              "Qui peut pratiquer la CIF ? (Deux ou trois roues motorisés de moins d'1 m de largeur.)",
              "Où se pratique la CIF ? (Voies dont la vitesse maximale autorisée est ≥ 70 km/h, à 2 voies séparées d'un terre-plein central, dans les départements où l'expérimentation est en cours.)",
              "Quand pratiquer la CIF ? (Uniquement en circulation dense — files continues sur toutes les voies.)",
              "Dans quelles circonstances les motards peuvent-ils pratiquer la CIF ?",
              "À quelle vitesse se pratique la CIF ? (Vitesse ≤ 50 km/h avec un différentiel de 30 km/h max par rapport aux autres véhicules.)"
            ],
            info_plus: {
              titre: "Info + · CIF — encadrement légal",
              items: [
                "La CIF est une expérimentation officielle depuis 2021, reconduite jusqu'à 2027.",
                "Elle est autorisée dans 21 départements (les plus congestionnés) sur voies rapides à séparateur central.",
                "En dehors de ces zones et de ces conditions, la CIF reste une infraction (dépassement par la droite, non-respect des voies)."
              ],
              conclusion: "Partager la route, c'est aussi accepter la coexistence de gabarits différents avec des rythmes différents."
            },
            savoir: [
              "Quels indices signalent la pratique de la CIF ?",
              "Comment repérer un motard qui remonte les files ?",
              "Quelle conduite tenir en tant qu'automobiliste ? (Ne pas serrer la ligne blanche, maintenir sa trajectoire, ne pas changer brusquement de voie.)"
            ],
            savoir_faire: [
              "Repérer les motards en approche ou en remontée de file.",
              "Appliquer la bonne procédure pour faciliter la CIF sans nuire à sa propre sécurité."
            ]
          },
          risques: {
            intro: "La conduite inter-files peut générer de la frustration chez les automobilistes — sensation d'être prisonnier du trafic pendant que le motard « dépasse librement ». Certains motards en CIF à vitesse élevée peuvent susciter un fort sentiment d'insécurité chez les autres usagers.",
            directives: [
              "La CIF peut surprendre des conducteurs peu habitués aux grandes agglomérations.",
              "Certains conducteurs individualistes peuvent volontairement entraver la manœuvre.",
              "À votre niveau, comment faire baisser le risque : anticiper, maintenir sa trajectoire, ne pas provoquer d'obstruction volontaire."
            ],
            risques_listes: "Quels sont les risques de la CIF pour les automobilistes ? Pour les 2-roues ? Comment pouvez-vous faire baisser le niveau de risque de cette pratique ?"
          },
          influences: {
            intro: "Le lieu de résidence, les habitudes de conduite des proches, leur représentation du phénomène moto et leur rapport au risque vont être déterminants dans leur engagement à Partager la route et faciliter la CIF. La méconnaissance de la procédure et des lieux où la CIF est autorisée influence négativement le comportement de conduite d'un conducteur inexpérimenté.",
            questions: [
              "Dans votre entourage, comment perçoit-on les motards en CIF ? (Utilité, danger, agressivité, respect ?)",
              "Vos proches ont-ils déjà pratiqué ou envisagé la moto pour des raisons de temps de trajet ?"
            ]
          },
          pressions: {
            intro: "La CIF est une pratique de fait, largement répandue avant même son encadrement légal. Elle a été officialisée par expérimentation pour l'encadrer plutôt que la laisser sauvage.",
            question_situations: "À débattre :",
            situations: [
              "Pensez-vous que cette pratique va faciliter la circulation des professionnels qui se déplacent à moto ?",
              "Pratique dangereuse à interdire ou pratique inévitable à encadrer ?",
              "Comment évoluer d'un ressentiment (« ils passent, pas moi ») vers une coexistence apaisée ?"
            ]
          }
        },
        points: [
          "Sur autoroute et voies rapides à ≥ 2 voies par sens, en circulation dense : motos et scooters ≥ 125 cm³ peuvent circuler entre les 2 files de gauche.",
          "Vitesse motard en CIF : maxi 50 km/h.",
          "Écart vitesse motard / voiture : maxi 30 km/h.",
          "Automobiliste : ne pas changer de file brusquement, laisser passer les motos, faciliter leur passage.",
        ],
        erreurs: ["Changer de file sans regarder les rétros — collision latérale avec un motard en CIF."],
        geste: 'En bouchon, avant tout changement de file : rétro + clignotant + angle mort + attente 2 s. Une moto peut arriver à 50 km/h.',
        mnemo: '"CIF = LAISSE PASSER" : Sur autoroute dense, un motard qui remonte entre 2 files est LÉGAL. Facilite-lui le passage.',
        checklist: [
          "En circulation dense sur autoroute, je m'attends à voir des motos remonter entre les files.",
          "Avant tout changement de file : contrôle rétros + angle mort + clignotant 3 s avant.",
          "Je ne bloque pas volontairement un motard qui remonte (interdit).",
          "Je serre légèrement à droite pour élargir le couloir CIF si possible.",
          "Je vérifie que la CIF est autorisée sur mon axe (dispositif régional).",
        ],
        attention: [
          "La CIF est autorisée sous conditions strictes : hors agglomération, autoroute / voie rapide à 2×2 voies minimum, en trafic dense.",
          "En zone où la CIF n'est PAS autorisée, un motard qui remonte est en infraction — ne l'imite pas.",
          "Un motard invisible dans l'angle mort peut arriver à 50 km/h relatif = collision violente.",
        ],
      },
      {
        i: 7,
        letter: 'h',
        titre: "Conduire quand l'adhérence et la visibilité sont réduites",
        objectif: "Adapter sa conduite à la pluie, la neige, le brouillard, la nuit, l'éblouissement.",
        // ── Trame REMC officielle (fidèle au livret C3h) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir identifier les situations où l'adhérence est réduite et à adapter sa conduite en cas de mauvaise visibilité. Une expérience pratique (freinage d'urgence sous pluie) permet d'intégrer plus facilement la difficulté.",
            qr: [
              {
                q: "Quels sont les avantages à savoir identifier que l'adhérence est réduite ?",
                r: "Éviter d'être surpris, permettre d'adapter sa conduite (réduction d'allure), anticiper les distances de freinage majorées."
              }
            ]
          },
          comment: {
            a_traiter: "Identifier les situations et lieux où l'adhérence est réduite, adapter l'allure, utiliser les accessoires liés à la baisse de visibilité.",
            questions_ouvertes: [
              "Quels sont les accessoires et feux à utiliser quand la visibilité est réduite ? (Feux de croisement, brouillard avant, brouillard arrière selon situation.)",
              "Quelles situations réduisent l'adhérence ? Pluie (aquaplaning, route grasse aux premières gouttes), verglas, neige, forte chaleur (bitume mou), graviers, feuilles mortes, routes souillées."
            ],
            info_plus: {
              titre: "Info + · Distances de freinage",
              items: [
                "Sur sol sec à 50 km/h : temps de réaction 1 s = 14 m + freinage 12 m = 26 m d'arrêt total.",
                "Sur sol mouillé à 50 km/h : temps de réaction 1 s = 14 m + freinage 24 m = 38 m (× 1,5).",
                "L'été est plus propice aux accidents que l'hiver en France (davantage de 2-roues et de piétons, trafic touristique).",
                "En conditions dégradées : distances × 1,5 pluie, × 2 nuit/brouillard."
              ],
              conclusion: "La météo dégradée fait chuter la visibilité ET l'adhérence — le risque d'accident individuel augmente mécaniquement."
            },
            savoir: [
              "Qu'est-ce que l'aquaplaning et comment y réagir ?",
              "Comment se forme le verglas ? Quels équipements utiliser ?",
              "Neige : quels équipements sont obligatoires en zones montagneuses (loi Montagne II) ?",
              "Quelle est la relation entre visibilité et distance d'arrêt ?"
            ],
            savoir_faire: [
              "Adapter sa vitesse aux conditions d'adhérence.",
              "Freiner sur sol mouillé.",
              "Commenter les situations de baisse de visibilité nécessitant une réduction d'allure et l'utilisation d'accessoires."
            ]
          },
          risques: {
            intro: "Une adhérence ou une visibilité réduite oblige à ralentir, réduit la capacité d'anticipation, retarde la détection des autres usagers et rend la conduite plus fatigante. Le conducteur doit être plus concentré, plus longtemps.",
            directives: [
              "La météo a un impact direct sur la mortalité routière.",
              "Contre-intuitif : l'été est plus meurtrier que l'hiver en France (deux-roues, piétons, tourisme).",
              "En conditions dégradées, le risque individuel d'accident augmente — la seule parade est de RÉDUIRE l'allure."
            ],
            risques_listes: "Quels sont les inconvénients d'une adhérence réduite ? D'une visibilité réduite ? Pourquoi la fatigue est-elle accrue en conditions dégradées ?"
          },
          influences: {
            intro: "Amorcez avec votre élève une réflexion basée sur le comportement au volant de son entourage lorsque les conditions climatiques sont mauvaises. C'est en observant et en analysant ce que font les autres qu'il va construire une partie de son expérience et choisir les comportements à adopter en retour.",
            questions: [
              "Comment se comporte votre entourage en cas de pluie forte, neige, brouillard ?",
              "Y a-t-il des personnes qui ne modifient rien à leur conduite quelle que soit la météo ?",
              "Y a-t-il des personnes qui, au contraire, deviennent excessivement lentes et dangereuses par leur excès de prudence ?"
            ]
          },
          pressions: {
            intro: "On ne peut pas toujours différer son voyage ou son déplacement. Il est donc important de connaître les risques et précautions à prendre lorsque la météo n'est pas favorable.",
            question_situations: "À débattre :",
            situations: [
              "La météo modifie-t-elle votre heure de départ ? Votre vitesse ? Votre niveau de vigilance ?",
              "Connaissez-vous des professions qui obligent à rouler quelles que soient les conditions météo ? (transport routier, urgences, service public, agriculture)",
              "Comment gérer la pression professionnelle vs. les conditions dégradées ?"
            ]
          }
        },
        points: [
          "Pluie : -20 % vitesse, +50 % distance de sécurité, essuie-glaces vitesse 2.",
          "Brouillard : feux antibrouillard avant si visibilité < 100 m, arrière < 50 m.",
          "Verglas : éviter accélération et freinage brusques.",
          "Nuit : feux de croisement dès la tombée du jour ; feux de route SI personne devant ni en face ; passage à croisement à 150 m d'un véhicule.",
        ],
        erreurs: [
          "Laisser les feux antibrouillard arrière une fois le brouillard dissipé — éblouit le suivant.",
          "Oublier de baisser les feux à l'approche d'un véhicule en face.",
        ],
        geste: "Premières gouttes = route la plus glissante (huile remontée). Double ta distance. Face à un éblouissement, regarde à droite (bord de route), pas la source.",
        mnemo: '"BAS À 150 m + 2-3-4" : Feux → croisement à 150 m d\'un véhicule croisé. Distance = 2 s sec, 3 s pluie, 4 s nuit/brouillard.',
        checklist: [
          "Sous pluie, mes essuie-glaces sont réglés à la bonne vitesse.",
          "Mes feux de croisement sont allumés sous pluie/brouillard/neige et dès la tombée du jour.",
          "Je respecte +50 % de distance de sécurité minimum sous pluie.",
          "Sous brouillard, ma vitesse est adaptée à MA visibilité (pas au panneau).",
          "Je coupe mes antibrouillard arrière dès que le brouillard se lève.",
          "Je passe des feux de route aux feux de croisement à 150 m d'un véhicule croisé.",
          "Face à un éblouissement, je regarde à droite (bord droit de la route), pas la source.",
        ],
        attention: [
          "Les 10 premières minutes de pluie = les plus dangereuses (huile + poussière remontées).",
          "Micro-sommeil = 3 secondes yeux fermés à 130 km/h = 110 m parcourus. Un semi-remorque de plus.",
          "Verglas : sur voiture ABS, appui ferme et continu. Sans ABS : par à-coups doux.",
          "Un piéton en noir sur bord de route est INVISIBLE à 30 m en feux de croisement.",
        ],
      },
      {
        i: 8,
        letter: 'i',
        titre: "Conduire à l'abord et dans la traversée d'ouvrages routiers tels que les tunnels, les ponts, les passages à niveau",
        objectif: 'Traverser en sécurité tunnels, ponts et passages à niveau, avec les réflexes spécifiques à chacun.',
        // ── Trame REMC officielle (fidèle au livret C3i) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre l'intérêt à savoir se comporter à l'abord et lors de la traversée d'ouvrages routiers tels que tunnels, ponts, passages à niveau.",
            qr: [
              {
                q: "Avantages à connaître les précautions avant d'entrer et pour circuler dans un tunnel ?",
                r: "Éviter la panique en cas d'incident, savoir appliquer la procédure d'urgence, protéger sa vie et celle des autres."
              },
              {
                q: "Inconvénients à ne pas connaître les précautions au franchissement d'un passage à niveau ?",
                r: "Risque d'être surpris par le train, mauvaise gestion des barrières à demi-baissées, accident mortel."
              },
              {
                q: "Inconvénients à ne pas tenir compte des conditions météo lors de la traversée d'un pont ?",
                r: "Vent latéral, verglas, gel prématuré du tablier — perte de contrôle."
              },
              {
                q: "Repères de distance dans un tunnel routier ?",
                r: "Cadrer sur les luminaires plafonniers ou les niches SOS — respecter 2 s minimum."
              },
              {
                q: "Que peut engendrer un éblouissement en sortie de tunnel ?",
                r: "Perte visuelle temporaire (adaptation rétinienne), collision avec l'usager précédent, sortie de trajectoire."
              }
            ]
          },
          comment: {
            a_traiter: "Comportement à l'abord et franchissement de tunnel, distances de sécurité, procédures d'urgence (panne, accident, incendie). Signalisation et comportement aux passages à niveau. Réglementation et comportement sur un pont.",
            questions_ouvertes: [
              "Manœuvres interdites dans un tunnel ? (Demi-tour, marche arrière, arrêt hors zone SOS.)",
              "Manœuvres interdites à un passage à niveau ? (S'arrêter sur les voies, forcer une barrière.)",
              "Manœuvres interdites sur un pont ? (Dépassement selon signalisation, stationnement sauf urgence.)",
              "Pourquoi laisser les clés sur le contact avant d'évacuer un véhicule en tunnel ? (Permettre aux secours de le déplacer.)",
              "Pourquoi la vitesse est-elle limitée sur les grands ponts ? (Vent latéral, oscillation de tablier, effet ressort.)"
            ],
            info_plus: {
              titre: "Info + · Passages à niveau (2020)",
              items: [
                "19 accidents impliquant un train en France en 2020.",
                "À vitesse égale, la distance d'arrêt d'un train est 10 fois supérieure à celle d'une voiture.",
                "La majorité des accidents aux passages à niveau concerne des trajets HABITUELS et touche les personnes résidant à PROXIMITÉ.",
                "Comportements en cause : excès de vitesse, passage en chicane, baisse de vigilance liée à l'habitude, impatience."
              ],
              conclusion: "Ces ouvrages sont des zones où l'habitude tue plus que l'ignorance."
            },
            savoir: [
              "Quelle est la procédure d'urgence en cas de panne, d'accident ou d'incendie dans un tunnel ?",
              "Quels indices doivent conforter le conducteur à appliquer la procédure d'urgence sans attendre ?"
            ],
            savoir_faire: [
              "Traverser un tunnel en respectant l'allumage des feux et les distances de sécurité.",
              "Franchir un passage à niveau (avec ou sans barrières) selon la procédure adaptée.",
              "Adapter la trajectoire et l'allure sur un pont selon les conditions météo."
            ]
          },
          risques: {
            intro: "Beaucoup d'usagers, noyés dans leurs habitudes de conduite, oublient que certains lieux imposent un comportement moins routinier — c'est particulièrement vrai des tunnels (allumage des feux, distances, procédure d'urgence méconnue) et des passages à niveau.",
            directives: [
              "En tunnel, en cas de crise, la panique et l'anarchie peuvent régner — gênant et retardant l'intervention des secours.",
              "Aux passages à niveau, on suppose souvent que le « bon sens » suffit. En réalité 19 accidents avec train ont eu lieu en 2020.",
              "Scénarios types : excès de vitesse (véhicule qui ne peut freiner à temps), passage en chicane, baisse de vigilance par habitude, impatience."
            ],
            risques_listes: "Qu'est-ce qui peut pousser un usager à franchir un passage à niveau dont les barrières sont abaissées ? Quels indices doivent conforter l'application immédiate de la procédure d'urgence dans un tunnel ? Étude de cas : vous êtes en tunnel, un message d'alerte s'affiche mais personne autour de vous ne réagit — que faites-vous ?"
          },
          influences: {
            intro: "Le lieu de résidence, les habitudes de conduite des proches et leur rapport au risque influencent fortement le comportement aux passages à niveau et dans les tunnels. Les statistiques montrent que la majorité des accidents aux PN concernent les trajets habituels des personnes résidant à proximité.",
            questions: [
              "Dans votre entourage, comment se comporte-t-on à un passage à niveau ? (Marque-t-on l'arrêt, ralentit-on, passe-t-on rapidement ?)",
              "En tunnel, votre entourage allume-t-il systématiquement les feux ? Respecte-t-il les distances ?",
              "Le bon comportement en tunnel est-il transmis par exemplarité ou par crainte de la sanction ?"
            ]
          },
          pressions: {
            intro: "À cause des nombreux canulars télévisuels, les gens doutent de la véracité d'un fait. Ils ont besoin de preuves pour accepter l'état d'urgence d'une situation — ou d'un leader persuasif qui ne leur laisse pas le temps de réfléchir. Lors d'une crise, le doute et le manque de sang-froid peuvent faire perdre des instants précieux — parfois la vie.",
            question_situations: "Étude de cas :",
            situations: [
              "Vous êtes avec un ami à un passage à niveau. Les barrières commencent à descendre. Il vous dit : « Passe, je l'ai déjà fait — le train n'arrive que quand les barrières sont totalement baissées. » Que faites-vous ? Que dites-vous ?",
              "Dans un tunnel, un panneau lumineux affiche « ALERTE — RALENTIR ». Personne ne ralentit. Vous ?",
              "Comment gérer la pression sociale qui minimise le risque à un passage à niveau ou dans un tunnel ?"
            ]
          }
        },
        points: [
          "Tunnel : feux de croisement allumés, distance de sécurité doublée, radio sur fréquence tunnel.",
          "Pont : sensibilité au vent latéral, verglas plus fréquent (surface exposée), pas d'arrêt sauf urgence.",
          "Passage à niveau : jamais s'engager si la barrière commence à descendre. Si bloqué sur les rails : sortir immédiatement, alerter par téléphone d'urgence.",
          "En cas de panne dans un tunnel : gilet, se garer sur la voie de secours si possible, cheminer vers la sortie de secours à pied.",
        ],
        erreurs: ["S'engager sur un passage à niveau alors que le feu clignote — jamais."],
        geste: "En tunnel : allume les feux de croisement AVANT d'entrer. En passage à niveau : ralentis, regarde 2 fois même si le feu est vert.",
        mnemo: '"TUNNEL = FEUX + DISTANCE" · "PONT = VENT" · "PN = STOP AU MOINDRE DOUTE".',
        checklist: [
          "Avant un tunnel, j'allume mes feux de croisement.",
          "En tunnel, je double ma distance de sécurité.",
          "Sur un pont, je tiens fermement le volant contre le vent latéral.",
          "Je ne m'engage JAMAIS sur un passage à niveau si la barrière descend.",
          "Si mon véhicule cale sur des rails : je sors immédiatement et j'appelle le numéro d'urgence de la borne.",
          "En cas de panne en tunnel : je gagne la sortie de secours à pied, gilet enfilé.",
        ],
        attention: [
          "Un train ne peut pas s'arrêter en moins de 800 m. S'engager au dernier moment = mortel.",
          "Un pont peut être verglacé alors que la route juste avant ne l'est pas.",
          "Tunnel en panne = risque incendie / fumée : ne fais PAS demi-tour, gagne la sortie de secours la plus proche.",
        ],
      },
    ],
  },
  {
    code: 'C4',
    title: 'Pratiquer',
    subtitle: 'une conduite autonome, sûre et économique',
    color: 'red',
    intro: "Ton permis approche. C4 t'apprend à conduire SEUL, en gérant l'imprévu, la fatigue, les aides à la conduite, l'écologie, les premiers secours.",
    duree: '5 à 15 h selon AAC ou traditionnel',
    pre_requis: 'C1, C2, C3 toutes acquises.',
    lecons: [
      {
        i: 0,
        letter: 'a',
        titre: 'Suivre un itinéraire de manière autonome',
        objectif: 'Lire la signalisation directionnelle, gérer un GPS sans s\'y perdre.',
        // ── Trame REMC (C4a) — Contenu officiel REMC ──
        remc: {
          pourquoi: {
            intro: "Comprendre l'intérêt de savoir conduire de façon autonome, en privilégiant la sécurité et l'éco-conduite. Rouler de façon autonome permet d'être libre de ses choix, de son rythme, de ses décisions et de son itinéraire. Mais cela implique aussi d'être seul face à ses choix : hésitation, indécision, mauvais conseils ou capacités de conduite insuffisantes peuvent créer des risques. Avant de prendre le volant, il faut réaliser une auto-évaluation rapide de son état physique et mental : fatigue, stress, maladie, prise de médicaments, trajet long ou difficile, météo, circulation.",
            avantages: [
          "Liberté de ses choix, de son rythme, de ses décisions et de son itinéraire.",
          "Confiance renforcée par une évaluation lucide de ses capacités avant chaque trajet.",
          "Adaptation de sa conduite aux situations réelles rencontrées.",
          "Meilleure sécurité pour l'élève et pour les autres usagers."
        ],
            inconvenients: [
          "Confondre « connaître un itinéraire » et « maîtriser toutes les situations de conduite ».",
          "Relâchement d'attention sur un trajet habituel → surpris par l'imprévu.",
          "La routine devient un facteur de risque : une grande partie des accidents a lieu près du domicile.",
          "Prise de risque inconsciente pour soi et pour les autres."
        ],
          },
          comment: {
            a_traiter: "Faire une rapide évaluation de ses capacités avant de conduire · Vérifier rapidement le véhicule · Pratiquer l'éco-conduite · Adapter sa conduite aux situations · Suivre un itinéraire de manière autonome et lire la signalisation directionnelle.",
            savoir: [
          "Quels sont les différents types de panneaux de direction ?",
          "Que signifient leurs couleurs ?",
          "Quelle est la différence entre un panneau de présignalisation de direction et un panneau de signalisation de position de direction ?"
        ],
            savoir_faire: [
          "En circulation, suivre un itinéraire et donner la signification des différents panneaux de direction.",
          "Réaliser une auto-évaluation rapide (état physique + mental) AVANT de démarrer.",
          "Préparer l'itinéraire AVANT de démarrer si trajet long.",
          "GPS = aide, jamais chef. Signalisation routière prime sur GPS.",
          "En cas d'erreur : ne pas faire demi-tour brusque, prendre la prochaine intersection sûre."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « suivre un itinéraire de manière autonome » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "Demi-tour sur autoroute parce qu'on a raté la sortie.",
          "Un demi-tour sur autoroute = perte de permis + amende + danger mortel.",
          "Le GPS ne connaît PAS les travaux du jour ni le sens interdit provisoire.",
          "Ne cherche jamais l'adresse sur ton téléphone en roulant — arrête-toi 30 s sur un parking."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Préparer l'itinéraire AVANT de démarrer si trajet long.",
          "GPS = aide, jamais chef. Signalisation routière prime sur GPS.",
          "En cas d'erreur : ne pas faire demi-tour brusque, prendre la prochaine intersection sûre.",
        ],
        erreurs: ["Demi-tour sur autoroute parce qu'on a raté la sortie."],
        geste: 'Si le GPS dit « tournez à gauche » mais le panneau dit « sens interdit » : suis le panneau.',
        mnemo: '"PANNEAU > GPS" : Le panneau prime, toujours. Le GPS peut être en retard sur les travaux.',
        checklist: [
          "Je prépare mon itinéraire AVANT de démarrer sur trajet long.",
          "Le GPS est fixé et audible sans le regarder.",
          "En cas d'erreur, je prends la prochaine sortie légale — pas de demi-tour brusque.",
          "Je lis les panneaux directionnels 200 m avant la sortie.",
          "Je suis TOUJOURS le panneau si contradiction avec le GPS.",
        ],
        attention: [
          "Un demi-tour sur autoroute = perte de permis + amende + danger mortel.",
          "Le GPS ne connaît PAS les travaux du jour ni le sens interdit provisoire.",
          "Ne cherche jamais l'adresse sur ton téléphone en roulant — arrête-toi 30 s sur un parking.",
        ],
      },
      {
        i: 1,
        letter: 'b',
        titre: 'Préparer et effectuer un voyage longue distance en autonomie',
        objectif: 'Gérer durée, fatigue, météo, carburant, pauses.',
        // ── Trame REMC (C4b) — Contenu officiel REMC ──
        remc: {
          pourquoi: {
            intro: "Comprendre l'intérêt de préparer et d'organiser un voyage longue distance. Préparer un voyage longue distance permet de ne rien oublier, de partir plus confiant, de réduire le stress, de voyager plus agréablement et d'améliorer le confort des passagers. Avant un long trajet : auto-évaluation des facultés physiques + contrôle du véhicule (niveaux, pression, feux, GPS, triangle et gilet) + préparation de l'itinéraire avec centres d'intérêt et pauses.",
            avantages: [
          "Partir plus confiant, réduire le stress et voyager plus agréablement.",
          "Améliorer le confort des passagers.",
          "Anticiper les imprévus (pneu percé, panne, météo, trafic).",
          "Respecter les temps de pause → conducteur vigilant, arrivée sereine."
        ],
            inconvenients: [
          "Un voyage mal préparé peut vite tourner à la catastrophe.",
          "Pneu percé à 500 km du domicile + roue de secours vide = problème majeur.",
          "Succession d'imprévus → stress, énervement, prise de risque.",
          "Horaire trop contraignant → pression à respecter au détriment de la sécurité."
        ],
          },
          comment: {
            a_traiter: "Évaluer ses capacités de conduite · Vérifier le véhicule (niveaux, plein, pneus, feux, essuie-glaces, GPS, triangle, gilet) · Préparer l'itinéraire · Prendre en compte passagers et bagages · Tenir compte de la saison, du trafic et du chargement · Prévoir les pauses · S'adapter aux situations. Points importants : hydratation, lampe de poche, habillement adapté, ne pas fixer une heure d'arrivée trop stricte, respecter les temps de pause.",
            savoir: [
          "Pourquoi est-il important de préparer l'itinéraire avant un voyage longue distance ?",
          "Pourquoi faut-il prévoir des pauses si l'on fait un long parcours ?",
          "Quelles précautions prendre au niveau du véhicule et du conducteur avant un voyage longue distance ?"
        ],
            savoir_faire: [
          "Procéder aux vérifications : niveaux, propreté, feux, signalisation, vitres et rétroviseurs, état et pression des pneus.",
          "Effectuer de manière autonome l'itinéraire établi préalablement.",
          "Lire et interpréter la signalisation.",
          "Respecter les temps de pause (toutes les 2 h ou 200 km).",
          "Bagages, papiers, gilet, triangle, trousse de premiers secours, carte grise et assurance à bord."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « préparer et effectuer un voyage longue distance en autonomie » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "« Encore 30 km, je tiens » : la fatigue tue plus que l'alcool sur autoroute.",
          "La fatigue tue plus que l'alcool sur autoroute (source ONISR).",
          "Café + 15 min sieste = +1 h de vigilance. Bien plus efficace que 2 cafés d'affilée.",
          "Ne dépasse jamais 500 km / jour sans conducteur alternant."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Pause obligatoire toutes les 2 h ou 200 km — micro-sommeil = mort.",
          "Bagages, document, gilet, triangle, trousse premiers secours, carte grise et assurance à bord.",
          "Météo et trafic vérifiés avant départ.",
        ],
        erreurs: ["« Encore 30 km, je tiens » : la fatigue tue plus que l'alcool sur autoroute."],
        geste: 'Un café + 15 min sieste yeux fermés au parking = +1 h de vigilance gagnée.',
        mnemo: '"200/2/20" : 200 km ou 2 h = pause de 20 min. Règle vitale contre le micro-sommeil.',
        checklist: [
          "Je fais une pause toutes les 2 h ou 200 km, SANS exception.",
          "Gilet, triangle, trousse, papiers, assurance : tous à bord et accessibles.",
          "Météo et trafic vérifiés avant départ.",
          "Réservoir plein pour le premier tronçon.",
          "Nuit précédente : minimum 7 h de sommeil.",
        ],
        attention: [
          "La fatigue tue plus que l'alcool sur autoroute (source ONISR).",
          "Café + 15 min sieste = +1 h de vigilance. Bien plus efficace que 2 cafés d'affilée.",
          "Ne dépasse jamais 500 km / jour sans conducteur alternant.",
        ],
      },
      {
        i: 2,
        letter: 'c',
        titre: 'Connaître les principaux facteurs de risque au volant et les recommandations à appliquer',
        objectif: 'Identifier alcool, drogue, médicaments, fatigue, vitesse et distraction comme causes principales d\'accidents, et connaître les gestes qui sauvent.',
        // ── Trame REMC (C4c) — Contenu officiel REMC ──
        remc: {
          pourquoi: {
            intro: "Comprendre l'intérêt de savoir reconnaître les principaux facteurs de risque au volant afin de pouvoir les éviter. Les facteurs d'accident peuvent être liés aux caractéristiques du conducteur (genre, âge). Les hommes et les femmes ne sont pas égaux face au risque routier : la prise de risque est généralement plus associée au comportement masculin, notamment chez les jeunes adultes. La tranche 18-24 ans est la plus touchée. Attention aux biais psychologiques : autocomplaisance (« je suis meilleur conducteur »), optimisme comparatif (« l'accident, c'est pour les autres »), justification par causes externes.",
            avantages: [
          "Identifier ses propres biais psychologiques pour ne plus être aveuglé par eux.",
          "Distinguer le besoin (nécessité réelle) de l'envie (construite par la société, la pub, la culture).",
          "Anticiper les principaux facteurs de risque : fatigue, vitesse, inattention, alcool, stupéfiants, priorités, médicaments, stress.",
          "Adopter les recommandations officielles pour chaque facteur."
        ],
            inconvenients: [
          "Réduction de la perception du risque = comportement dangereux.",
          "Confusion besoin / envie → envie d'aller vite, de gagner du temps, de se valoriser.",
          "Non-respect des règles élémentaires (alcool, drogue, médicaments niveau 3).",
          "Prise de risque augmentée chez les jeunes conducteurs (18-24 ans)."
        ],
          },
          comment: {
            a_traiter: "Identifier les facteurs d'accident liés au conducteur (genre, âge, biais psychologiques). Reconnaître les principaux risques : fatigue, vitesse excessive ou inadaptée, inattention, alcool, stupéfiants, non-respect des priorités, médicaments, stress, besoin d'aller vite, envie de prendre des risques. Distinguer besoin et envie.",
            savoir: [
          "Quels sont les effets de la fatigue sur le conducteur ?",
          "Que faire pour limiter les effets de la fatigue ?",
          "Comment mesure-t-on le taux d'alcool ?",
          "Quels sont les effets des produits psychoactifs sur le conducteur ?",
          "Comment s'organiser pour faire la fête ?",
          "Quelle est la tranche d'âge la plus touchée par les accidents de la route ?",
          "Comment lutter contre la fatigue ?"
        ],
            savoir_faire: [
          "Alcool : 0,5 g/L (0,2 g/L jeune conducteur) — 1 verre standard suffit à dépasser pour un jeune.",
          "Drogue : tolérance ZÉRO en France.",
          "Médicaments : lire le pictogramme (niveaux 1, 2 ou 3) avant de conduire.",
          "Vitesse : cause principale d'accidents mortels — chaque 10 km/h en plus multiplie le risque.",
          "Distraction : téléphone en main = interdit ; 2 s d'inattention à 90 km/h = 50 m parcourus.",
          "Fatigue : micro-sommeil = 3 s yeux fermés = mort possible.",
          "Si tu as bu, drogué, ou pris un médicament niveau 3 : tu NE prends PAS le volant. Point."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « connaître les principaux facteurs de risque au volant et les recommandations à appliquer » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "« Je peux conduire, j'ai bu qu'un verre » — faux, surtout pour un jeune conducteur.",
          "Regarder une notification en roulant — 2 secondes de perte d'attention suffisent.",
          "0,5 g/L = ~2 verres standards, dépassement + amende + retrait de 6 points.",
          "Jeune conducteur (permis probatoire) : 0,2 g/L max = 1 seul verre suffit à dépasser.",
          "Téléphone en main au volant : 135 € + 3 points. Suspension possible en cas d'accident.",
          "Alcool + fatigue = risque multiplié par 15 (source ONISR)."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Alcool : 0,5 g/L (0,2 g/L jeune conducteur) — 1 verre standard suffit à dépasser pour un jeune.",
          "Drogue : tolérance ZÉRO en France.",
          "Médicaments : lire le pictogramme (niveaux 1, 2 ou 3) avant de conduire.",
          "Vitesse : cause principale d'accidents mortels — chaque 10 km/h en plus multiplie le risque.",
          "Distraction : téléphone en main = interdit ; 2 s d'inattention à 90 km/h = 50 m parcourus.",
          "Fatigue : micro-sommeil = 3 s yeux fermés = mort possible.",
        ],
        erreurs: [
          "« Je peux conduire, j'ai bu qu'un verre » — faux, surtout pour un jeune conducteur.",
          "Regarder une notification en roulant — 2 secondes de perte d'attention suffisent.",
        ],
        geste: "Si tu as bu, drogué, ou pris un médicament niveau 3 : tu NE prends PAS le volant. Point.",
        mnemo: '"AVD-FVD" : Alcool, Vitesse, Distraction, Fatigue, Véhicule (mauvais état), Drogue. Les 6 tueurs sur la route.',
        checklist: [
          "Je ne conduis JAMAIS avec la moindre alcoolémie (surtout jeune conducteur : 0,2 g/L).",
          "Je ne conduis jamais après consommation de drogue (tolérance zéro).",
          "Je lis le pictogramme des médicaments avant de conduire.",
          "Je respecte scrupuleusement les vitesses limites.",
          "Je ne touche JAMAIS mon téléphone en roulant (sauf bluetooth mains libres).",
          "Je fais une pause dès que je sens la fatigue.",
        ],
        attention: [
          "0,5 g/L = ~2 verres standards, dépassement + amende + retrait de 6 points.",
          "Jeune conducteur (permis probatoire) : 0,2 g/L max = 1 seul verre suffit à dépasser.",
          "Téléphone en main au volant : 135 € + 3 points. Suspension possible en cas d'accident.",
          "Alcool + fatigue = risque multiplié par 15 (source ONISR).",
        ],
      },
      {
        i: 3,
        letter: 'd',
        titre: "Connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir",
        objectif: 'Réagir efficacement à un accident, appliquer les gestes qui sauvent en attendant les secours.',
        // ── Trame REMC (C4d) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre pourquoi la compétence « Connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir » est essentielle pour un futur conducteur : Réagir efficacement à un accident, appliquer les gestes qui sauvent en attendant les secours.",
            avantages: [
          "Meilleure sécurité pour l'élève et pour les autres usagers.",
          "Réflexes plus fluides et moins de charge mentale au volant.",
          "Confiance en soi renforcée dans les situations réelles.",
          "Économie (usure, carburant, sinistres évités) sur le long terme."
        ],
            inconvenients: [
          "Erreurs répétées difficiles à corriger une fois installées.",
          "Perte de contrôle en situation d'urgence ou de stress.",
          "Prise de risques inconsciente pour soi et pour les autres.",
          "Coût matériel et humain d'un incident évitable."
        ],
          },
          comment: {
            a_traiter: "Connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir",
            savoir: [
          "Quelles sont les règles et notions clés liées à « connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir » ?",
          "Quelles sont les conséquences concrètes d'un mauvais geste ou d'une mauvaise décision ?",
          "Comment reconnaître qu'une manœuvre est réussie vs à corriger ?"
        ],
            savoir_faire: [
          "PROTÉGER : feux de détresse, triangle 30 m (150 m sur autoroute), écarter les témoins du danger.",
          "ALERTER : 112 (Europe), localiser précisément (route, sens, PK, borne).",
          "SECOURIR : Position Latérale de Sécurité (PLS) si inconscient et respire ; massage cardiaque si inconscient et ne respire pas.",
          "Hémorragie : compression manuelle ferme + appel + maintien jusqu'à arrivée secours.",
          "Si tu n'es pas formé PSC1 : protège la zone, appelle 112, RESTE auprès, n'improvise pas."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "Bouger un blessé inconscient sans nécessité — risque aggravation.",
          "Donner à boire à un blessé — risque fausse route.",
          "Un blessé inconscient bougé sans nécessité = risque de section médullaire (paralysie).",
          "Ne coupe JAMAIS le moteur d'un véhicule accidenté sans savoir (risque incendie ou airbag).",
          "Ne retire jamais un casque de motard sauf urgence vitale absolue.",
          "Formation PSC1 : ~60 €, 7 h, valide à vie. C'est le meilleur investissement de ta vie."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "PROTÉGER : feux de détresse, triangle 30 m (150 m sur autoroute), écarter les témoins du danger.",
          "ALERTER : 112 (Europe), localiser précisément (route, sens, PK, borne).",
          "SECOURIR : Position Latérale de Sécurité (PLS) si inconscient et respire ; massage cardiaque si inconscient et ne respire pas.",
          "Hémorragie : compression manuelle ferme + appel + maintien jusqu'à arrivée secours.",
        ],
        erreurs: [
          "Bouger un blessé inconscient sans nécessité — risque aggravation.",
          "Donner à boire à un blessé — risque fausse route.",
        ],
        geste: "Si tu n'es pas formé PSC1 : protège la zone, appelle 112, RESTE auprès, n'improvise pas.",
        mnemo: '"PAS" : Protéger – Alerter – Secourir. Dans cet ordre. JAMAIS l\'inverse.',
        checklist: [
          "Je mets mes feux de détresse et gilet AVANT de m'approcher.",
          "Je pose le triangle 30 m en amont (150 m sur autoroute).",
          "J'appelle 112 avec localisation précise.",
          "Je ne déplace pas un blessé sauf danger imminent (incendie).",
          "Je sais mettre en PLS un inconscient qui respire.",
          "Je sais faire un massage cardiaque (30 comp / 2 insuf).",
          "Je serai formé PSC1 dans les 12 mois (~60 €, 7 h).",
        ],
        attention: [
          "Un blessé inconscient bougé sans nécessité = risque de section médullaire (paralysie).",
          "Ne coupe JAMAIS le moteur d'un véhicule accidenté sans savoir (risque incendie ou airbag).",
          "Ne retire jamais un casque de motard sauf urgence vitale absolue.",
          "Formation PSC1 : ~60 €, 7 h, valide à vie. C'est le meilleur investissement de ta vie.",
        ],
      },
      {
        i: 4,
        letter: 'e',
        titre: "Faire l'expérience des aides à la conduite du véhicule (régulateur, limiteur de vitesse, ABS, aides à la navigation…)",
        objectif: "Comprendre le rôle, les limites et la bonne utilisation des principales aides à la conduite embarquées.",
        // ── Trame REMC (C4e) — Contenu officiel REMC ──
        remc: {
          pourquoi: {
            intro: "Comprendre l'intérêt de savoir utiliser les aides à la conduite, mais aussi connaître les risques liés à leur utilisation. Distinguer sécurité active (dispositifs qui agissent AVANT l'accident pour éviter le choc : ABS, ESP, freinage automatique, AFIL…) et sécurité passive (dispositifs qui agissent PENDANT ou APRÈS le choc pour réduire ses conséquences : airbag, ceinture, structure déformable). Les aides peuvent procurer un faux sentiment de confiance.",
            avantages: [
          "Sécurité active (ABS, ESP, AEB) et sécurité passive (airbag, ceinture) réduisent le risque et les conséquences.",
          "Aides à la fatigue : régulateur, limiteur, alerte de franchissement de ligne.",
          "Aides à la navigation : GPS, reconnaissance des panneaux, éclairage directionnel.",
          "Aides au stationnement : radar de recul, caméra, détecteur d'angle mort."
        ],
            inconvenients: [
          "Sentiment de confiance = prise de risque et inattention accrues.",
          "Décharge d'automatismes → difficultés au changement de véhicule.",
          "Mauvaise utilisation ou méconnaissance des aides = risque créé.",
          "Défaillance possible (rare) : la vigilance humaine reste indispensable."
        ],
          },
          comment: {
            a_traiter: "Identifier les principales aides : airbag, capteur de pluie, éthylotest antidémarrage, éclairage directionnel, système d'avertissement du conducteur, détection de collision, ESP, assistant de changement de voie, aide au stationnement, GPS, freinage automatique à faible vitesse, reconnaissance des panneaux, aide au démarrage en côte, contrôle de vitesse en descente, radar de recul, limiteur, régulateur, détecteur d'angle mort. Distinguer sécurité active et passive.",
            savoir: [
          "Quelle est la différence entre le régulateur de vitesse et le limiteur de vitesse ?",
          "Quel est le rôle de l'ABS ?",
          "Quel est l'intérêt d'utiliser un GPS ?",
          "Quelles sont les limites du GPS ?"
        ],
            savoir_faire: [
          "Faire l'expérience d'un freinage avec déclenchement de l'ABS dans une zone protégée.",
          "Utiliser le régulateur et le limiteur de vitesse en conditions adaptées.",
          "Préparer un parcours avec GPS AVANT le départ.",
          "Régulateur = maintient la vitesse choisie ; à couper en circulation dense, en descente, sous pluie forte.",
          "Limiteur = bloque la vitesse maxi (utile en zone 30, 50, sur autoroute).",
          "ABS = appui FERME et CONTINU au freinage d'urgence (jamais par à-coups)."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « faire l'expérience des aides à la conduite du véhicule (régulateur, limiteur de vitesse, abs, aides à la navigation…) » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "S'endormir en confiance sur le régulateur en trajet long — la fatigue reste ton adversaire.",
          "Freiner à petits coups avec ABS — casse l'effet ABS. Appuie franchement et maintiens.",
          "Régulateur allumé + inattention = accident quasi-inévitable en cas de bouchon soudain.",
          "L'AEB (freinage automatique) peut se déclencher tardivement : ne pas compter dessus.",
          "ESP off + verglas = risque de tête-à-queue. Laisse toujours l'ESP activé.",
          "GPS mal fixé = distraction majeure = amende + risque d'accident."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Régulateur de vitesse : maintient la vitesse choisie ; à couper en circulation dense, en descente, sous pluie forte.",
          "Limiteur de vitesse : bloque la vitesse maxi (utile en zone 30, 50, sur autoroute).",
          "ABS : anti-blocage des roues au freinage d'urgence — appui FERME et CONTINU (jamais par à-coups).",
          "ESP : anti-patinage / anti-dérapage — corrige les pertes de trajectoire, ne remplace pas l'anticipation.",
          "AEB : freinage d'urgence automatique — dernière chance, ne pas s'en servir comme béquille.",
          "GPS / aide à la navigation : outil, jamais chef — signalisation prime.",
        ],
        erreurs: [
          "S'endormir en confiance sur le régulateur en trajet long — la fatigue reste ton adversaire.",
          "Freiner à petits coups avec ABS — casse l'effet ABS. Appuie franchement et maintiens.",
        ],
        geste: "Régulateur : à couper AU MOINDRE trafic dense, pluie forte ou descente. Limiteur : à mettre en zone 30/50 pour éviter les excès involontaires.",
        mnemo: '"AIDE, PAS PILOTE" : Chaque aide à la conduite reste UN OUTIL. C\'est TOI le pilote. Anticipe TOI-MÊME.',
        checklist: [
          "Je sais activer et désactiver le régulateur de vitesse.",
          "Je coupe le régulateur en circulation dense, en descente, sous pluie forte.",
          "J'utilise le limiteur en zone 30 / 50 pour éviter les excès involontaires.",
          "En freinage d'urgence avec ABS, j'appuie FERME et CONTINU.",
          "Je connais les limites de l'ESP (adhérence limitée, ne remplace pas l'anticipation).",
          "Je paramètre mon GPS AVANT de démarrer, pas en roulant.",
        ],
        attention: [
          "Régulateur allumé + inattention = accident quasi-inévitable en cas de bouchon soudain.",
          "L'AEB (freinage automatique) peut se déclencher tardivement : ne pas compter dessus.",
          "ESP off + verglas = risque de tête-à-queue. Laisse toujours l'ESP activé.",
          "GPS mal fixé = distraction majeure = amende + risque d'accident.",
        ],
      },
      {
        i: 5,
        letter: 'f',
        titre: "Avoir des notions sur l'entretien, le dépannage et les situations d'urgence",
        objectif: "Connaître l'entretien courant, réagir à une panne, une crevaison, un refus de priorité.",
        // ── Trame REMC (C4f) ──
        remc: {
          pourquoi: {
            intro: "Aidez votre élève à comprendre pourquoi la compétence « Avoir des notions sur l'entretien, le dépannage et les situations d'urgence » est essentielle pour un futur conducteur : Connaître l'entretien courant, réagir à une panne, une crevaison, un refus de priorité.",
            avantages: [
          "Meilleure sécurité pour l'élève et pour les autres usagers.",
          "Réflexes plus fluides et moins de charge mentale au volant.",
          "Confiance en soi renforcée dans les situations réelles.",
          "Économie (usure, carburant, sinistres évités) sur le long terme."
        ],
            inconvenients: [
          "Erreurs répétées difficiles à corriger une fois installées.",
          "Perte de contrôle en situation d'urgence ou de stress.",
          "Prise de risques inconsciente pour soi et pour les autres.",
          "Coût matériel et humain d'un incident évitable."
        ],
          },
          comment: {
            a_traiter: "Avoir des notions sur l'entretien, le dépannage et les situations d'urgence",
            savoir: [
          "Quelles sont les règles et notions clés liées à « avoir des notions sur l'entretien, le dépannage et les situations d'urgence » ?",
          "Quelles sont les conséquences concrètes d'un mauvais geste ou d'une mauvaise décision ?",
          "Comment reconnaître qu'une manœuvre est réussie vs à corriger ?"
        ],
            savoir_faire: [
          "Entretien : niveaux (huile, liquide de refroidissement, lave-glace), pression pneus mensuelle, contrôle technique tous les 2 ans après 4 ans.",
          "Panne : sortir gilet AVANT de descendre + triangle 30 m derrière + appel dépanneur.",
          "Crevaison : ne pas freiner brusquement, maintenir le cap, ralentir progressivement, s'arrêter à l'écart.",
          "Refus de priorité : NE PAS forcer ton droit — laisse passer pour ta sécurité.",
          "Bande d'arrêt d'urgence : véhicule rangé au maximum à droite, feux de détresse, sortir CÔTÉ TALUS."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « avoir des notions sur l'entretien, le dépannage et les situations d'urgence » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "Sortir du véhicule sans gilet sur une autoroute.",
          "Sortir sur autoroute sans gilet = amende ET danger mortel.",
          "Crevaison à vitesse : garder les 2 mains fermes au volant, décélérer progressivement.",
          "Refus de priorité : ton « droit » ne vaut rien si tu es à l'hôpital. Laisse toujours passer.",
          "Un pneu à -0,5 bar sur 4 = risque doublé de crevaison + surconsommation."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Entretien : niveaux (huile, liquide de refroidissement, lave-glace), pression pneus mensuelle, contrôle technique tous les 2 ans après 4 ans.",
          "Panne : sortir gilet AVANT de descendre + triangle 30 m derrière + appel dépanneur.",
          "Crevaison : ne pas freiner brusquement, maintenir le cap, ralentir progressivement, s'arrêter à l'écart.",
          "Refus de priorité : NE PAS forcer ton droit — laisse passer pour ta sécurité.",
        ],
        erreurs: ["Sortir du véhicule sans gilet sur une autoroute."],
        geste: "Bande d'arrêt d'urgence : véhicule rangé au maximum à droite, feux de détresse, sortir CÔTÉ TALUS.",
        mnemo: '"PAT" : Protection (gilet+triangle), Alerte (112 ou borne), Trajectoire (bande d\'arrêt d\'urgence).',
        checklist: [
          "Je vérifie les niveaux tous les mois (huile, refroidissement, lave-glace).",
          "Je vérifie la pression des pneus tous les mois.",
          "Je connais la date de mon prochain contrôle technique.",
          "En panne : gilet AVANT de descendre + triangle 30 m derrière.",
          "En crevaison : je ne freine pas brusquement, je maintiens le cap.",
          "Face à un refus de priorité, je laisse passer plutôt que de forcer.",
          "Sur autoroute, je sors du véhicule CÔTÉ TALUS, jamais côté chaussée.",
        ],
        attention: [
          "Sortir sur autoroute sans gilet = amende ET danger mortel.",
          "Crevaison à vitesse : garder les 2 mains fermes au volant, décélérer progressivement.",
          "Refus de priorité : ton « droit » ne vaut rien si tu es à l'hôpital. Laisse toujours passer.",
          "Un pneu à -0,5 bar sur 4 = risque doublé de crevaison + surconsommation.",
        ],
      },
      {
        i: 6,
        letter: 'g',
        titre: "Pratiquer l'éco-conduite",
        objectif: 'Réduire consommation, bruit et émissions par une conduite fluide et anticipée.',
        // ── Trame REMC (C4g) — Contenu officiel REMC ──
        remc: {
          pourquoi: {
            intro: "Comprendre l'intérêt de conduire de façon économique et écologique. L'éco-conduite permet de réduire la consommation, limiter les émissions polluantes, diminuer l'usure du véhicule et adopter une conduite plus souple. Ce n'est PAS une conduite lente : c'est une conduite efficace, anticipée et organisée. L'éco-conduite intègre aussi l'intermodalité (trottinette + bus, marche + bus, etc.) et le choix du mode de déplacement.",
            avantages: [
          "Réduire la consommation et les émissions polluantes.",
          "Diminuer l'usure du véhicule (freins, embrayage, pneus).",
          "Adopter une conduite plus souple → passagers plus confortables.",
          "Économies concrètes en euros et gains environnementaux mesurables."
        ],
            inconvenients: [
          "Mauvaises pratiques justifiées à tort par l'économie (ex : couper le moteur en descente = interdit et dangereux).",
          "Confusion éco-conduite = conduite lente (faux).",
          "Négliger la pression des pneus = surconsommation invisible.",
          "Sous-régime ou sur-régime = surconsommation et usure du moteur."
        ],
          },
          comment: {
            a_traiter: "Utiliser les bons rapports de vitesse · Adopter une conduite souple · Anticiper · Augmenter les distances de sécurité · Éviter les accélérations et freinages inutiles · Couper le moteur lors d'arrêts prolongés · Utiliser la climatisation avec modération · Décharger le véhicule · Vérifier la pression des pneus · Entretenir correctement le véhicule · Utiliser certaines aides à la conduite · Choisir un véhicule électrique ou économique lorsque possible. Aides utiles : régulateur, limiteur, indicateur de changement de vitesse, Start & Stop, contrôle de pression des pneus.",
            savoir: [
          "Quels sont les effets des émissions polluantes ?",
          "Quels sont les avantages de l'éco-conduite ?",
          "Quels sont les principes de l'éco-conduite ?"
        ],
            savoir_faire: [
          "Mettre en œuvre les grands principes de la conduite économique et écologique.",
          "Accélérer progressivement, sans à-coup.",
          "Passer le rapport supérieur dès 2 000 - 2 500 tr/min.",
          "Anticiper pour relâcher plutôt que freiner.",
          "Vérifier la pression des pneus tous les mois.",
          "À l'arrêt > 30 s : couper le moteur. Utiliser la clim avec modération.",
          "Envisager l'intermodalité : trottinette + bus, marche + bus, trottinette + voiture."
        ],
          },
          risques: {
            intro: "Puisez dans les ressources de votre élève. Partez d'une situation vécue pour faire ressortir un problème lié à cette compétence. Démontrez qu'un accident est une suite d'événements non anodins, liés à de mauvais choix de comportements.",
            questions: [
          "Quels sont les risques concrets si un conducteur néglige « pratiquer l'éco-conduite » ?",
          "Ces risques sont-ils identiques pour un conducteur qui reconnaît sa faiblesse vs un conducteur qui l'ignore ? Expliquez."
        ],
            situations: [
          "Accélérer sur 100 m pour freiner derrière le feu rouge.",
          "Utiliser la clim sur autoroute augmente la conso de ~5 %. Sur route, préfère les vitres.",
          "Un coffre de toit vide augmente la conso de 10-15 %. Retire-le hors usage.",
          "Rouler à 110 au lieu de 130 sur autoroute = -25 % de consommation."
        ],
          },
          influences: {
            intro: "Amenez votre élève à réfléchir sur la fréquence et la façon dont son entourage se comporte face à cette compétence. La mise en évidence de leur intérêt et de leur investissement personnel apporte des explications sur la vision et le comportement de l'élève.",
            questions: [
          "Comment les personnes qui conduisent autour de toi (parents, amis, collègues) abordent-elles cette compétence ?",
          "As-tu déjà été passager avec un conducteur qui la maîtrisait mal ? Qu'as-tu ressenti ?",
          "Ton mode de vie (horaires, trajets, pressions extérieures) t'incite-t-il à bâcler cette compétence ?",
          "Ton entourage valorise-t-il la prudence ou plutôt la performance / la rapidité ?"
        ],
          },
          pressions: {
            intro: "Aidez votre élève à lister les pressions qui peuvent parasiter cette compétence. Cela lui donnera l'habitude d'identifier les pressions qui influencent son comportement.",
            situations: [
          "Lorsque l'on est en retard ou pressé (rendez-vous, examen, travail).",
          "Sous pression hiérarchique ou familiale (livrer, aller chercher quelqu'un vite).",
          "Face à un groupe de passagers qui distrait ou pousse à la faute.",
          "Face à la publicité automobile qui valorise la vitesse et la performance."
        ],
          },
        },
        points: [
          "Accélération : progressive, sans à-coup.",
          "Rétrograder tard, passer le rapport supérieur dès 2 000 - 2 500 tr/min.",
          "Anticiper pour relâcher au lieu de freiner.",
          "Pression pneus = -0,5 bar = +5 % de conso. Vérifie tous les mois.",
          "À l'arrêt > 30 s = couper le moteur.",
        ],
        erreurs: ['Accélérer sur 100 m pour freiner derrière le feu rouge.'],
        geste: 'Lève le pied 200 m avant le feu rouge prévu : tu y arriveras en roulant.',
        mnemo: '"-20 %" : Éco-conduite bien pratiquée = -20 % consommation. Économies, environnement, sérénité.',
        checklist: [
          "J'accélère progressivement, sans à-coup.",
          "Je passe le rapport supérieur dès 2 000 - 2 500 tr/min.",
          "Je vérifie la pression des pneus tous les mois.",
          "À l'arrêt > 30 s (feu rouge long, passage à niveau), je coupe le moteur.",
          "J'anticipe les ralentissements pour relâcher au lieu de freiner.",
        ],
        attention: [
          "Utiliser la clim sur autoroute augmente la conso de ~5 %. Sur route, préfère les vitres.",
          "Un coffre de toit vide augmente la conso de 10-15 %. Retire-le hors usage.",
          "Rouler à 110 au lieu de 130 sur autoroute = -25 % de consommation.",
        ],
      },
    ],
  },
];

export const TOTAL_LECONS = COURS_VOITURE_ELEVE.reduce((acc, c) => acc + c.lecons.length, 0);
